const BUILDING_INSPECTION = {
  // help text shown in the info "i" next to inspection fields
  tooltips: {
    info: {
      buildingCategory:
        'Wählen Sie die Hauptkategorie des Gebäudes, zum Beispiel Büro, Schule oder Lager. Das Feld dient dazu, die richtigen Standardwerte und Profile in der Berechnung auszuwählen.',
      yearOfConstruction:
        'Geben Sie das Baujahr des Gebäudes an oder das Jahr der letzten wesentlichen Umbaumaßnahme, falls dieses repräsentativer ist. Wird unter anderem zur Einschätzung des voraussichtlichen technischen Standards verwendet.',
      numberOfFloors:
        'Geben Sie die Gesamtanzahl der oberirdischen Geschosse des Gebäudes an. Das Feld dient als Grundlage für Geometrie, Volumen und die weitere Einteilung in Zonen.',
    },
    thermalZones: {
      zoneCategory:
        'Eine thermische Zone ist ein Teil des Gebäudes, der in der Berechnung als eine Einheit behandelt wird, typischerweise mit ähnlicher Nutzung und ähnlichem Innenklima. Geben Sie der Zone einen eindeutigen Namen und wählen Sie eine Zonenkategorie. Die Kategorie legt die Standardprofile für Nutzungszeiten, interne Lasten und technische Annahmen fest.',
      buildingSubcategory:
        'Wählen Sie eine Unterkategorie, wenn Sie eine genauere Klassifizierung der Zone wünschen. Lassen Sie das Feld leer, wenn die normale Zonenkategorie ausreicht.',
      zoneClimate:
        'Gibt an, ob die Zone beheizt, teilweise beheizt oder unbeheizt ist. Der Klimastatus bestimmt, wie die Zone in den Heiz- und Kühlbedarf eingeht, und ist eine grundlegende Voraussetzung für die Energieberechnung.',
      bra: 'BRA ist die Nutzfläche der Zone, also die Bodenfläche innerhalb der Außenwände, die als beheizte Fläche zählt. Geben Sie die BRA in m² an. Die Fläche ist eine der wichtigsten Eingaben und beeinflusst nahezu alle Berechnungen direkt.',
      floors:
        'Geben Sie an, über wie viele Geschosse sich die Zone erstreckt, wenn sie nicht auf eine Ebene beschränkt ist. Wenn die Zone nur auf einer Ebene liegt, kann das Feld oft leer bleiben.',
      floorHeight:
        'Geben Sie die durchschnittliche Geschosshöhe in Metern für die Zone an. Wird zusammen mit der Fläche zur Berechnung von Volumen und Luftmengen verwendet.',
      indoorTemp:
        'Die Temperatur der Zone zu Beginn der Simulation. Dies ist kein Sollwert: Die Sollwerte für Heizung und Kühlung werden im Heizungsplan und im Kühlungsplan festgelegt.',
      tekStandard:
        'TEK bezeichnet die norwegischen Bauvorschriften, zum Beispiel TEK10 und TEK17, die unter anderem Anforderungen an U-Werte und Dichtheit stellen. Wählen Sie den relevanten TEK-Standard, wenn Sie die Standardwerte präziser steuern möchten als es das Baujahr allein erlaubt.',
      airLeakageN50:
        'Die Luftwechselrate (n50) beschreibt, wie luftdicht das Gebäude ist, gemessen als Luftwechsel pro Stunde bei 50 Pa Druckdifferenz. Geben Sie den Wert an, wenn er aus einer Druckprüfung oder Dokumentation bekannt ist. Wenn das Feld leer ist, werden repräsentative Standardwerte verwendet.',
      thermalBridgeCoeff:
        'Eine Wärmebrücke ist eine Stelle in der Konstruktion mit erhöhtem Wärmeverlust, typischerweise dort, wo Decken und Wände auf die Außenkonstruktion treffen. Wählen Sie das Tragwerk oder die Wärmebrückenkategorie, wenn Sie die Wärmebrücken präziser modellieren möchten. Wird normalerweise nur verwendet, wenn Sie über gute bauphysikalische Informationen verfügen.',
      thermalBridgePsiValue:
        'Der normalisierte Wärmebrückenwert (ψ) drückt den gesamten zusätzlichen Wärmeverlust durch Wärmebrücken pro m² Bodenfläche aus. Geben Sie den Wert an, wenn er aus einer Berechnung bekannt ist. Kann bei einer Standardaufnahme normalerweise leer bleiben.',
      heatingEmissionSystem:
        'Das Wärmeabgabesystem ist die Art, wie die Wärme an den Raum abgegeben wird, zum Beispiel Heizkörper, Konvektor oder Fußbodenheizung. Die Wahl beeinflusst die erforderliche Vorlauftemperatur und Regelung. Nützlich für die Detaillierung, aber bei der ersten Erfassung in der Regel nicht erforderlich.',
      coolingEmissionSystem:
        'Das Kälteabgabesystem ist die Art, wie die Kühlung an den Raum abgegeben wird, zum Beispiel Kühlbalken, Ventilatorkonvektor oder Kühldecke. Die Wahl beeinflusst das Temperaturniveau und die Regelung. Nützlich für die Detaillierung, aber bei der ersten Erfassung in der Regel nicht erforderlich.',
      zoneConnections:
        'Eine Zonenverbindung beschreibt eine Fläche, an der zwei Zonen, oder eine Zone und eine Klimabedingung, Wärme austauschen, zum Beispiel eine Innenwand zu einer kälteren Zone. Verwenden Sie dies, wenn ein solcher Wärmeaustausch für das Modell wichtig ist. Normalerweise nur bei einer detaillierteren Einrichtung relevant.',
      connectionArea:
        'Geben Sie die Fläche in m² der Fläche an, die die Zonen verbindet. Zusammen mit dem U-Wert bestimmt sie, wie viel Wärme ausgetauscht wird. Wird nur ausgefüllt, wenn Sie tatsächlich eine Zonenverbindung modellieren.',
      connectionUValue:
        'Der U-Wert beschreibt, wie gut die Fläche zwischen den Zonen dämmt (W/m²K). Geben Sie ihn an, falls verfügbar. Andernfalls kann die Verbindung in der Regel vereinfacht oder weggelassen werden.',
      heatingSchedule:
        'Ein Heizplan beschreibt, wie Sollwert und Betrieb über den Tag und die Woche variieren, zum Beispiel Nachtabsenkung. Verwenden Sie ihn, wenn die Zone einen abweichenden Betrieb hat. Ergibt eine realistischere Simulation als feste Standardprofile.',
      hasFloorToGround:
        'Aktivieren Sie dies, wenn die Zone einen Boden gegen Erdreich hat. Beim Deaktivieren wird das Element ausgeblendet und die gespeicherte Fläche aus der Energieberechnung entfernt.',
      hasRoof:
        'Aktivieren Sie dies, wenn die Zone ein Dach gegen Außenluft hat. Beim Deaktivieren wird das Element ausgeblendet und die gespeicherte Fläche aus der Energieberechnung entfernt.',
      isBasement:
        'Aktivieren Sie dies, wenn die Zone ein Keller unter Gelände ist. Der Wärmeverlust an das Erdreich wird dann aus dem Element Kellerkonstruktion berechnet, und Dach, Boden gegen Erdreich, Außenwände, Fenster und Türen dieser Zone bleiben in der Energieberechnung unberücksichtigt.',
      basement: {
        area: 'Geben Sie die Bodenfläche des Kellers gegen Erdreich in m² ein. Sie wird für die Berechnung des Wärmeverlusts an das Erdreich benötigt und entspricht normalerweise der BRA der Kellerzone.',
        wallPerimeter:
          'Geben Sie die Länge der erdberührten Kellerwand in Metern ein. Zusammen mit der Fläche ergibt sie die charakteristische Abmessung des Bodens. Bleibt das Feld leer, wird eine quadratische Grundfläche angenommen.',
        fillHeight:
          'Geben Sie die mittlere Tiefe vom Gelände bis zum Kellerboden in Metern ein. Sie bestimmt, wie viel der Wand Wärme an das Erdreich abgibt. 0 bedeutet Bodenplatte auf Erdreich.',
        wallThickness:
          'Geben Sie die Gesamtstärke der Kellerwand auf Geländehöhe in Metern ein, einschließlich Dämmung. Bleibt das Feld leer, werden 0,3 m verwendet.',
        wallConstructionType:
          'Wählen Sie die Konstruktion der Kellerwand unter Gelände oder eine TEK Periode, um deren Anforderung zu verwenden. Die Wahl schlägt den U-Wert vor.',
        wallUValue:
          'Der U-Wert der Kellerwandkonstruktion unter Gelände (W/m²K). Geben Sie ihn ein, wenn er aus Unterlagen bekannt ist, sonst wird der vorgeschlagene Wert verwendet.',
        floorConstructionType:
          'Wählen Sie die Konstruktion des Kellerbodens gegen Erdreich oder eine TEK Periode, um deren Anforderung zu verwenden. Die Wahl schlägt den U-Wert vor.',
        floorUValue:
          'Der U-Wert der Kellerbodenkonstruktion gegen Erdreich (W/m²K). Geben Sie ihn ein, wenn er aus Unterlagen bekannt ist, sonst wird der vorgeschlagene Wert verwendet.',
      },
      floor: {
        type: 'Der Typ des Bodens gegen Erdreich beschreibt, wie der Boden zum Erdreich oder zu einem unbeheizten Raum aufgebaut ist, zum Beispiel Bodenplatte auf Erdreich oder Boden über einem Keller. Wählen Sie den, der die Konstruktion am besten beschreibt. Die Wahl dient dazu, relevante Standardwerte vorzuschlagen, unter anderem den U-Wert.',
        area: 'Geben Sie die Fläche des Bodens gegen Erdreich in m² für den zu erfassenden Teil der Zone an. Die Fläche wird benötigt, um den Wärmeverlust durch den Boden zu berechnen.',
        uValue:
          'Der U-Wert gibt an, wie viel Wärme pro m² und Grad Temperaturdifferenz durch die Konstruktion entweicht (W/m²K). Ein niedrigerer Wert bedeutet bessere Dämmung. Geben Sie ihn an, wenn Sie ihn aus Dokumentation oder Berechnung kennen, andernfalls werden Nennwerte anhand des gewählten Typs und Jahres verwendet.',
      },
      structuralNodes: {
        boundary:
          'Ein Strukturknoten ist eine Stelle, an der Bauteile zusammentreffen, zum Beispiel zwischen Decke und Außenwand, und ist typischerweise eine Wärmebrücke mit zusätzlichem Wärmeverlust. Verwenden Sie Strukturknoten, wenn Sie solche Details erfassen möchten. Normalerweise nur bei einem höheren Detaillierungsgrad relevant.',
        length:
          'Geben Sie die Länge des betreffenden Knotens oder der Wärmebrücke in Metern an. Nur auszufüllen, wenn strukturelle Knoten verwendet werden.',
        height:
          'Geben Sie die Höhe des betreffenden Knotens in Metern an, falls relevant. Wird zusammen mit den übrigen Maßen für eine detaillierte Geometriebeschreibung verwendet.',
        width:
          'Geben Sie die Breite des betreffenden Knotens in Metern an, falls relevant. Das Feld wird nur für die detaillierte Erfassung struktureller Knoten verwendet.',
      },
      roof: {
        angle:
          'Die Dachneigung ist die Neigung der Dachfläche in Grad, wobei 0 ein Flachdach bedeutet. Sie wird für die Begehung erfasst, die Energieberechnung verwendet sie aber noch nicht: Der Wärmeverlust über das Dach ergibt sich aus Fläche und U-Wert, und Dachfenster erhalten in der Berechnung keine Sonneneinstrahlung.',
        type: 'Die Dachkonstruktion beschreibt, wie das Dach aufgebaut ist, zum Beispiel Kompaktdach, belüftetes Schrägdach oder Dachstühle. Wählen Sie die, die das Dach am besten beschreibt. Die Wahl bildet die Grundlage für den Standard-U-Wert und weitere Annahmen.',
        area: 'Geben Sie die zur Zone gehörende Dachfläche in m² an. Die Fläche wird benötigt, um die Transmission durch das Dach zu berechnen.',
        uValue:
          'Der U-Wert gibt an, wie viel Wärme pro m² und Grad Temperaturdifferenz durch die Dachkonstruktion entweicht (W/m²K). Ein niedrigerer Wert bedeutet bessere Dämmung. Geben Sie ihn an, wenn er bekannt ist, andernfalls wird ein Nennwert anhand der gewählten Konstruktion und des Alters verwendet.',
        glassType:
          'Aktivieren Sie dies, wenn das Dach Fenster oder Oberlichter hat, und wählen Sie den Glastyp. Der Glastyp, zum Beispiel Zwei- oder Dreifachverglasung, bestimmt sowohl den Wärmeverlust als auch, wie viel Sonnenenergie durch die Dachfläche eindringt.',
        windowArea:
          'Geben Sie die gesamte Fenster- oder Oberlichtfläche in m² an. Das Feld ist nur relevant, wenn das Dach tatsächlich Fenster oder Oberlichter hat.',
        windowUValue:
          'Der U-Wert der Dachfenster gibt den Wärmeverlust durch das Glas und den Rahmen selbst an (W/m²K). Ein niedrigerer Wert bedeutet bessere Dämmung. Geben Sie ihn an, wenn er bekannt ist, andernfalls reichen Standardwerte oft aus.',
        gValue:
          'Der g-Wert (Gesamtenergiedurchlassgrad) beschreibt den Anteil der Sonnenenergie, der durch das Glas dringt, von 0 bis 1. Ein hoher g-Wert liefert im Winter mehr kostenlose Solarwärme, aber im Sommer auch einen höheren Kühlbedarf.',
        externalBlindsGt:
          'Außenjalousien sitzen auf der Außenseite des Glases und reduzieren die Sonneneinstrahlung wirksam. Der Sonnenfaktor (gt) beschreibt, wie viel Sonnenenergie durchgelassen wird, wenn die Verschattung aktiv ist. Erfassen Sie dies, wenn eine solche Verschattung eine deutliche Wirkung hat.',
        externalScreenGt:
          'Ein Außenscreen ist eine außen liegende textile Verschattung, die die Sonneneinstrahlung dämpft. Der Sonnenfaktor (gt) gibt an, wie viel Sonnenenergie bei heruntergelassenem Tuch durchgelassen wird. Nur ausfüllen, wenn die Lösung im Gebäude vorhanden ist.',
        internalShadingGt:
          'Eine innen liegende Verschattung, zum Beispiel Jalousien oder Vorhänge auf der Innenseite, dämpft die Sonne, aber weniger wirksam als eine außen liegende Verschattung. Der Sonnenfaktor (gt) beschreibt den verbleibenden Solareintrag. Wird verwendet, um die Berechnung der Solargewinne zu verbessern.',
      },
      groundConditions: {
        type: 'Die Bodenverhältnisse beschreiben die Massen unter dem Gebäude, zum Beispiel Lehm, Sand oder Fels, die den Wärmeverlust zum Erdreich beeinflussen. Verwenden Sie dies, wenn Sie spezifische Informationen über den Baugrund haben. Dies ist typischerweise ein Detailfeld.',
        thermalConductivity:
          'Die Wärmeleitfähigkeit (λ) gibt an, wie gut der Baugrund Wärme leitet, in W/mK. Ein höherer Wert führt zu einem größeren Wärmeverlust zum Erdreich. Geben Sie einen dokumentierten Wert an, falls vorhanden, andernfalls kann das Feld leer bleiben.',
        heatCapacity:
          'Die Wärmekapazität beschreibt, wie viel Wärme der Baugrund speichern kann, und dämpft Schwankungen des Wärmeverlusts über die Zeit. Geben Sie sie an, wenn sie bekannt ist. Kann bei einer üblichen Energieaufnahme normalerweise leer bleiben.',
        penetrationDepth:
          'Die periodische Eindringtiefe ist die Tiefe im Erdreich, die von jahreszeitlichen Temperaturschwankungen beeinflusst wird. Sie wird in detaillierteren Baugrundmodellen verwendet. Das Feld ist bei einer Standarderfassung normalerweise nicht erforderlich.',
      },
      internalLoads: {
        lighting:
          'Beleuchtung ist ein interner Wärmeeintrag: Die von den Lichtquellen genutzte Energie wird größtenteils zu Wärme in der Zone. Erfassen Sie das Beleuchtungsniveau und etwaige Betriebsprofile. Dies beeinflusst sowohl den Stromverbrauch als auch den Kühlbedarf.',
        equipment:
          'Technische Geräte wie Computer, Bildschirme und andere fest installierte Geräte geben zusätzlich zum Stromverbrauch Wärme an den Raum ab und sind daher ein interner Wärmeeintrag. Erfassen Sie die typische Leistung und das Betriebsprofil für die Zone.',
        occupancy:
          'Personen geben Wärme und Feuchtigkeit ab und beeinflussen gleichzeitig den Lüftungsbedarf. Erfassen Sie die Personenbelegung über Anzahl und Profile oder eine Standardkonfiguration, die die normale Nutzung der Zone beschreibt.',
        dishwasher:
          'Aktivieren Sie Geschirrspüler, wenn er eine relevante Last in der Zone ist. Der Warmwasseranteil gibt an, wie viel des Verbrauchs durch erwärmtes Leitungswasser gedeckt wird, statt dass das Gerät es selbst erwärmt. Normalerweise nur verwendet, wenn Haushaltsgeräte erheblich sind.',
        washingMachine:
          'Aktivieren Sie Waschmaschine, wenn sie eine relevante Last in der Zone ist. Der Warmwasseranteil gibt an, wie viel des Wassers die Maschine aus dem Warmwassersystem bezieht, statt es selbst zu erwärmen.',
        tumbleDryer:
          'Aktivieren Sie Wäschetrockner, wenn er eine relevante Last in der Zone ist. Ein etwaiger Warmwasseranteil beschreibt, wie viel des Energiebedarfs über warmes Leitungswasser statt über direkten Strom gedeckt wird.',
      },
      thermalMass: {
        heatCapacityCategory:
          'Die thermische Masse ist die Fähigkeit des Gebäudes, Wärme zu speichern, was Temperaturschwankungen dämpft und den Heiz- und Kühlbedarf zeitlich verschiebt. Wählen Sie eine Wärmekapazitätskategorie, zum Beispiel leichte oder schwere Konstruktion, wenn Sie dies über die Standardwerte hinaus anpassen möchten.',
        normalizedHeatCapacity:
          'Die normalisierte Wärmekapazität drückt aus, wie viel Wärme die Zone pro m² Bodenfläche speichern kann (Wh/m²K). Geben Sie einen genaueren Wert an, falls vorhanden, andernfalls kann das Feld leer bleiben und die Kategorie wird verwendet.',
        cladding:
          'Die innere Bekleidung, zum Beispiel Gipskarton, Holz oder Sichtbeton, beeinflusst, wie viel der thermischen Masse tatsächlich zum Raum hin wirksam ist. Wählen Sie den Typ, wenn Sie eine detailliertere Beschreibung wünschen.',
        heatCapacity:
          'Geben Sie die Wärmekapazität der Innenwände an, falls bekannt. Dies beschreibt, wie viel Wärme die inneren Konstruktionen speichern können, und wird nur für eine detailliertere Modellierung der thermischen Masse verwendet.',
        furnitureGrade:
          'Möbel und Einrichtung tragen ebenfalls zur thermischen Masse bei. Wählen Sie einen Möblierungsgrad, der beschreibt, wie möbliert die Zone ist, falls dies relevant ist. Das Feld ist normalerweise ein Detailfeld.',
        massFactor:
          'Der Massefaktor passt an, wie viel Möbel und Einrichtung zur thermischen Masse der Zone beitragen. Geben Sie einen Wert an, wenn Sie den Standardwert überschreiben möchten.',
      },
      exteriorWall: {
        direction:
          'Die Ausrichtung bestimmt, wie viel Sonne die Fassade erhält und wie Wind und Außenklima den Wärmeverlust beeinflussen. Wählen Sie die Richtung, zum Beispiel Norden, Süden, Osten oder Westen, für die zu erfassende Wand.',
        type: 'Der Wandtyp beschreibt, wie die Außenwand aufgebaut ist, zum Beispiel Holzständerwerk, Mauerwerk oder Beton mit Dämmung. Wählen Sie den, der die Wand am besten beschreibt. Die Wahl dient dazu, relevante Standardwerte vorzuschlagen.',
        area: 'Geben Sie die Bruttofläche der Außenwand in m² an, einschließlich Fenster, Türen und Tore. Die Berechnung zieht die an der Wand erfassten Öffnungen selbst ab; eine Nettofläche würde den Wärmeverlust über die Wand zu niedrig ansetzen.',
        uValue:
          'Der U-Wert gibt an, wie viel Wärme pro m² und Grad Temperaturdifferenz durch die Wand entweicht (W/m²K). Ein niedrigerer Wert bedeutet bessere Dämmung. Geben Sie ihn an, wenn er bekannt ist, andernfalls werden Nennwerte anhand des Wandtyps und des Alters verwendet.',
        windowShadingFactor:
          'Der Anteil des direkten Sonnenlichts, den das Fenster durch Verschattung von Vorsprüngen, Nachbargebäuden oder Gelände verliert, von 0 bis 1. 0 bedeutet keine Verschattung, 1 vollständig verschattet. Nur die direkte Sonne wird reduziert, nicht die diffuse Strahlung. Die Jalousien und Screens unten werden erfasst, aber in der Berechnung nicht verwendet.',
      },
      heatingCooling: {
        name: 'Geben Sie dem Gerät einen eindeutigen Namen, mit dem sich Komponenten leicht unterscheiden lassen. Der Name dient in erster Linie der Identifikation im Projekt.',
        type: 'Der Typ beschreibt, um welche Art von Heiz- oder Kühleinheit es sich handelt, zum Beispiel Heizkörper, Fußbodenheizung, Wärmepumpe oder Kühlbalken. Die Wahl steuert, welche Felder relevant sind und wie das System modelliert wird.',
        energySource:
          'Die Energiequelle ist das, was die Einheit zur Erzeugung von Wärme oder Kälte nutzt, zum Beispiel Strom, Fernwärme oder eine Wärmepumpe. Wählen Sie die Quelle, wenn die Komponente direkt mit einer bestimmten Quelle verbunden ist, andernfalls kann die Energieversorgung zentral beschrieben werden.',
        co2eEmissionFactor:
          'Der CO₂e-Emissionsfaktor gibt an, wie viel Treibhausgasemission mit der von der Einheit genutzten Energie verbunden ist, angegeben pro kWh. Geben Sie einen bestimmten Wert an, wenn Sie Emissionen genau berechnen möchten. Er wirkt sich nicht auf den Energiebedarf selbst aus.',
        quantity:
          'Geben Sie die Anzahl identischer Einheiten an, wenn mehrere identische Einheiten installiert sind. Kann leer bleiben, wenn die Leistung gesamt angegeben wird.',
        power:
          'Die Nennleistung ist die maximale Heiz- oder Kühlleistung der Einheit in kW. Sie wird verwendet, um zu beurteilen, ob das System die Kapazität hat, den Bedarf zu decken, und wie mehrere Systeme priorisiert werden. Geben Sie die Gesamtleistung an, wenn mehrere identische Einheiten zusammengefasst werden.',
        systemEfficiency:
          'Der Systemwirkungsgrad beschreibt, wie viel der zugeführten Energie tatsächlich zu nutzbarer Wärme oder Kälte wird, einschließlich Verluste in Verteilung und Regelung. Geben Sie eine bessere Zahl als den Standard an, wenn Sie eine haben. Bei der ersten Erfassung oft nicht erforderlich.',
        priority:
          'Die Priorität steuert die Reihenfolge, in der die Systeme genutzt werden, wenn mehrere denselben Bedarf decken. Eine niedrigere Priorität bedeutet, dass das System zuerst genutzt wird und der Rest die Spitzenlast deckt. Legen Sie dies fest, wenn die Zone mehrere Heiz- oder Kühlquellen hat.',
        cop: 'Der COP (Coefficient of Performance) ist der Wirkungsgrad der Wärmepumpe für die Heizung: das Verhältnis von gelieferter Wärme zu zugeführtem Strom. Ein COP von 3 bedeutet dreimal so viel Wärme wie Strom. Geben Sie einen bestimmten Wert an, wenn Sie einen haben.',
        eer: 'Der EER (Energy Efficiency Ratio) ist der Wirkungsgrad für die Kühlung: das Verhältnis von gelieferter Kälte zu zugeführtem Strom. Ein höherer Wert bedeutet effizientere Kühlung. Geben Sie einen bestimmten Wert an, wenn Sie einen haben.',
        nominalLoad:
          'Die Nennlast (0-1) beschreibt den Anteil der vollen Kapazität, auf den die Einheit für den Normalbetrieb ausgelegt ist. Dies ist ein Detailfeld und kann normalerweise auf dem Standardwert belassen werden.',
        minimumLoad:
          'Die Mindestlast (0-1) ist der niedrigste Anteil der vollen Kapazität, bei dem die Einheit stabil laufen kann, bevor sie ein- und ausschalten muss. Geben Sie einen Wert an, wenn Sie den Standard überschreiben möchten.',
        degradeCoeff:
          'Der Degradationskoeffizient (0-1) beschreibt, wie stark der Wirkungsgrad sinkt, wenn die Einheit bei Teillast statt voller Leistung läuft. Invertergeregelte Einheiten haben in der Regel geringere Verluste. Wird oft automatisch festgelegt.',
        maxTemperatureSupplied:
          'Die maximale Vorlauftemperatur ist die höchste Temperatur, die die Einheit an das Wärmeabgabesystem liefern kann. Sie bestimmt, ob die Einheit den Temperaturbedarf decken kann, zum Beispiel für Heizkörper, die eine hohe Vorlauftemperatur benötigen.',
      },
      domesticHotWater: {
        name: 'Geben Sie der Trinkwarmwasser-Komponente einen eindeutigen Namen, wenn Sie mehrere Einheiten oder Teilsysteme erfassen.',
        heaterType:
          'Der Erwärmungstyp beschreibt, wie das Trinkwarmwasser erwärmt wird, zum Beispiel ein direkter elektrischer Erhitzer, eine Wärmepumpe oder eine zentrale Versorgung wie Fernwärme. Die Wahl beeinflusst sowohl den Energiebedarf als auch die Emissionen für Warmwasser.',
        tapFrequency:
          'Die Zapfhäufigkeit beschreibt, wie oft und wie viel Warmwasser entnommen wird, und spiegelt das tatsächliche Nutzungsmuster der Zone wider. Sie ist ein wichtiger Treiber des berechneten Energiebedarfs für Warmwasser.',
        tapCyclesPerDay:
          'Die Anzahl der Zapfzyklen pro Tag ist, wie oft am Tag Warmwasser entnommen wird. Geben Sie einen Wert an, wenn Sie das Standardprofil durch eine genauere Zahl ersetzen möchten.',
        thermalZone:
          'Verknüpfen Sie das Trinkwarmwassersystem mit der thermischen Zone, die es versorgt. Dies platziert den Energieverbrauch und eine etwaige Wärmeabgabe korrekt im Modell.',
      },
      productionEquipment: {
        name: 'Geben Sie der Produktionsausrüstung einen eindeutigen Namen. Wird verwendet, um die Last im Projekt und in Berichten zu identifizieren.',
        energySource:
          'Die Energiequelle ist das, was die Produktionsausrüstung nutzt, zum Beispiel Strom oder Gas. Sie wird verwendet, um den Energieverbrauch dem richtigen Energieträger zuzuordnen und für eine eventuelle Emissionsberechnung.',
        power:
          'Die Nennleistung ist die typische Leistungsaufnahme des Geräts in kW. Zusammen mit dem Betriebsplan bildet sie die Grundlage für die Berechnung des Energieverbrauchs und der Wärmeabgabe an die Zone.',
        eligibleForHarvesting:
          'Energierückgewinnung bedeutet, überschüssige Wärme des Geräts für andere Zwecke zu nutzen, zum Beispiel zum Heizen. Aktivieren Sie dies, wenn das Gerät solche überschüssige Energie abgibt, damit das Rückgewinnungspotenzial bewertet wird.',
        operationalSchedule:
          'Der Betriebsplan beschreibt, wann das Gerät tatsächlich über den Tag und die Woche genutzt wird. Fügen Sie ihn hinzu, wenn das Gerät nicht den normalen Betriebszeiten folgt, für eine realistischere Berechnung des Energieverbrauchs und der internen Lasten.',
      },
      hvac: {
        name: 'Geben Sie dem Lüftungsgerät einen eindeutigen Namen. Der Name dient zur Identifikation, wenn das Gebäude mehrere Geräte hat.',
        linkedZones:
          'Verknüpfte Zonen sind die thermischen Zonen, die das Lüftungsgerät mit Luft versorgt. Die Wahl ist erforderlich, um Luftmengen, Ventilatorenergie und Wärmerückgewinnung korrekt zwischen den Zonen zu verteilen.',
        flowSfpSettings:
          'Hier geben Sie die Luftmengen und SFP-Annahmen des Geräts ein. Der SFP (spezifische Ventilatorleistung) drückt aus, wie viel elektrische Leistung die Ventilatoren pro Luftmenge benötigen, und ist eine Kerninformation für die Lüftungsberechnung.',
        motorType:
          'Der Motortyp, zum Beispiel AC oder EC, beeinflusst den Ventilatorwirkungsgrad und wie sich die Leistung bei Teillast ändert. Wählen Sie den Typ, falls bekannt, für eine genauere Berechnung.',
        sfp100:
          'Der SFP (spezifische Ventilatorleistung) ist das Verhältnis von Leistungsaufnahme der Ventilatoren zur Luftmenge, angegeben in kW pro m³/s. Ein niedrigerer SFP bedeutet einen energieeffizienteren Ventilator. Geben Sie den Wert bei 100 % Betrieb an, dies ist der Hauptparameter der Lüftungsberechnung.',
        sfp80:
          'Der SFP bei 80 % Betrieb beschreibt die spezifische Ventilatorleistung, wenn das Gerät mit reduzierter Luftmenge läuft. Geben Sie ihn an, wenn Sie Teillastdaten haben, andernfalls kann das Feld leer bleiben.',
        sfp60:
          'Der SFP bei 60 % Betrieb beschreibt die spezifische Ventilatorleistung bei geringerer Luftmenge. Wird nur für eine detailliertere Teillastmodellierung verwendet.',
        sfp40:
          'Der SFP bei 40 % Betrieb. Geben Sie ihn an, wenn Teillastdaten für eine so geringe Luftmenge verfügbar sind.',
        sfp20:
          'Der SFP bei 20 % Betrieb. Geben Sie ihn an, wenn Teillastdaten für eine so geringe Luftmenge verfügbar sind.',
        fanPowerIn:
          'Die Zuluftventilatorleistung ist die elektrische Leistungsaufnahme des Zuluftventilators in kW. Geben Sie sie an, wenn Sie sie separat haben. Kann normalerweise leer bleiben, wenn der SFP erfasst ist, da die Leistung dann daraus berechnet wird.',
        fanPowerOut:
          'Die Abluftventilatorleistung ist die elektrische Leistungsaufnahme des Abluftventilators in kW. Geben Sie sie an, wenn Sie sie separat haben. Wird nur für eine detailliertere Erfassung verwendet.',
        coverageArea:
          'Die Abdeckungsfläche ist die Bodenfläche, die das Gerät versorgt, in m². Geben Sie sie an, wenn das Gerät nur einen Teil des Gebäudes oder der Zone abdeckt. Kann oft aus den verbundenen Zonen abgeleitet werden.',
        coverageVolume:
          'Das Abdeckungsvolumen ist das Luftvolumen, das das Gerät versorgt, in m³. Geben Sie es an, falls bekannt. Wird als Detailfeld für die Lüftungsdimensionierung verwendet.',
        airVolumeOperating:
          'Der Zuluftvolumenstrom im Betrieb ist die Luftmenge, die das Gerät im Normalbetrieb liefert, in m³/h. Dies ist eine zentrale Eingabe für Lüftungsbedarf, Ventilatorenergie sowie Heiz- und Kühlregister.',
        airVolumeCapacity:
          'Die Zuluftkapazität ist die maximale Luftmenge, die das Gerät liefern kann, in m³/h. Geben Sie sie an, falls bekannt. Nützlich für Kapazitätsbewertungen, aber nicht immer erforderlich.',
        airVolumeNonOperating:
          'Der Zuluftvolumenstrom außerhalb des Betriebs ist die Luftmenge, die das Gerät liefert, wenn das Gebäude nicht genutzt wird, zum Beispiel bei reduziertem Nachtbetrieb. Geben Sie ihn an, wenn das Gerät einen Teil der Zeit mit reduziertem Luftvolumen läuft.',
        airVolumeExtractionOperating:
          'Der Abluftvolumenstrom im Betrieb ist die Luft, die das Gerät im Normalbetrieb aus den Zonen abführt, in m³/h. Zusammen mit dem Zuluftvolumenstrom beschreibt er die tatsächliche Luftbilanz des Geräts und beeinflusst Ventilatorenergie und Wärmerückgewinnung.',
        airVolumeExtractionCapacity:
          'Die Abluftkapazität ist die maximale Luftmenge, die das Gerät abführen kann, in m³/h. Geben Sie sie an, falls bekannt. Nützlich für Kapazitätsbewertungen, aber nicht immer erforderlich.',
        airVolumeExtractionNonOperating:
          'Der Abluftvolumenstrom außerhalb des Betriebs ist die Luft, die das Gerät abführt, wenn das Gebäude nicht genutzt wird, zum Beispiel bei Nachtabsenkung oder reduziertem Betrieb. Geben Sie ihn an, wenn das Gerät einen Teil der Zeit mit reduziertem Luftvolumen läuft.',
        supplyTemperature:
          'Die Zulufttemperatur ist die Temperatur der Luft, die das Gerät in die Zone einbläst, in °C. Die Sollwerte im Betriebsplan haben Vorrang: Dieser Wert wird nur für Stunden verwendet, in denen der Betriebsplan keinen Sollwert hat. Ändern Sie den Zuluftsollwert im Betriebsplan.',
        heatRecoveryType:
          'Die Wärmerückgewinnung nutzt die Wärme der Abluft, um die Zuluft vorzuwärmen, wodurch der Heizbedarf sinkt. Wählen Sie den installierten Typ, zum Beispiel Rotationswärmetauscher, Plattenwärmetauscher oder Kreislaufverbundsystem. Die Wahl ist wichtig für die Berechnung der zurückgewonnenen Energie.',
        efficiencyHR:
          'Der Wirkungsgrad gibt an, welchen Anteil der Wärme der Abluft die Rückgewinnungseinheit tatsächlich an die Zuluft überträgt, in Prozent. Ein höherer Wert bedeutet einen geringeren Heizbedarf. Geben Sie einen dokumentierten Wert an, falls vorhanden, andernfalls wird ein Standardwert anhand des gewählten Typs verwendet.',
        frostProtection:
          'Der Frostschutz verhindert, dass die Rückgewinnungseinheit bei niedrigen Außentemperaturen vereist, kann in solchen Zeiten aber verringern, wie viel Wärme zurückgewonnen wird. Aktivieren Sie dies, wenn das Gerät einen Frostschutz hat, der Betrieb oder Wärmerückgewinnung beeinflusst. Nützlich für eine genauere Modellierung.',
        frostProtectionTemperature:
          'Dies ist die Außentemperatur, bei der der Frostschutz aktiviert wird. Unterhalb dieser Temperatur wird die Rückgewinnung reduziert oder geregelt, um Vereisung zu vermeiden. Geben Sie den Wert an, falls bekannt, andernfalls wird ein Standardwert verwendet.',
        measuredSupplyTemp:
          'Die gemessene Zulufttemperatur ist die tatsächliche Temperatur der Luft, die das Gerät einbläst, erfasst bei einer Begehung oder Aufzeichnung. Geben Sie sie an, wenn Sie Feldmessungen haben. Wird zur Qualitätssicherung und zur genaueren Kalibrierung des Modells verwendet.',
        measuredExhaustTemp:
          'Die gemessene Ablufttemperatur ist die tatsächliche Temperatur der aus den Zonen abgeführten Luft, erfasst durch Feldmessung. Geben Sie sie an, wenn Sie solche Messungen haben. Zusammen mit der gemessenen Zulufttemperatur dient sie der Qualitätssicherung.',
        dx: {
          name: 'Ein DX-System (Direktverdampfung) ist ein Kühl- oder Wärmepumpenregister, bei dem das Kältemittel direkt im Luftstrom verdampft, ohne einen Wasserkreislauf dazwischen. Geben Sie der Einheit einen eindeutigen Namen zur Identifikation, wenn das Gerät eine solche integrierte DX-Einheit hat.',
          type: 'Der Typ gibt an, was die DX-Einheit kann: nur Kühlung, nur Heizung oder beides (Wärmepumpenfunktion). Die Wahl steuert, welche Leistungs- und Wirkungsgradfelder relevant sind.',
          heatingEffect:
            'Die Heizleistung ist die maximale Wärme, die die DX-Einheit an die Luft abgeben kann, in kW. Geben Sie sie an, wenn das System Wärme liefert. Kann leer bleiben, wenn die Einheit nur zur Kühlung verwendet wird.',
          coolingEffect:
            'Die Kühlleistung ist die maximale Kühlung, die die DX-Einheit an die Luft abgeben kann, in kW. Dies ist normalerweise der wichtigste Kapazitätswert für den Kühlbetrieb.',
          seasonalCop:
            'Der saisonale COP ist der durchschnittliche Wirkungsgrad der DX-Einheit für die Heizung über eine Saison: das Verhältnis von gelieferter Wärme zu zugeführtem Strom. Geben Sie ihn an, wenn die Einheit auch zum Heizen verwendet wird. Verwenden Sie einen Standardwert, wenn keine genaue Dokumentation vorliegt.',
          seasonalEer:
            'Der saisonale EER ist der durchschnittliche Wirkungsgrad der DX-Einheit für die Kühlung über eine Saison: das Verhältnis von gelieferter Kühlung zu zugeführtem Strom. Geben Sie ihn an, wenn er bekannt ist. Wird verwendet, um den Stromverbrauch für die Kühlung zu berechnen.',
          systemEfficiency:
            'Die Berechnung verwendet den Systemwirkungsgrad als Wirkungsgrad der DX-Einheit selbst, in Prozent: 300 % bedeutet dreimal so viel Wärme oder Kälte wie Strom. Die Felder für saisonalen COP/EER werden noch nicht verwendet, geben Sie COP oder EER daher hier in Prozent an. Bleibt das Feld leer, werden 100 % verwendet.',
          energySource:
            'Die Energiequelle ist das, was die DX-Einheit zur Erzeugung von Wärme oder Kälte nutzt, normalerweise Strom. Sie wird für die Energieverteilung und eine eventuelle Emissionsberechnung verwendet.',
        },
        heatingBattery: {
          name: 'Ein Heizregister in der Lüftung ist ein Wärmetauscher im Gerät, der die Zuluft erwärmt, typischerweise mit Warmwasser aus einem Kessel oder einer Wärmepumpe gespeist, oder elektrisch. Geben Sie dem Register einen eindeutigen Namen, wenn mehrere Register im selben Gerät oder Gebäude vorhanden sind.',
          type: 'Der Registertyp gibt an, wie die Wärme zugeführt wird, zum Beispiel wasserbasiert (Warmwasser durch das Register) oder elektrisch. Die Wahl beeinflusst die Energiequelle und den Wirkungsgrad.',
          power:
            'Die Leistung ist die maximale Wärme, die das Register der Zuluft zuführen kann, in kW. Wird für die Kapazitätsprüfung und Energieberechnung verwendet.',
          systemEfficiency:
            'Der Systemwirkungsgrad erfasst Verluste in Verteilung und Regelung bis zum Register. Geben Sie einen Wert an, wenn Sie eine bessere Zahl als den Standard haben, andernfalls kann das Feld leer bleiben.',
          energySource:
            'Die Energiequelle ist das, was das Heizregister mit Wärme versorgt, zum Beispiel Fernwärme, ein Kessel, eine Wärmepumpe oder Strom. Sie wird für die Energieverteilung und eine eventuelle Emissionsberechnung verwendet.',
        },
        coolingBattery: {
          name: 'Ein Kühlregister in der Lüftung ist ein Wärmetauscher im Gerät, der die Zuluft kühlt, typischerweise mit Kaltwasser aus einer Kältemaschine gespeist oder durch Direktverdampfung (DX). Geben Sie dem Register einen eindeutigen Namen, wenn mehrere Register vorhanden sind.',
          type: 'Der Typ gibt an, wie die Kühlung zugeführt wird, zum Beispiel wasserbasiert (Kaltwasser durch das Register) oder DX (Direktverdampfung). Die Wahl beeinflusst die Energiequelle und den Wirkungsgrad.',
          power:
            'Die Leistung ist die maximale Kühlung, die das Register der Zuluft zuführen kann, in kW. Wird für die Kapazitätsprüfung und Energieberechnung verwendet.',
          systemEfficiency:
            'Der Systemwirkungsgrad erfasst zusätzliche Verluste in Verteilung und Regelung über die Nennleistung hinaus. Geben Sie einen Wert an, wenn Sie solche Verluste einbeziehen möchten, andernfalls kann das Feld leer bleiben.',
          eer: 'Der EER (Energy Efficiency Ratio) ist der Wirkungsgrad des Kühlregisters: das Verhältnis von gelieferter Kühlung zu zugeführtem Strom. Geben Sie ihn an, wenn er bekannt ist. Wird verwendet, um den Stromverbrauch für die Kühlung zu berechnen.',
          energySource:
            'Die Energiequelle ist das, was das Kühlregister mit Kühlung versorgt, zum Beispiel eine Kältemaschine, Fernkälte oder DX. Sie wird für die Energieverteilung und eine eventuelle Emissionsberechnung verwendet.',
        },
        naturalVentilation:
          'Natürliche Lüftung ist Luftaustausch, der durch Wind und Temperaturunterschiede über Fenster, Lüftungsöffnungen oder Schächte erfolgt, ohne Ventilatoren. Aktivieren Sie dies, wenn die Zone oder das Gerät über eine natürliche Lüftung verfügt, die im Modell berücksichtigt werden soll.',
        operationalSchedule:
          'Ein Betriebsplan beschreibt, wann die Lüftung über den Tag und die Woche in Betrieb ist. Geben Sie einen Plan für die natürliche Lüftung oder den Gerätebetrieb an, wenn der Betrieb von den Standardbetriebszeiten abweicht.',
        operationalScheduleExtra:
          'Verwenden Sie einen zusätzlichen Plan, wenn dasselbe Gerät oder dieselbe Lüftungsfunktion mehrere Betriebsperioden mit unterschiedlichem Betrieb hat, zum Beispiel saisonal. Jeder Plan deckt einen eigenen Zeitraum ab.',
      },
      centralEnergy: {
        name: 'Ein zentrales Energiemodul ist eine gemeinsame Energiezentrale, die mehrere Zonen oder Funktionen versorgt, zum Beispiel eine Heizzentrale oder eine Kältemaschinenzentrale. Geben Sie ihr einen eindeutigen Namen. Der Name dient nur der Identifikation.',
        mode: 'Der Modus gibt an, ob die Zentrale Heizung, Kühlung, Warmwasser oder Kombinationen davon liefert. Dies ist eine grundlegende Einstellung, die steuert, wie die Zentrale im Modell verwendet wird.',
        thermalZone:
          'Eine Zentrale kann mit einer thermischen Zone verknüpft werden, sodass die Umgebungstemperatur um die Zentrale dieser Zone folgt, was Wirkungsgrad und Verluste beeinflusst. Verknüpfen Sie sie mit einer relevanten Zone, wenn Platzierung oder Umgebungstemperatur für die Berechnung wichtig ist, andernfalls kann sie eigenständig bleiben.',
        ambientTemperature:
          'Die Umgebungstemperatur ist die Temperatur des Raums, in dem die Zentrale steht, zum Beispiel ein Technikraum. Sie wird nur verwendet, wenn die Zentrale nicht mit einer thermischen Zone verknüpft ist, und beeinflusst die Verluste der Zentrale und der Speicher. Wenn eine Zone gewählt ist, wird die Temperatur stattdessen von dort übernommen.',
        sourceName:
          'Geben Sie der Energiequelle einen eindeutigen Namen, damit sie leicht zu erkennen ist, wenn die Zentrale mehrere Energiequellen hat. Der Name dient nur der Identifikation.',
        usage:
          'Diese Optionen steuern, was die Energiequelle tatsächlich abdeckt: Heizung, Kühlung und/oder Trinkwarmwasser. Wählen Sie die Bedarfe, zu denen die Quelle beiträgt. Invertergeregelt bedeutet, dass die Einheit ihre Leistung modulieren kann, was einen besseren Wirkungsgrad bei Teillast ergibt.',
        heatPump: {
          type: 'Der Wärmepumpentyp beschreibt, woher die Wärmepumpe Energie bezieht und wohin sie sie liefert: Luft-Wasser entzieht der Außenluft Energie und liefert an ein wasserbasiertes System, Sole-Wasser bezieht aus Erdreich, Fels oder Wasser über einen Kollektor, und Luft-Luft erwärmt die Raumluft direkt. Die Wahl beeinflusst den Wirkungsgrad und welche zusätzlichen Felder angezeigt werden.',
          co2eEmissionFactor:
            'Der CO₂e-Emissionsfaktor gibt an, wie viel Treibhausgasemission mit der von der Wärmepumpe genutzten Energie verbunden ist, angegeben pro kWh. Geben Sie nur dann einen bestimmten Wert an, wenn Sie Emissionen genau berechnen möchten. Er wirkt sich nicht auf den Energiebedarf selbst aus.',
          heatingCapacity:
            'Die Heizleistung ist die nominale Wärmeleistung der Wärmepumpe in kW, also wie viel Wärme sie unter normalen Bedingungen liefern kann. Dies ist der wichtigste Kapazitätswert und wird verwendet, um zu beurteilen, ob die Pumpe den Heizbedarf deckt.',
          nominalLoad:
            'Die Nennlast (0-1) ist der Anteil der vollen Kapazität, für den die Wärmepumpe im Normalbetrieb ausgelegt ist. Geben Sie sie an, wenn die Dokumentation sie separat angibt. Wird für eine detaillierte Teillastmodellierung verwendet.',
          minimumLoad:
            'Die Mindestlast (0-1) ist der niedrigste Anteil der vollen Kapazität, bei dem die Wärmepumpe stabil laufen kann, bevor sie ein- und ausschalten muss. Geben Sie sie an, wenn die Pumpe modulieren kann und dies bekannt ist.',
          degradeCoeff:
            'Der Degradationskoeffizient (0-1) beschreibt, wie stark der Wirkungsgrad sinkt, wenn die Wärmepumpe bei Teillast statt voller Leistung läuft. Geben Sie ihn an, wenn Herstellerdaten oder Berechnungen vorliegen. Kann normalerweise leer bleiben; er wird dann gemäß NS 3031 auf 0,8 gesetzt, oder 0,6 für invertergeregelte Einheiten.',
          maxTemperatureSupplied:
            'Die höchste gelieferte Temperatur ist die wärmste Vorlauftemperatur, die die Wärmepumpe an das Heizsystem liefern kann, in °C. Wärmepumpen verlieren bei hohen Vorlauftemperaturen an Wirkungsgrad. Wird verwendet, um zu beurteilen, ob die Pumpe den Temperaturbedarf deckt, zum Beispiel für Heizkörper, die eine hohe Temperatur benötigen.',
          cop: 'Der COP (Coefficient of Performance) ist der Wirkungsgrad der Wärmepumpe für die Heizung: das Verhältnis von gelieferter Wärme zu zugeführtem Strom. Ein COP von 3 bedeutet dreimal so viel Wärme wie Strom. Geben Sie einen bestimmten Wert an, falls vorhanden, andernfalls werden Standardwerte verwendet.',
          liquidSource:
            'Die Flüssigkeitsquelle ist das Medium, aus dem die Sole-Wasser-Wärmepumpe über einen Kollektor Energie bezieht, zum Beispiel Erdreich, Fels, Süßwasser oder Meerwasser. Die Quelle beeinflusst die verfügbare Quellentemperatur und damit den Wirkungsgrad.',
          sourceTemperature:
            'Die Quellentemperatur ist die Temperatur der Flüssigkeit, die von der Quelle in die Wärmepumpe gelangt, in °C. Eine höhere Quellentemperatur ergibt einen besseren Wirkungsgrad. Geben Sie sie an, wenn sie aus Messung oder Baugrunduntersuchung bekannt ist.',
          sourceYearlyAverageTemperature:
            'Die Jahresmitteltemperatur ist die durchschnittliche Temperatur der Quelle über ein Jahr, in °C. Sie dient als Ausgangspunkt zur Berechnung der saisonalen Leistung der Wärmepumpe. Geben Sie sie an, wenn sie bekannt ist, andernfalls werden typische Werte für die gewählte Quelle verwendet.',
          liquidMaxTemperature:
            'Dies ist die höchste Temperatur, die die Quelle im Laufe des Jahres erreicht, in °C. Zusammen mit Jahresmittel und Amplitude beschreibt sie, wie die Quellentemperatur über die Saison schwankt, was den Wirkungsgrad beeinflusst.',
          sourceTemperatureAmplitude:
            'Die Temperaturamplitude beschreibt, wie stark die Quellentemperatur im Laufe des Jahres über und unter den Jahresmittelwert schwankt, in °C. Eine größere Amplitude bedeutet eine größere saisonale Schwankung des Wirkungsgrads. Geben Sie sie an, wenn sie bekannt ist, andernfalls werden typische Werte für die Quelle verwendet.',
          energyWellDimensioning:
            'Richtwerte für Jahresmitteltemperatur und Jahresamplitude von Erdwärmesonden (Bohrlöchern). Wählen Sie die Beschreibung, die am besten zur Nutzung und Dimensionierung der Sonde passt; die Temperaturwerte werden dann automatisch anhand des Klimastandorts gesetzt.',
          waterSourceDepth:
            'Richtwerte für Jahresmitteltemperatur und Jahresamplitude bei Wärmeentnahme aus Meer- und Süßwasser. Wählen Sie die Tiefe der Wärmeentnahme; die Temperaturwerte werden dann automatisch anhand des Klimastandorts gesetzt.',
        },
        districtHeating: {
          maxCapacity:
            'Die maximale Kapazität ist die höchste Leistung, die der Fernwärme- oder Fernkälteanschluss an das Gebäude liefern kann, in kW. Geben Sie sie an, wenn sie aus Dokumentation oder Anlagendaten bekannt ist. Wird verwendet, um zu beurteilen, ob die Quelle den Leistungsbedarf deckt.',
          efficiency:
            'Der Wirkungsgrad beschreibt, wie viel der vom Fernwärmenetz gelieferten Energie nach Verlusten in Wärmetauscher und Verteilung tatsächlich zu nutzbarer Wärme im Gebäude wird. Geben Sie einen Gesamtwert an, wenn Sie die Standardwerte der Zentrale überschreiben möchten.',
          temperatureFromSource:
            'Die Temperatur von der Quelle ist die Vorlauftemperatur, die das Fernwärme- oder Fernkältenetz an den Wärmetauscher liefert, in °C. Geben Sie sie an, wenn sie bekannt ist. Ergibt eine realistischere Beschreibung des Betriebs und Wirkungsgrads der Zentrale.',
          heatExchangerLoss:
            'Der Wärmetauscher überträgt Energie vom Fernwärmenetz in das eigene System des Gebäudes, und ein Teil der Energie geht dabei verloren. Wählen Sie Dämmniveau und Austrittstemperaturbereich, um den Verlust detaillierter zu beschreiben, oder geben Sie den Verlustkoeffizienten direkt an, wenn ein dokumentierter Wert vorliegt. Lassen Sie die Felder leer, um Standardwerte zu verwenden.',
          distributionHeatLoss:
            'Der Verteilungswärmeverlust ist die Energie, die im Rohrnetz zwischen der Zentrale und dem Gebäudesystem verloren geht. Wählen Sie den Vorlauftemperaturbereich für die Verteilung, um den Verlust detaillierter zu beschreiben, oder geben Sie den Verlustkoeffizienten direkt an, wenn er bekannt ist. Lassen Sie die Felder leer, um Standardwerte zu verwenden.',
          coolingHeatExchanger:
            'Der Kältetauscher überträgt Kühlung von der Fernkälte oder der Kältezentrale auf das Gebäudesystem, und ein Teil der Energie geht verloren. Wählen Sie das Dämmniveau, wenn die Kälteseite detaillierter modelliert werden soll, oder geben Sie den U-Wert direkt an, wenn er bekannt ist. Lassen Sie die Felder leer, um Standardwerte zu verwenden.',
          co2eEmissionFactor:
            'Der CO₂e-Emissionsfaktor gibt an, wie viel Treibhausgasemission mit der Energie aus Fernwärme oder Fernkälte verbunden ist, angegeben in Gramm pro kWh. Geben Sie einen bestimmten Wert an, wenn Sie die tatsächliche Emissionszahl des Netzes verwenden möchten. Er wirkt sich nur auf die Emissionsbilanz aus, nicht auf den Energiebedarf selbst.',
          energyPrice:
            'Der Energiepreis ist der Preis pro kWh der von Fernwärme oder Fernkälte gelieferten Energie. Geben Sie einen bestimmten Preis an, wenn Sie Kostenberechnungen mit realen Preisen wünschen, andernfalls kann das Feld leer bleiben. Er wirkt sich nur auf die Kostenzahlen aus, nicht auf Energie oder Emissionen.',
        },
        combustionBoiler: {
          boilerType:
            'Der Kesseltyp beschreibt, um welche Art Verbrennungskessel es sich handelt, zum Beispiel Öl, Gas oder Biomasse. Wählen Sie den, der die Anlage am besten beschreibt. Die Wahl steuert Standardannahmen wie Wirkungsgrad und Emissionsniveau.',
          heatingCapacity:
            'Die Heizleistung ist die nominale Wärmeleistung des Kessels in kW, also wie viel Leistung er unter normalen Bedingungen liefern kann. Dies ist der Hauptwert, um zu beurteilen, ob der Kessel den Leistungsbedarf deckt.',
          performance:
            'Die Leistung gibt das nominale Wirkungsgradniveau des Kessels an, also wie effizient der Brennstoff in nutzbare Wärme umgewandelt wird. Wählen oder geben Sie das Niveau an, wenn es für den Kessel dokumentiert ist, andernfalls werden Standardwerte verwendet.',
          fuelSource:
            'Die Brennstoffquelle ist das, was der Kessel verbrennt, zum Beispiel Öl, Gas oder Biobrennstoff. Die Wahl bestimmt den Standardenergiegehalt und den Emissionsfaktor des Brennstoffs und beeinflusst damit sowohl die Energie- als auch die Emissionsberechnung.',
          fuelEnergyContent:
            'Der Energiegehalt ist, wie viel Energie der Brennstoff pro Einheit enthält, zum Beispiel kWh pro Liter. Geben Sie einen bestimmten Wert an, wenn Sie genauere Annahmen als die Standardwerte für den gewählten Brennstoff wünschen.',
          co2eEmissionFactor:
            'Der CO₂e-Emissionsfaktor gibt an, wie viel Treibhausgasemission die Verbrennung des Brennstoffs erzeugt, angegeben in Gramm pro kWh. Geben Sie einen bestimmten Wert an, wenn Sie eine genaue Emissionsberechnung wünschen. Er wirkt sich nur auf die Emissionsbilanz aus, nicht auf den Energiebedarf.',
          efficiencyAtLowerLoad:
            'Dies ist die Wärmeleistung des Kessels bei etwa 30 % der Volllast, in Kilowatt. Der Wert ist zusammen mit dem Volllastwert erforderlich, damit die Simulation das Teillastverhalten des Kessels modellieren kann.',
          effectAtFullLoad:
            'Dies ist die Wärmeleistung des Kessels bei Volllast in Kilowatt, also wie viel Leistung er bei maximalem Betrieb liefert. Der Wert ist erforderlich, damit die Simulation den Kessel richtig dimensioniert.',
          isCondensing:
            'Ein Brennwertkessel nutzt zusätzlich die Wärme im Wasserdampf des Abgases und erreicht damit einen höheren Wirkungsgrad als ein herkömmlicher Kessel. Aktivieren Sie dies, wenn der Kessel ein Brennwertkessel ist.',
          isCHP:
            'Eine Kraft-Wärme-Kopplungsanlage (CHP) erzeugt gleichzeitig Strom und Wärme aus demselben Brennstoff, was eine hohe Gesamtenergienutzung ergibt. Aktivieren Sie dies, wenn die Anlage eine CHP-Anlage ist; dann erscheinen eigene CHP-Einstellungen.',
          scheduleStart:
            'Der Startzeitpunkt ist, wann die Betriebssaison des Kessels beginnt, angegeben als Tag und Monat. Füllen Sie dies aus, wenn der Kessel nicht kontinuierlich läuft oder nicht dem Standardbetriebsprofil folgt, zum Beispiel ein Kessel, der nur in der Heizsaison genutzt wird.',
          scheduleEnd:
            'Der Endzeitpunkt ist, wann die Betriebssaison des Kessels endet, angegeben als Tag und Monat. Wird zusammen mit dem Startzeitpunkt ausgefüllt, um den Zeitraum zu beschreiben, in dem der Kessel in Betrieb ist.',
          seasonalMeanTemp:
            'Die saisonale Mitteltemperatur ist die durchschnittliche Außentemperatur über die Betriebssaison, in °C. Geben Sie sie an, wenn die Anlage mit detaillierteren Temperaturannahmen als dem Standard beschrieben werden soll.',
          temperatureSupply:
            'Die Vorlauftemperatur ist die Temperatur des Wassers, das der Kessel an das Heizsystem sendet, in °C. Eine niedrigere Vorlauftemperatur ergibt oft einen besseren Wirkungsgrad, besonders bei Brennwertkesseln. Geben Sie sie an, wenn sie bekannt ist.',
          temperatureReturn:
            'Die Rücklauftemperatur ist die Temperatur des Wassers, das vom Heizsystem zum Kessel zurückkommt, in °C. Bei Brennwertkesseln ist eine niedrige Rücklauftemperatur wichtig, um Kondensation und einen hohen Wirkungsgrad zu erreichen. Geben Sie sie an, wenn sie bekannt ist.',
        },
        electricBoiler: {
          maxCapacity:
            'Die maximale Kapazität ist die höchste Leistung, die der Elektrokessel liefern kann, in kW. Dies ist der Hauptwert, um zu beurteilen, ob der Kessel den Leistungsbedarf deckt.',
          insulationGrade:
            'Der Dämmgrad beschreibt, wie gut der Kessel selbst gedämmt ist, und bestimmt, wie viel Wärme er im eingeschalteten Zustand an die Umgebung verliert. Wählen Sie einen Grad, wenn Sie eine genauere Modellierung des Wärmeverlusts des Kessels wünschen.',
          efficiency:
            'Der Wirkungsgrad beschreibt, wie viel des zugeführten Stroms nach Verlusten im Kessel zu nutzbarer Wärme wird. Elektrokessel haben normalerweise einen hohen Wirkungsgrad. Geben Sie einen Wert an, wenn Sie die Standardannahmen überschreiben möchten.',
          co2eEmissionFactor:
            'Der CO₂e-Emissionsfaktor gibt an, wie viel Treibhausgasemission mit dem vom Kessel genutzten Strom verbunden ist, angegeben in Gramm pro kWh. Geben Sie einen bestimmten Wert an, wenn Sie eine genaue Emissionsberechnung wünschen. Er wirkt sich nur auf die Emissionsbilanz aus, nicht auf den Energiebedarf.',
          temperatureSupply:
            'Die Vorlauftemperatur ist die Temperatur des Wassers, das der Kessel an das Heizsystem sendet, in °C. Sie beeinflusst, welche Wärmeübergeber der Kessel bedienen kann, und den Wärmeverlust im System. Geben Sie sie an, wenn sie bekannt ist.',
          temperatureReturn:
            'Die Rücklauftemperatur ist die Temperatur des Wassers, das vom Heizsystem zum Kessel zurückkommt, in °C. Zusammen mit der Vorlauftemperatur beschreibt sie das Temperaturniveau im System. Geben Sie sie an, wenn sie bekannt ist.',
        },
        solarThermal: {
          solarType:
            'Der Solarkollektortyp beschreibt das Kollektorprinzip, zum Beispiel Flachkollektor oder Vakuumröhrenkollektor. Vakuumröhren liefern bei niedrigen Außentemperaturen in der Regel eine bessere Leistung. Die Wahl beeinflusst die Standardannahmen für den Ertrag der Anlage.',
          azimuth:
            'Der Azimut ist die Ausrichtung der Kollektoren nach Himmelsrichtung in Grad, wobei 0 in der Regel genau Süden bedeutet. Er beschreibt, in welche Richtung die Kollektoren zeigen, und beeinflusst stark, wie viel Sonnenenergie sie einfangen.',
          tilt: 'Die Neigung ist der Winkel der Kollektoren gegenüber der Horizontalen in Grad, wobei 0 flach und 90 senkrecht ist. Zusammen mit dem Azimut bestimmt sie, wie viel Sonneneinstrahlung die Kollektoren über das Jahr erhalten.',
          adjustmentFactor:
            'Der Anpassungsfaktor skaliert den berechneten Solarertrag nach oben oder unten, um lokale Bedingungen wie Verschattung oder Verschmutzung zu berücksichtigen. Geben Sie nur dann einen Wert an, wenn Sie die Standardberechnung korrigieren möchten; andernfalls lassen Sie das Feld leer.',
          performance:
            'Die Leistung gibt das nominale Wirkungsgrad- oder Kapazitätsniveau der solarthermischen Anlage an, also wie effizient die Kollektoren die Sonneneinstrahlung in nutzbare Wärme umwandeln. Wählen oder geben Sie das Niveau an, wenn es aus der Dokumentation bekannt ist, andernfalls werden Standardwerte verwendet.',
          pipeLength:
            'Die Rohrlänge ist die Gesamtlänge der Rohre zwischen den Kollektoren und dem Speicher, in Metern. Längere Rohre verlieren mehr Wärme. Geben Sie sie zusammen mit dem Rohrdämmungstyp an, wenn Sie die Rohrverluste detaillierter berechnen möchten.',
          pipeInsulationType:
            'Der Rohrdämmungstyp beschreibt, wie gut die Rohre zwischen den Kollektoren und dem Speicher gedämmt sind, was den Standardwärmeverlust pro Meter Rohr festlegt. Wählen Sie ihn, wenn bekannt, andernfalls wird ein Standardwert verwendet.',
          pipeUValue:
            'Der U-Wert der Rohre gibt an, wie viel Wärme die Rohre des Kollektorkreises pro Meter und Grad Temperaturdifferenz verlieren (W/mK). Ein niedrigerer Wert bedeutet bessere Dämmung. Geben Sie ihn an, wenn er bekannt ist, andernfalls wird er aus dem gewählten Rohrdämmungstyp abgeleitet.',
          collectorArea:
            'Die Kollektorfläche ist die gesamte aktive Fläche der Solarkollektoren, in m². Dies ist eine zentrale Eingabe für die Ertragsberechnung, da mehr Kollektorfläche mehr Sonnenenergie liefert.',
          tankSpiralPlacementFactor:
            'Der Platzierungsfaktor der Speicherspirale beschreibt, wo im Speicher die Solarwärmespirale sitzt, was beeinflusst, wie effektiv die Solarwärme an das Wasser übertragen wird. Geben Sie einen Wert an, wenn Sie detaillierte Daten für das System haben, andernfalls wird ein Standardwert verwendet.',
          temperatureColdWater:
            'Die Kaltwassertemperatur ist die Temperatur des dem System zugeführten Wassers, bevor es von den Kollektoren erwärmt wird, in °C. Eine niedrigere Kaltwassertemperatur ergibt einen höheren Solarertrag. Geben Sie einen Wert an, wenn Sie den Standardwert überschreiben möchten.',
          percentageOfCollectorLoopOutside:
            'Dies ist der Anteil des Kollektorkreises (Rohre und Komponenten), der sich im Freien befindet, in Prozent. Rohre, die im Freien verlaufen, verlieren mehr Wärme. Geben Sie einen Wert an, wenn dies für die Verlustberechnung relevant ist.',
          collectorSpecs:
            'Diese Werte bilden die Wirkungsgradkurve des Kollektors, entnommen aus dem Produktdatenblatt oder dem Solar-Keymark-Zertifikat. η₀ ist der optische Wirkungsgrad bei keiner Temperaturdifferenz, während die Wärmeverlustkoeffizienten a₁ und a₂ beschreiben, wie schnell der Wirkungsgrad sinkt, wenn der Kollektor wärmer als seine Umgebung wird. Geben Sie die Werte an, wenn Dokumentation vorliegt, andernfalls werden Standardwerte verwendet.',
          snowCoverageMonths:
            'Wählen Sie aus, in welchen Monaten die Solarkollektoren normalerweise schneebedeckt sind. In diesen Monaten erzeugen die Kollektoren wenig oder keine Energie, was eine realistischere Jahresberechnung ergibt, bei der Schnee die Produktion beeinflusst.',
          insulationFactorForCollectionLoop:
            'Der Dämmfaktor für den Kollektorkreis beschreibt, wie gut die Rohre und Komponenten im Solarkreis insgesamt gedämmt sind. Wählen Sie ein Niveau, wenn Sie eine genauere Berechnung des Wärmeverlusts im Kreis wünschen, andernfalls wird ein Standardwert verwendet.',
        },
        otherSource: {
          fuelType:
            'Der Brennstofftyp ist der Energieträger, den diese Versorgung nutzt, zum Beispiel Öl, Gas, Biobrennstoff, Fernwärme oder Strom. Die Wahl bestimmt den Standard-Emissionsfaktor und wie die Energie verrechnet wird.',
          maxCapacity:
            'Die maximale Kapazität ist die höchste Leistung, die diese Energiequelle liefern kann, in kW. Dies ist der Hauptwert, um zu beurteilen, ob die Quelle den Leistungsbedarf deckt.',
          efficiency:
            'Der Wirkungsgrad beschreibt, wie viel der zugeführten Energie nach Verlusten in der Quelle zu nutzbarer Wärme oder Kälte wird. Geben Sie einen Wert an, wenn er bekannt ist, andernfalls wird eine Standardannahme verwendet.',
          co2eEmissionFactor:
            'Der CO₂e-Emissionsfaktor gibt an, wie viel Treibhausgasemission mit der von dieser Quelle genutzten Energie verbunden ist, angegeben in Gramm pro kWh. Geben Sie einen bestimmten Wert an, wenn Sie eine genaue Emissionsberechnung wünschen. Er wirkt sich nur auf die Emissionsbilanz aus, nicht auf den Energiebedarf.',
          energyPrice:
            'Der Energiepreis ist der Preis pro kWh Energie aus dieser Quelle. Geben Sie einen bestimmten Preis an, wenn Sie Kostenberechnungen mit realen Preisen wünschen, andernfalls kann das Feld leer bleiben. Er wirkt sich nur auf die Kostenzahlen aus, nicht auf Energie oder Emissionen.',
        },
        accumulationTank: {
          purpose:
            'Ein Pufferspeicher speichert Wärme oder Kälte, sodass Erzeugung und Verbrauch zeitlich verschoben werden können. Wählen Sie den Zweck, zum Beispiel Wärmespeicher, Kältespeicher oder Warmwasser, der die Funktion des Speichers im System beschreibt.',
          volume:
            'Das Volumen ist die Speicherkapazität des Speichers in Litern und der Hauptparameter dafür, wie viel Wärme oder Kälte der Speicher speichern kann. Geben Sie es an, wenn ein Pufferspeicher vorhanden ist.',
          insulation:
            'Das Dämmniveau beschreibt, wie gut der Speicher gedämmt ist, und bestimmt, wie viel Wärme an die Umgebung verloren geht. Wählen Sie das Niveau oder den Typ, falls bekannt. Wird verwendet, um den Wärmeverlust des Speichers abzuschätzen oder zu überschreiben.',
          heatLoss:
            'Der Wärmeverlust (W/K) gibt an, wie viel Leistung der Speicher pro Grad Temperaturdifferenz an die Umgebung verliert. Geben Sie einen dokumentierten Wert an, falls vorhanden. Kann normalerweise leer bleiben, wenn Volumen und Standarddämmung ausreichen.',
          setpoint:
            'Die Sollwerttemperatur ist die gewünschte Speichertemperatur im Speicher, in °C. Sie bestimmt, wie warm oder kalt das Medium gehalten wird, und beeinflusst sowohl Verluste als auch Kapazität.',
          maxTemp:
            'Die Maximaltemperatur ist die höchste Temperatur, die der Speicher erreichen darf, in °C. Geben Sie sie an, wenn dies bekannt oder für die Regelung relevant ist.',
          minTemp:
            'Die Mindesttemperatur ist die niedrigste Temperatur, auf die der Speicher absinken darf, in °C. Geben Sie sie an, wenn dies bekannt oder für die Regelung relevant ist.',
          minTempDhw:
            'Die Mindesttemperatur ist die niedrigste Temperatur, auf die der Speicher absinken darf, in °C. Bei Trinkwarmwasserspeichern sollte sie mindestens 70 °C betragen, um Legionellenbildung zu verhindern.',
        },
      },
      excessEnergy: {
        medium:
          'Das Medium ist, worin die Überschussenergie strömt: Luft, zum Beispiel ein Abluftkanal, oder Flüssigkeit, zum Beispiel eine Abwasserleitung. Die Wahl bestimmt, welche Felder angezeigt werden und wie die verfügbare Energie berechnet wird.',
        name: 'Geben Sie der Überschussenergiequelle einen eindeutigen Namen. Der Name dient dazu, potenzielle Quellen für die Rückgewinnung zu identifizieren, zum Beispiel Abluft aus einer Küche oder Abwärme aus einem Prozess.',
        ductShape:
          'Wählen Sie das Medium und die Kanalform für die Quelle. Die Kanalform, zum Beispiel rund oder rechteckig, wird zusammen mit den Maßen verwendet, um den Querschnitt und damit den verfügbaren Energiestrom zu berechnen, wenn die Überschussenergie aus Luft entnommen wird.',
        ductWidthDiameter:
          'Geben Sie die Breite oder den Durchmesser des Kanals in mm an, falls bekannt. Wird zusammen mit der Kanalform und gegebenenfalls Höhe, Luftgeschwindigkeit oder Volumenstrom verwendet, um zu berechnen, wie viel Luft durch den Kanal strömt.',
        height:
          'Geben Sie die Kanalhöhe in mm an, wenn die Kanalform dies erfordert, zum Beispiel bei einem rechteckigen Kanal. Zusammen mit der Breite ergibt sie den Querschnitt des Kanals.',
        airspeed:
          'Die Luftgeschwindigkeit ist, wie schnell die Luft durch den Kanal strömt, in m/s. Geben Sie sie an, wenn der Volumenstrom nicht direkt bekannt ist; die Luftmenge wird dann aus Geschwindigkeit und Kanalquerschnitt berechnet.',
        exhaustTempAir:
          'Die Ablufttemperatur ist die Temperatur des Luftstroms, aus dem die Überschussenergie entnommen wird, in °C. Die Temperatur ist entscheidend für die Beurteilung, wie viel Energie zurückgewonnen werden kann; eine höhere Temperatur liefert mehr verfügbare Wärme.',
        exhaustTempLiquid:
          'Geben Sie die Temperatur des Flüssigkeitsstroms an, aus dem die Überschussenergie entnommen wird, in °C. Die Temperatur ist entscheidend für die Beurteilung, wie viel Energie aus der Flüssigkeit zurückgewonnen werden kann.',
        volumeFlowAir:
          'Der Volumenstrom ist, wie viel Luft pro Stunde durchströmt, in m³/h. Zusammen mit der Temperatur bestimmt er, wie viel Energie für die Rückgewinnung verfügbar ist. Geben Sie ihn an, wenn er bekannt ist, andernfalls kann er aus der Kanalgeometrie und der Luftgeschwindigkeit berechnet werden.',
        volumeFlowLiquid:
          'Der Volumenstrom ist, wie viel Flüssigkeit pro Stunde durchströmt, in L/h. Zusammen mit der Temperatur bestimmt er, wie viel Energie für die Rückgewinnung verfügbar ist. Geben Sie ihn an, wenn er bekannt ist.',
      },
      solarPv: {
        panelAngle:
          'Die Neigung der Solarmodule gemessen ab der Horizontalen, in Grad. Ein flach auf dem Dach liegendes Modul hat 0° und ein senkrecht stehendes Modul 90°. Die Neigung bestimmt, wie direkt das Sonnenlicht im Laufe des Jahres auf die Module trifft, und beeinflusst daher die berechnete Jahresproduktion stark.',
        name: 'Ein eindeutiger, wiedererkennbarer Name für diese Photovoltaikanlage. Er dient zur Identifizierung der Anlage in Listen, Ergebnissen und Berichten, was hilfreich ist, wenn ein Gebäude mehrere separate Photovoltaikanlagen hat.',
        panelArea:
          'Die aktive Fläche der Solarmodule, in Quadratmetern. Geben Sie entweder die Fläche eines einzelnen Moduls oder die Gesamtfläche der gesamten Anlage an, je nachdem, wie die Anlage erfasst wird, und passen Sie Anzahl an diese Wahl an. Zusammen mit dem Wirkungsgrad ist die Fläche eine der zentralen Eingabegrößen, die bestimmen, wie viel Strom die Anlage erzeugen kann.',
        quantity:
          'Die Anzahl der Solarmodule in dieser Anlage, sofern bekannt. Sie wird zusammen mit der Modulfläche und dem Wirkungsgrad zur Berechnung der installierten Leistung verwendet und muss damit übereinstimmen, wie die Fläche eingegeben wurde: Verwenden Sie die Modulanzahl, wenn die Modulfläche pro Modul angegeben ist, und 1, wenn die Modulfläche die Gesamtfläche der Anlage ist.',
        yearInstalled:
          'Das Jahr, in dem die PV-Anlage in Betrieb genommen wurde. Es wird für die Begehung erfasst, die Berechnung verwendet es aber nicht: Die Alterung der Module wird immer über eine feste Lebensdauer von 30 Jahren mit dem jährlichen Degradationsverlust berechnet.',
        soilingLocation:
          'Die Standortart, die bestimmt, wie schnell sich Staub, Pollen und Verschmutzung auf den Modulen ablagern. Wenn Sie einen Standort wählen, zum Beispiel städtisch, ländlich oder eine andere Exposition, wird ein standardisiertes monatliches Verschmutzungsprofil für diese Umgebung geladen, das Sie anschließend monatlich feinabstimmen können.',
        monthlySoiling:
          'Verschmutzung ist der Ertragsverlust durch Schmutz, Staub, Schnee und Verschmutzung auf der Moduloberfläche und schwankt im Jahresverlauf. Die Auswahl eines Standorts füllt ein vereinfachtes Standardprofil aus; geben Sie hier Ihren eigenen Wert für jeden Monat ein, wenn Sie dieses Profil durch standortspezifische Zahlen ersetzen möchten.',
        cellType:
          'Die Photovoltaiktechnologie der Module, zum Beispiel monokristallines oder polykristallines Silizium. Der Zelltyp bestimmt, wie effizient die Module Sonnenlicht in Strom umwandeln, daher legt die Auswahl einen repräsentativen Standardwirkungsgrad fest, den Sie weiterhin anpassen können.',
        nominalEfficiency:
          'Der Anteil der einfallenden Sonnenenergie, den die Module unter Standardtestbedingungen in Strom umwandeln, angegeben als Dezimalzahl (zum Beispiel 0,20 für 20 %). Geben Sie den dokumentierten Wert aus dem Datenblatt ein, wenn er bekannt ist; andernfalls wird der Standardwert des gewählten Zelltyps verwendet.',
        panelAzimuth:
          'Die Himmelsrichtung, in die die Module ausgerichtet sind, in Grad von 0 bis 360 (Süden liegt auf der Nordhalbkugel bei etwa 180°). Der Azimut bestimmt zusammen mit der Neigung, welchen Teil der Sonnenbahn die Module über den Tag und das Jahr erfassen, und beeinflusst daher die geschätzte Produktion direkt.',
        shadingFactor:
          'Der Anteil des Sonnenlichts, den die Module durch Verschattung von Nachbargebäuden, Gelände oder Bewuchs verlieren, von 0 bis 1. 0 bedeutet keine Verschattung und 1 vollständig verschattet, der Standardwert 0,05 ist also ein Verlust von 5 %. Der Wert wird erfasst, die Berechnung verwendet ihn aber noch nicht.',
        mountingType:
          'Wie die Module montiert sind, zum Beispiel dachintegriert oder freistehend mit Luftspalt. Die Montageart bestimmt, wie gut die Module von der umgebenden Luft gekühlt werden, was in das detailliertere Modell für Modultemperatur und Verluste einfließt. Wählen Sie sie, wenn Sie diesen Detailgrad wünschen.',
        windExposure:
          'Wie stark die Anlage dem Wind ausgesetzt ist. Wind kühlt die Module und senkt ihre Betriebstemperatur, was den Wirkungsgrad verbessert, daher wird dies zusammen mit der Montageart im detaillierteren Modell für die Modultemperatur verwendet. Wählen Sie sie, wenn sie bekannt ist.',
        heatLossFactor:
          'Wie leicht die Module Wärme an ihre Umgebung abgeben, in W/m²K. Er wird normalerweise aus Montageart und Windexposition abgeleitet, Sie können hier aber einen Wert eingeben, um diese Standardannahmen zu überschreiben und zu steuern, wie die Modultemperatur modelliert wird.',
        inverterEfficiency:
          'Der Anteil des Gleichstroms der Module, den der Wechselrichter als nutzbaren Wechselstrom liefert, als Dezimalzahl (zum Beispiel 0,945). Er erfasst den Umwandlungsverlust im Wechselrichter; geben Sie den dokumentierten Datenblattwert ein, wenn er bekannt ist.',
        degradationLoss:
          'Der allmähliche und dauerhafte Rückgang des Modulertrags mit zunehmendem Alter der Module, als Dezimalzahl (zum Beispiel 0,005 für 0,5 % pro Jahr). Geben Sie ihn ein, wenn Sie die nachlassende Leistung über die Lebensdauer der Anlage genauer modellieren möchten.',
        inverterLoss:
          'Zusätzliche Verluste im Zusammenhang mit dem Wechselrichter und seinem Betrieb, als Dezimalzahl. Verwenden Sie dies, wenn Sie wechselrichterbezogene Verluste getrennt vom Wirkungsgrad des Wechselrichters erfassen möchten, anstatt sie zu einer einzigen Zahl zusammenzufassen.',
        transmissionProduct:
          'Ein kombinierter Faktor (0 bis 1) für die optischen Verluste, wenn das Licht durch das Deckglas des Moduls hindurchtritt und die Zellen erreicht, etwa Reflexion und Absorption. Geben Sie ihn als Dezimalzahl ein, wenn die gewählte Berechnungsmethode diesen Term verwendet.',
        temperatureCoefficient:
          'Wie stark sich der Modulertrag mit der Temperatur ändert, in %/°C. Er ist normalerweise negativ, da der Ertrag sinkt, wenn sich die Module über ihre Nenntesttemperatur hinaus erwärmen. Geben Sie den dokumentierten Datenblattwert ein, wenn für diese Module einer vorliegt.',
        incidentAngleModifier:
          'Ein Faktor (0 bis 1), der die zusätzlichen Reflexionsverluste berücksichtigt, wenn das Sonnenlicht schräg statt frontal auf das Modul trifft. Geben Sie ihn als Dezimalzahl ein, wenn Sie das detailliertere Sonnenmodell verwenden möchten, das diese Einfallswinkeleffekte erfasst.',
      },
      battery: {
        name: 'Ein klarer, wiedererkennbarer Name für diese Batterie. Er dient dazu, die Batterie in Listen, Ergebnissen und Berichten zu identifizieren, was hilfreich ist, wenn ein Gebäude mehrere Batterien hat.',
        maxCapacity:
          'Die gesamte Energiemenge, die die Batterie speichern kann, in kWh. Dies ist die Nennkapazität des Batteriesystems und begrenzt, wie viel Solarüberschuss für die spätere Nutzung gespeichert werden kann.',
        maxChargePower:
          'Die höchste Leistung, mit der die Batterie geladen werden kann, in kW. Sie begrenzt, wie schnell die Batterie Solarüberschuss oder Netzstrom aufnehmen kann.',
        maxDischargePower:
          'Die höchste Leistung, die die Batterie an das Gebäude zurückliefern kann, in kW. Sie begrenzt, wie viel der Gebäudelast die Batterie in jedem Moment decken kann.',
        chargeEfficiency:
          'Welcher Anteil der in die Batterie eingespeisten Energie tatsächlich gespeichert wird, zwischen 0 und 1. Bei 0 wird der typische Standardwert für Lithium-Ionen-Batterien verwendet.',
        dischargeEfficiency:
          'Welcher Anteil der gespeicherten Energie beim Entladen tatsächlich geliefert wird, zwischen 0 und 1. Bei 0 wird der typische Standardwert für Lithium-Ionen-Batterien verwendet.',
        minStateOfCharge:
          'Der niedrigste Stand, bis zu dem die Batterie entladen werden darf, als Anteil der vollen Kapazität zwischen 0 und 1. Eine Reserve schont die Lebensdauer der Batterie. Bei 0 wird der Standardwert verwendet.',
        maxStateOfCharge:
          'Der höchste Stand, bis zu dem die Batterie geladen werden darf, als Anteil der vollen Kapazität zwischen 0 und 1. Etwas unterhalb der vollen Ladung zu bleiben schont die Lebensdauer der Batterie. Bei 0 wird der Standardwert verwendet.',
        peakShavingThreshold:
          'Der Netzbezug, unter dem die Batterie das Gebäude zu halten versucht, in kW. Würde das Gebäude mehr als diesen Wert aus dem Netz beziehen, entlädt sich die Batterie, um die Differenz zu decken. Bei 0 ist die Lastspitzenkappung deaktiviert; die Batterie speichert dann nur Solarüberschuss und deckt Defizite.',
        preChargeStateOfCharge:
          'Der Stand, auf den die Batterie in ruhigen Stunden aus dem Netz vorgeladen wird, als Anteil der vollen Kapazität zwischen 0 und 1, damit sie für die nächste Lastspitze bereit ist. Wird nur verwendet, wenn eine Schwelle für die Lastspitzenkappung gesetzt ist. Bei 0 ist die Vorladung deaktiviert.',
      },
    },
  },

  // Page titles
  title: 'Gebäudeinspektionen',
  sidebarTitle: 'Inspektion',
  new: 'Neue Gebäudeinspektion',
  edit: 'Inspektion bearbeiten',

  // List page
  fetchError: 'Fehler beim Laden der Gebäudeinspektionen.',
  noInspections: 'Keine Gebäudeinspektionen gefunden.',
  createNew: 'Neue Inspektion',
  confirmDeleteTitle: 'Inspektionen löschen',
  confirmDeleteDescription:
    'Sind Sie sicher, dass Sie diese Inspektion löschen möchten?',
  duplicate: 'Duplizieren',
  duplicating: 'Inspektion wird dupliziert...',
  duplicateSuccess: 'Inspektion dupliziert',
  duplicateError: 'Inspektion konnte nicht dupliziert werden',
  renameInspection: 'Inspektion umbenennen',

  // Common
  common: {
    // generic
    custom: 'Benutzerdefiniert',
    standard: 'Standard',
    other: 'Sonstiges',
    text: 'Text',
    from: 'Von',
    to: 'Bis',
    hide: 'Ausblenden',
    show: 'Anzeigen',
    horizontal: 'Horizontal',
    vertical: 'Vertikal',
    addImage: 'Bild hinzufügen',
    confirmDeleteImage: 'Möchten Sie dieses Bild wirklich löschen?',
    generating: 'Wird generiert...',
    indoorClimate: 'Raumklima',
    score: 'Bewertung',
    energyData: 'Energiedaten',
    air: 'Luft',
    liquid: 'Flüssigkeit',
    round: 'Rund',
    square: 'Quadratisch/rechteckig',

    // field labels
    quantity: 'Anzahl',
    location: 'Standort',
    priority: 'Priorität',
    yearInstalled: 'Installationsjahr',
    medium: 'Medium',

    // section / navigation labels
    inspection: 'Inspektion',
    info: 'Informationen',
    purpose: 'Zweck',
    module: 'Modul',
    control: 'Steuerung & Regelung',
    equipment: 'Ausrüstung',
    hvacSystems: 'HLK-Systeme',
    thermalZones: 'Thermische Zonen',
    zones: 'Zonen',
    heatingCooling: 'Heizung & Kühlung',
    heatingAndCooling: 'Heizung und Kühlung',
    heatingOnly: 'Nur Heizung',
    domesticHotWater: 'Trinkwarmwasser',
    centralEnergy: 'Zentrale Energie',
    excessEnergy: 'Überschussenergie',
    solarPv: 'Photovoltaik',
    solarThermal: 'Solarthermie',
    solarCells: 'Photovoltaik',
    attachments: 'Anhänge',
    annualSimulation: 'Jahressimulation',
    energyLabel: 'Energieausweis',
    actions: 'Maßnahmen',
    lighting: 'Beleuchtung',
    report: 'Bericht',
    hvac: 'HLK',
    windows: 'Fenster',
    doors: 'Türen',
    gates: 'Tore',
    walls: 'Wände',
    exteriorWalls: 'Außenwände',
    floor: 'Boden gegen Erdreich',
    roof: 'Dach',
    basement: 'Kellerkonstruktion',
    groundConditions: 'Bodenbedingungen',
    airLeakage: 'Luftleckage',
    thermalMass: 'Thermische Masse',
    internalLoads: 'Interne Lasten',
    productionEquipment: 'Produktionsausrüstung',
    ground: 'Erdreich',
    zone: 'Zone',
    wall: 'Wand',
    window: 'Fenster',
    door: 'Tür',
    gate: 'Tor',

    // climate
    climate: 'Klima',
    climatized: 'Klimatisiert',
    partlyClimatized: 'Teilweise klimatisiert',
    unclimatized: 'Nicht klimatisiert',
    floorHeight: 'Geschosshöhe (m)',

    // units and physical quantities
    area: 'Fläche (m²)',
    areaShort: 'Fläche',
    volume: 'Volumen (L)',
    volumeShort: 'Volumen',
    length: 'Länge (m)',
    power: 'Leistung (kW)',
    powerShort: 'Leistung',
    uValue: 'U-Wert (W/m²K)',
    uValueShort: 'U-Wert',
    coverageArea: 'Abdeckungsbereich (m²)',
    coverageAreaShort: 'Abdeckungsbereich',
    coverageVolume: 'Abdeckungsvolumen',
    heatingEffect: 'Heizleistung (kW)',
    coolingEffect: 'Kühlleistung (kW)',
    effect: 'Leistung (kW)',
    cop: 'COP',
    eer: 'EER',
    seasonalCOP: 'Saisonaler COP',
    seasonalEER: 'Saisonaler EER',
    efficiency: 'Wirkungsgrad',
    systemEfficiency: 'Systemeffizienz (%)',
    co2eEmissionFactor: 'CO₂e-Emissionsfaktor (g/kWh)',
    temperatureSupply: 'Vorlauftemperatur (°C)',
    temperatureReturn: 'Rücklauftemperatur (°C)',
    avgTemp: 'Durchschn. Temp',
    sfp: 'SFP',
    bra: 'BRA',
    airVolume: 'Luftvolumen',
    heatRecovery: 'Wärmerückgewinnung',
    panelArea: 'Panelfläche',
    cellType: 'Zellentyp',
    azimuth: 'Azimut',
    value: 'Wert',
    unit: 'Einheit',

    // system / fuel
    systemType: 'Systemtyp',
    systemTypeShort: 'Systemtyp',
    energySource: 'Energiequelle',
    energySourceShort: 'Energiequelle',
    specificFuelType: 'Brennstoffart',
    selectSpecificFuelType: 'Brennstoff auswählen...',
    inverterControlled: 'Invertergesteuert',
    nominalLoad: 'Nennlast',
    minimumLoad: 'Mindestlast',
    degradeCoeff: 'Degradationskoeff',
    heatPump: 'Wärmepumpe',
    electric: 'Elektrisch',
    oil: 'Öl',
    gas: 'Gas',
    rock: 'Gestein',
    coolingOnly: 'Nur Kühlung',

    // performance / magnitude grades
    high: 'Hoch',
    low: 'Niedrig',
    normal: 'Normal',

    // dimensions
    width: 'Breite (m)',
    height: 'Höhe (m)',
    depth: 'Tiefe (m)',

    // zone editor
    userDefined: 'Benutzerdefiniert',
    calculator: 'Rechner',
    compass: {
      N: 'N',
      NE: 'NO',
      E: 'O',
      SE: 'SO',
      S: 'S',
      SW: 'SW',
      W: 'W',
      NW: 'NW',
    },
    directions: {
      n: 'Nord (0°)',
      ne: 'Nordost (45°)',
      e: 'Ost (90°)',
      se: 'Südost (135°)',
      s: 'Süd (180°)',
      sw: 'Südwest (225°)',
      w: 'West (270°)',
      nw: 'Nordwest (315°)',
    },
    structuralNodes: 'Strukturknoten',
    structuralNode: 'Strukturknoten',
    addStructuralNode: 'Strukturknoten hinzufügen',
    copyStructuralNode: 'Strukturknoten kopieren',
    confirmDeleteStructuralNode: 'Diesen Strukturknoten löschen?',
    boundary: 'Randbedingung',
    boundaryInteriorAir: 'Innenluft',
    boundaryExterior: 'Außen',
    boundaryAdjacentZone: 'Angrenzende Zone',
    boundaryAdiabatic: 'Adiabatisch',
    node: 'Knoten',
    addNode: 'Knoten hinzufügen',
    copyNode: 'Knoten kopieren',
    confirmDeleteNode: 'Diesen Knoten löschen?',
    surfaceType: 'Oberflächentyp',
    surfaceCeiling: 'Decke',
    surfaceArea: 'Oberfläche (m\u00B2)',
    heatTransferCoeff: 'Wärmeübergangskoeff. (W/m\u00B2K)',
    totalMass: 'Gesamtmasse (kg/m\u00B3)',
    specificHeatCapacity: 'Spezifische Wärmekapazität (J/kgK)',

    // insulation grades
    insulated: 'Isoliert',
    uninsulated: 'Nicht isoliert',
    poorlyInsulated: 'Schlecht isoliert',
    normallyInsulated: 'Normal isoliert',
    wellInsulated: 'Gut isoliert',
    veryWellInsulated: 'Sehr gut isoliert',
    selectInsulation: 'Isolierung wählen...',
    selectPerformance: 'Wirkungsgrad auswählen...',
    selectFuelType: 'Brennstofftyp auswählen...',

    // UI layout
    basicSettings: 'Grundeinstellungen',
    additionalInfo: 'Zusätzliche Informationen',
    showAdvanced: 'Erweitert anzeigen',
    hideAdvanced: 'Erweitert ausblenden',
    advanced: 'Erweitert',

    // actions
    settingUp: 'Wird eingerichtet...',
    co2PerKwh: 'CO₂ pro kWh [g]',
    gridFee: 'Netzentgelt [NOK/kWh]',
    enovaSupport: 'Enova-Förderung [%]',
    descriptionPlaceholder:
      'Beschreiben Sie die Maßnahme im Detail: Was wird geändert, warum und welches Ergebnis wird erwartet. Fügen Sie eine Berechnung des voraussichtlich reduzierten Energieverbrauchs bei Umsetzung der Maßnahme sowie eine Bewertung der Kosten und Auswirkungen auf Feuchtigkeit und Raumklima im Zusammenhang mit der Maßnahme hinzu.',
    electricityZone: 'Stromzone',
    selectZone: 'Zone auswählen...',
    runSimulation: 'Gebäudesimulation starten',
    runningSimulation: 'Simulation läuft...',
    simulationDescription: 'Führt stündliche Energiebilanzsimulation durch',
    baselineProgress: 'Referenzsimulation läuft... (1/2)',
    actionProgress: 'Maßnahmensimulation läuft... (2/2)',
    baselineStarted: 'Basissimulation gestartet...',
    simulationStarted: 'Maßnahmensimulation gestartet...',
    noAnnualSimulation:
      'Führen Sie zuerst eine Jahressimulation durch, um den Maßnahmenvergleich zu aktivieren.',
    simulationResults: 'Simulationsergebnisse',
    lastSimulated: 'Zuletzt simuliert',
    nettEnergyDemand: 'Netto-Energiebedarf',
    energyCategory: 'Energiekategorie',
    baselineKwh: 'Referenz (kWh)',
    actionKwh: 'Maßnahme (kWh)',
    savingsKwh: 'Einsparung (kWh)',
    baselineKwhM2: 'Referenz (kWh/m²)',
    actionKwhM2: 'Maßnahme (kWh/m²)',
    savingsPercent: 'Einsparung (%)',
    baseline: 'Referenz',
    afterAction: 'Nach Maßnahme',
    solarProduction: 'Solarproduktion',
    savings: 'Einsparung',
    costSavings: 'Kosten und Einsparungen',
    annualEnergySavings: 'Jährliche Energieeinsparung',
    kwhYear: 'kWh/Jahr',
    energySavingsTooltip:
      'Reduzierung des gesamten Energiebedarfs durch Verbesserungen',
    reduction: 'Reduzierung',
    increase: 'Erhöhung',
    annualCostSavings: 'Jährliche Kosteneinsparung',
    nokYear: 'NOK/Jahr',
    costSavingsTooltip:
      'Gesamte Kosteneinsparung durch reduzierten Energieverbrauch und Erlöse aus exportierter Solarproduktion',
    netCo2Reduction: 'Netto-CO₂-Reduzierung',
    kgCo2Year: 'kg CO₂/Jahr',
    co2Tooltip: 'Verwendet {value} g CO₂/kWh',
    tonnes: 'Tonnen',
    paybackPeriod: 'Amortisationszeit',
    paybackTooltip: 'Zeit zur Rückgewinnung der Anfangsinvestition',
    years: 'Jahre',
    investmentLabel: 'Investition: {value} NOK',
    noInvestmentCost: 'Keine Investitionskosten angegeben',
    beforeExisting: 'Vorher - Bestehendes System',
    afterNew: 'Nachher - Neues System',
    investment: 'Investition',
    installationType: 'Installationstyp',
    simple: 'Einfach',
    complex: 'Komplex',
    deliveredEnergy: 'Gelieferte Energie',
    roiTitle: 'Kapitalrendite über die Zeit',
    roiCumulativeSavings: 'Kumulative Einsparungen',
    roiNetValue: 'Nettowert (nach Investition)',
    roiYears: 'Jahre',
    roiBreakEven:
      'Die Gewinnschwelle wird erreicht, wenn der Nettowert Null überschreitet (Jahr {value})',

    // misc
    presenceControl: 'Präsenzkontrolle',
    distributionLosses: 'Verteilungs- und Speicherverluste',
    installationCost: 'Installationskosten [NOK]',
    installationCostShort: 'Installationskosten',
    noZones:
      'Keine thermischen Zonen gefunden. Fügen Sie zuerst thermische Zonen im Bereich Thermische Zonen hinzu.',

    // shared energy source labels
    energySources: {
      electricity: 'Strom',
      heatpumpAirToAir: 'Wärmepumpe Luft-Luft',
      fossilOil: 'Fossiles Öl',
      fossilGas: 'Fossiles Gas',
      fossilSolidFuel: 'Fossiler Festbrennstoff',
      bioOil: 'Bioöl',
      bioGas: 'Biogas',
      bioSolidFuel: 'Bio-Festbrennstoff',
      districtHeating: 'Fernwärme',
      districtCooling: 'Fernkälte',
      otherSources: 'Andere Quellen',
    },

    // shared schedule block
    schedule: {
      operationalSchedule: 'Betriebsplan',
      addSchedule: 'Zeitplan hinzufügen',
      clickToToggle: 'Stunden anklicken zum Ein-/Ausschalten',
      avgTemp: 'Durchschn. Temp',
      days: ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'],
      months: [
        'Januar',
        'Februar',
        'März',
        'April',
        'Mai',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'Dezember',
      ],
      hours: 'Stunden',
      weekly: 'Wöchentlich',
      annual: 'Jährlich',
      on: 'AN',
      off: 'AUS',
      hoursPerDayUnit: 'h/Tag',
      hoursPerWeekUnit: 'h/Woche',
      hoursPerYearUnit: 'h/Jahr',
      setpointPerHour: 'Solltemperatur pro Stunde',
      setpointInfoTooltip:
        'Verwenden Sie EIN/AUS zur Steuerung der Betriebsstunden. Sollwerte für EIN-Stunden werden in Berechnungen verwendet. AUS-Stunden sind außerhalb des Betriebs.',
      copyToWeekdays: 'Auf Wochentage kopieren',
      copyToWeekends: 'Auf Wochenende kopieren',
      resetToStandards: 'Zurücksetzen auf',
      confirmDeleteSchedule: 'Diesen Zeitplan löschen?',
      fromMonth: 'Von',
      toMonth: 'Bis',
    },
  },

  // List page labels
  lists: {
    quantity: 'Menge',
    totalArea: 'Gesamt (m²)',
    thermalZones: {
      duplicateZone: 'Zone duplizieren',
      copySuffix: 'Kopie',
      duplicateSuccess: 'Zone erfolgreich dupliziert',
      duplicateError: 'Zone konnte nicht dupliziert werden',
    },
    exteriorWalls: {
      addFirst: 'Klicken Sie, um Ihre erste Außenwand hinzuzufügen',
      addWall: 'Wand hinzufügen',
      duplicateWall: 'Wand duplizieren',
    },
    windows: {
      addFirst: 'Klicken Sie, um Ihr erstes Fenster hinzuzufügen',
      addWindow: 'Fenster hinzufügen',
    },
    doors: {
      addFirst: 'Klicken Sie, um Ihre erste Tür hinzuzufügen',
      addDoor: 'Tür hinzufügen',
    },
    gates: {
      addFirst: 'Klicken Sie, um Ihr erstes Tor hinzuzufügen',
      addGate: 'Tor hinzufügen',
    },
    productionEquipment: {
      addFirst: 'Klicken Sie, um Ihre erste Produktionsausrüstung hinzuzufügen',
      addEquipment: 'Produktionsausrüstung hinzufügen',
    },
    hvac: {
      addFirst: 'Klicken Sie, um Ihre erste HLK-Einheit hinzuzufügen',
      addHvac: 'HLK hinzufügen',
    },
    heatingCooling: {
      addFirstHeating: 'Klicken Sie, um ein Heiz- oder Kühlsystem hinzuzufügen',
      addHeating: 'System hinzufügen',
    },
    domesticHotWater: {
      add: 'Trinkwarmwasser hinzufügen',
      addFirst: 'Klicken Sie, um Trinkwarmwasser hinzuzufügen',
    },
    centralEnergy: {
      add: 'Zentrales Energiemodul hinzufügen',
      addFirst: 'Klicken Sie, um ein zentrales Energiemodul hinzuzufügen',
    },
    excessEnergy: {
      add: 'Überschussenergiemodul hinzufügen',
      addFirst: 'Klicken Sie, um ein Überschussenergiemodul hinzuzufügen',
    },
    solarPv: {
      add: 'Photovoltaikmodul hinzufügen',
      addFirst: 'Klicken Sie, um ein Photovoltaikmodul hinzuzufügen',
    },
    batteries: {
      add: 'Batterie hinzufügen',
      addFirst: 'Klicken, um eine Batterie hinzuzufügen',
    },
    attachments: {
      noInspectionFound: 'Keine Inspektion gefunden',
    },
  },

  // Edit page - Form fields
  inspector: 'Inspektor',
  selectBuilding: 'Gebäude auswählen',
  selectedBuilding: 'Gebäude',
  selectBuildingPlaceholder: 'Gebäude auswählen...',
  notes: 'Notizen',

  // Edit page - Map panel
  advancedComingSoon: 'In Entwicklung',
  mapPlaceholder: 'Sastech Karte',

  // Status options
  statusDraft: 'Entwurf',
  statusInReview: 'In Überprüfung',
  statusCompleted: 'Abgeschlossen',

  // Validation & feedback
  buildingRequired: 'Bitte wählen Sie ein Gebäude',
  gpsRequired: 'Das ausgewählte Gebäude muss eine GPS-Position haben',
  createSuccess: 'Inspektion erfolgreich erstellt',
  updateSuccess: 'Inspektion erfolgreich aktualisiert',
  saved: 'gespeichert',
  saveError: 'Fehler beim Speichern der Inspektion',
  loadError: 'Fehler beim Laden der Inspektionsdaten',

  // Delete dialog
  deleteTitle: 'Inspektion löschen',
  deleteConfirm: 'Sind Sie sicher, dass Sie diese Inspektion löschen möchten?',
  deleteSuccess: 'Inspektion erfolgreich gelöscht',
  deleteError: 'Fehler beim Löschen der Inspektion',

  // Zone edit
  zoneName: 'Zonenname',
  zoneCategory: 'Zonenkategorie',
  buildingSubcategory: 'Gebäudeunterkategorie',
  zoneSaved: 'Zone gespeichert',
  standardElementsUpdated: 'Aktualisierte {count} Elemente auf {tek}',
  braRequired: 'BRA über 0 ist erforderlich',
  basementAreaRequired: 'Kellerbodenfläche größer als 0 ist erforderlich',
  categoryRequired: 'Bitte wählen Sie eine Gebäudekategorie',
  yearRequired: 'Bitte geben Sie das Baujahr ein',
  floorsRequired: 'Bitte geben Sie die Anzahl der Etagen ein',
  zoneCategoryRequired: 'Bitte wählen Sie eine Zonenkategorie',
  subcategoryRequired: 'Bitte wählen Sie eine Gebäudeunterkategorie',
  zoneClimateRequired: 'Bitte wählen Sie ein Zonenklima',
  floorHeightRequired: 'Eine Geschosshöhe größer als 0 ist erforderlich',
  airLeakageN50Required:
    'Eine Luftleckagezahl (n50) größer als 0 ist erforderlich',
  thermalBridgePsiRequired:
    'Ein normalisierter Wärmebrückenwert ist erforderlich',
  panelAreaRequired: 'Eine Panelfläche größer als 0 ist erforderlich',
  yearInstalledRequired: 'Installationsjahr ist erforderlich',
  soilingLocationRequired: 'Bitte wählen Sie einen Verschmutzungsstandort',
  cellTypeRequired: 'Bitte wählen Sie einen Zelltyp',
  deleteZone: 'Zone löschen',
  deleteZoneWarning: 'Diese Aktion kann nicht rückgängig gemacht werden',
  confirmDeleteZone: 'Diese Zone löschen?',
  indoorTemp: 'Starttemperatur (°C)',
  zoneClimate: 'Zonenklima',
  thermalBridgeCoeff: 'Tragkonstruktion (Wärmebrücke)',
  thermalBridgePsiValue: 'Normierter Wärmebrückenwert ψ (W/(m²·K))',
  thermalBridgeCoeffTypes: {
    custom: 'Benutzerdefiniert',
    wood: 'Gebäude mit Holztragwerk',
    concrete_10cm:
      'Gebäude mit Beton-, Mauerwerks- oder Stahltragwerk und 10 cm Wärmebrückenunterbrechung in den Fassaden',
    concrete_5cm:
      'Gebäude mit Beton-, Mauerwerks- oder Stahltragwerk und 5 cm Wärmebrückenunterbrechung in den Fassaden',
  },
  addZone: 'Zone hinzufügen',
  addFirstZone: 'Klicken Sie, um Ihre erste Zone hinzuzufügen',
  image: 'Bild',
  upload: 'Hochladen',

  // Heating/Cooling edit pages
  heatingCooling: {
    deleteModule: 'Modul löschen',
    confirmDeleteModule: 'Dieses Modul löschen?',
    deleteHeating: 'Heizmodul löschen',
    deleteCooling: 'Kühlmodul löschen',
    confirmDeleteHeating: 'Dieses Heizmodul löschen?',
    confirmDeleteCooling: 'Dieses Kühlmodul löschen?',
    systemType: 'Typ',
    priorityHelp: '1 = höchste Priorität (deckt Bedarf zuerst)',
    maxTemperatureSupplied: 'Max Vorlauftemperatur (°C)',
    systemTypeRequired: 'Bitte wählen Sie einen Systemtyp',
    energySourceRequired: 'Bitte wählen Sie eine Energiequelle',
    heatingEffectRequired: 'Eine Heizleistung größer als 0 ist erforderlich',
    coolingEffectRequired: 'Eine Kühlleistung größer als 0 ist erforderlich',
    systemEfficiencyRequired:
      'Ein Systemwirkungsgrad größer als 0 ist erforderlich',
    copRequired: 'Ein COP größer als 0 ist erforderlich',
    eerRequired: 'Ein EER größer als 0 ist erforderlich',
  },

  domesticHotWater: {
    deleteDhw: 'Trinkwarmwasser löschen',
    confirmDelete: 'Dieses Trinkwarmwasser-Modul löschen?',
    heaterType: 'Heizungstyp',
    volume: 'Volumen (L)',
    setpointTemperature: 'Solltemperatur (°C)',
    heatingElementPower: 'Heizstableistung (kW)',
    heaterTypes: {
      electric: 'Elektrisch',
      centralHeating: 'Zentralheizung',
    },
    typeSection: 'Typ',
    consumptionSection: 'Verbrauch',
    distributionSection: 'Verteilungssystem',
    greyWaterSection: 'Grauwasser-Wärmerückgewinnung',
    tapFrequency: 'Zapffrequenz',
    tapCyclesPerDay: 'Zapfzyklen pro Tag',
    hasCirculation: 'Warmwassersystem mit Zirkulation',
    pipeSpecificLength: 'Spezifische Warmwasser-Rohrlänge',
    circulationPipeLength: 'Spezifische Zirkulationsrohrlänge',
    greyWaterRecoveryType: 'Rückgewinnungseinheit-Typ',
    greyWaterEfficiencyGrade: 'Momentaner Wirkungsgrad',
    greyWaterShareType: 'Anteil Warmwasser zur Rückgewinnung',
    greyWaterConnectionType: 'Anschlussvariante',
    greyWaterPatternType: 'Zapfmuster',
    greyWaterHelperText:
      'Rückgewonnene Energie aus Grauwasser wird vom Gesamtenergiebedarf für die Trinkwarmwasserbereitung abgezogen.',
    tapFrequencyTypes: {
      high: 'Hohe Zapffrequenz',
      normal: 'Normale Zapffrequenz',
      low: 'Niedrige Zapffrequenz',
      perDay: '/Tag',
    },
    dhwPipeLengthTypes: {
      residentialLong: 'Wohngebäude, lange Rohrstrecken',
      residentialNormal: 'Wohngebäude, normale Rohrstrecken',
      residentialShort: 'Wohngebäude, kurze Rohrstrecken',
      commercialLong: 'Gewerbegebäude, lange Rohrstrecken',
      commercialNormal: 'Gewerbegebäude, normale Rohrstrecken',
      commercialShort: 'Gewerbegebäude, kurze Rohrstrecken',
    },
    circulationPipeLengthTypes: {
      circulationLong: 'Zirkulationssystem, lange Rohrstrecken',
      circulationNormal: 'Zirkulationssystem, normale Rohrstrecken',
      circulationShort: 'Zirkulationssystem, kurze Rohrstrecken',
    },
    greyWaterRecoveryTypes: {
      verticalPipe: 'Vertikaler Rohr-Wärmetauscher',
      horizontalPipe: 'Horizontaler Wärmetauscher',
      tankRecovery: 'Tankbasierte Wärmerückgewinnung',
    },
    greyWaterEfficiencyGrades: {
      low: 'Niedriger Wirkungsgrad',
      normal: 'Normaler Wirkungsgrad',
      high: 'Hoher Wirkungsgrad',
    },
    greyWaterShareTypes: {
      allShowers: 'Alle Duschen zur Rückgewinnung',
      halfShowers: '50 % der Duschen zur Rückgewinnung',
      thirdShowers: '30 % der Duschen zur Rückgewinnung',
    },
    greyWaterConnectionTypes: {
      hotWaterTankOnly: 'Nur an Warmwasserspeicher angeschlossen',
      coldWaterShowerOnly: 'Nur an Kaltwasser-Duschkreis angeschlossen',
      hotWaterTankAndColdWaterShower:
        'An Warmwasserspeicher und Kaltwasser-Duschkreis angeschlossen',
    },
    greyWaterPatternTypes: {
      residentialWithAccumulation: 'Wohngebäude mit Grauwasser-Akkumulierung',
      residentialWithoutAccumulation:
        'Wohngebäude ohne Grauwasser-Akkumulierung',
      showerWithoutAccumulation: 'Duschanlage ohne Grauwasser-Akkumulierung',
      showerWithAccumulation: 'Duschanlage mit Grauwasser-Akkumulierung',
    },
  },

  // Pipe Link configuration
  pipeLink: {
    localEnergySources: 'Lokale Energiequellen',
    centralEnergySources: 'Zentrale Energiequellen',
    noCentralModules: 'Keine zentralen Energiemodule konfiguriert',
    pipeConfiguration: 'Rohrkonfiguration',
    spp: 'SPP (kW/(l/s))',
    constantFlow: 'Konstanter Durchfluss',
    variableFlow: 'Variabler Durchfluss',
    lengthOfPipe: 'Rohrlänge (m)',
    percentageInHeatedSpace: '% im beheizten Raum',
    avgTempOutsideHeatedSpace: 'Durchschn. Temp. außerhalb beheizter Raum (°C)',
    waterSystemQuality: 'Wassersystemqualität',
    waterDistributionType: 'Wasserverteilungstyp',
    pipeInsulationType: 'Rohrdämmung',
    qualityOptions: {
      poor: 'Schlechte Wasserverteilung',
      normal: 'Normale Wasserverteilung',
      good: 'Gute Wasserverteilung',
    },
    distributionTypes: {
      radiatorFloorHeating: 'Heizsystem, Heizkörper/Fußbodenheizung',
      heatingBattery: 'Heizsystem, Heizregister in Lüftung',
      localCoolingCeilingBaffles:
        'Kühlsystem, lokale Kühlung/Deckenkonvektoren',
      centralCoolingBattery: 'Kühlsystem, zentrales Kühlregister in Lüftung',
      dhwCirculation: 'TWW-Zirkulation',
      energyWellBrine: 'Energiebrunnen, Sole',
    },
    insulationTypes: {
      uninsulated: 'Ungedämmte Rohre',
      poorlyInsulated: 'Schlecht gedämmte Rohre',
      normallyInsulated: 'Normal gedämmte Rohre',
      wellInsulated: 'Gut gedämmte Rohre',
      veryWellInsulated: 'Sehr gut gedämmte Rohre',
    },
    distributionPipeLengthType: 'Rohrlänge pro BRA',
    distributionPipeLengthTypes: {
      localAndCentralLong: 'Lokale und zentrale Heizung, lange Rohrstrecken',
      localAndCentralNormal:
        'Lokale und zentrale Heizung, normal lange Rohrstrecken',
      centralOnlyLong: 'Nur Zentralheizung, lange Rohrstrecken',
      centralOnlyShort: 'Nur Zentralheizung, kurze Rohrstrecken',
    },
    temperatureCannotBeZero: 'Temperatur darf nicht 0 sein',
    pipeTemperatureZeroWarning:
      'Vorlauf- und/oder Rücklauftemperatur ist auf 0 gesetzt.',
  },

  // Production Equipment edit page
  productionEquipment: {
    deleteEquipment: 'Produktionsausrüstung löschen',
    confirmDelete: 'Diese Produktionsausrüstung löschen?',
    eligibleForHarvesting: 'Für Energierückgewinnung geeignet',
    eligibleForHarvestingHelp:
      'Dieses Gerät als berechtigt zur Überschussenergierückgewinnung markieren',
  },

  // Central Energy Module
  centralEnergy: {
    mode: 'Modus',
    heatPumpTypeRequired: 'Jede Wärmepumpe benötigt einen Wärmepumpentyp',
    heatPumpNominalLoadRequired:
      'Jede Wärmepumpe benötigt eine Nennlast größer als 0',
    heatPumpMinimumLoadRequired:
      'Jede Wärmepumpe benötigt eine Mindestlast größer als 0',
    combustionBoilerTypeRequired:
      'Jeder Verbrennungskessel benötigt einen Kesseltyp',
    combustionBoilerFuelSourceRequired:
      'Jeder Verbrennungskessel benötigt eine Brennstoffquelle',
    fillRequiredFields: 'Füllen Sie alle Pflichtfelder aus',
    requiredFieldsNotSaved:
      'Änderungen werden erst gespeichert, wenn alle Pflichtfelder ausgefüllt sind',
    solarThermalSolarTypeRequired:
      'Jede Solarthermie-Quelle benötigt einen Kollektortyp',
    solarThermalCollectorAreaRequired:
      'Jede Solarthermie-Quelle benötigt eine Kollektorfläche größer als 0',
    otherSourceMaxCapacityRequired:
      'Jede andere Quelle benötigt eine maximale Leistung größer als 0',
    otherSourceEfficiencyRequired:
      'Jede andere Quelle benötigt einen Wirkungsgrad größer als 0',
    heatingAndHotWater: 'Heizung und Warmwasser',
    thermalZone: 'Wärmezone',
    thermalZoneHelp: 'Mit Wärmezone für Umgebungstemperatur verknüpfen',
    noZone: 'Keine (eigenständig)',
    selectZone: 'Zone auswählen...',
    ambientTemperature: 'Umgebungstemperatur',
    ambientTempHelp:
      'Temperatur um das Modul wenn nicht mit einer Zone verknüpft',
    moduleName: 'Zentrales Energiemodul',
    deleteModule: 'Zentrales Energiemodul löschen',
    confirmDelete:
      'Dieses zentrale Energiemodul und alle Energiequellen löschen?',
    notLinkedWarning:
      'Dieses Modul ist mit keiner Anlage verknüpft. Fügen Sie es als Energiequelle in Heizung/Kühlung, Lüftung, Warmwasser oder Produktionsanlage hinzu.',
    notLinkedListWarning:
      '{name} ist mit keiner Anlage verknüpft. Fügen Sie es als Energiequelle hinzu, um es zu verwenden.',
    notesAttachments: 'Notizen und Anhänge',
    energySources: 'Energiequellen',
    tanks: 'Tanks',
    performance: 'Wirkungsgrad',

    // Accumulation tanks
    accumulationTanks: 'Pufferspeicher',
    addTank: 'Tank hinzufügen',
    confirmDeleteTank: 'Diesen Pufferspeicher löschen?',
    noTanks:
      'Keine Pufferspeicher konfiguriert. Klicken Sie, um einen hinzuzufügen.',
    dhwTank: 'TWW (Trinkwarmwasser)',
    heatingTank: 'Heizungspuffer',
    coolingTank: 'Kältespeicher',
    insulation: 'Dämmung',
    setpoint: 'Sollwert (°C)',
    maxTemp: 'Max Temp (°C)',
    minTemp: 'Min Temp (°C)',
    heatLoss: 'Wärmeverlust (W/K)',

    // Electric boiler insulation (Table J.2)
    boilerInsulation: 'Isolierungsgrad Kessel',
    boilerInsulationVeryLow: 'Sehr schlecht isoliert',
    selectBoilerInsulation: 'Isolierung wählen...',

    // Energy source configuration
    energySourceConfig: 'Energiequellenkonfiguration',
    sourceType: 'Energiequellentyp',
    selectType: 'Energiequellentyp auswählen...',
    sourceName: 'Energiequellenname',
    usage: 'Verwendung',
    dhw: 'TWW',
    addToList: 'Zur Liste hinzufügen',

    // Priority list
    priorityList: 'Prioritätsliste',
    dragToReorder: 'Klicken zum Bearbeiten. Ziehen zum Umordnen',
    clickToEdit: 'Quelle anklicken zum Bearbeiten',
    confirmDeleteSource: 'Diese Energiequelle löschen?',
    noPrioritySources: 'Noch keine Energiequellen hinzugefügt',
    noSources:
      'Noch keine Energiequellen hinzugefügt. Verwenden Sie das Formular oben, um Quellen hinzuzufügen.',

    // Energy source types
    districtHeating: 'Fernwärme',
    combustionBoiler: 'Verbrennungskessel',
    electricBoiler: 'Elektrokessel',
    otherSource: 'Andere Quelle',

    // Heat pump fields
    heatPumpType: 'Wärmepumpentyp',
    airToAir: 'Luft-Luft',
    airToWater: 'Luft-Wasser',
    liquidToWater: 'Sole-Wasser',
    heatingCapacity: 'Heizleistung (kW)',
    liquidSource: 'Wärmequelle',
    selectSource: 'Quelle auswählen...',
    freshWater: 'Süßwasser',
    seaWater: 'Meerwasser',
    sourceTemp: 'Quellentemperatur (°C)',
    avgYearlyTemp: 'Durchschn. Jahrestemperatur (°C)',
    maxTemperatureSupplied: 'Maximal gelieferte Temperatur (°C)',
    SourceTempeAmplitude: 'Temperaturvariation der Wärmequelle (°C)',
    energyWellDimensioning: 'Nutzung und Dimensionierung der Erdwärmesonde',
    energyWellHeatingOnlyUndersized:
      'Nur Heizung (Wärmeentnahme), etwas unterdimensionierte Erdwärmesonde',
    energyWellHeatingOnlyGood:
      'Nur Heizung (Wärmeentnahme), gut dimensionierte Erdwärmesonde',
    energyWellSomeCoolingUndersized:
      'Heizung und etwas Kühlung, etwas unterdimensionierte Erdwärmesonde',
    energyWellSomeCoolingGood:
      'Heizung und etwas Kühlung, gut dimensionierte Erdwärmesonde',
    energyWellBalancedUndersized:
      'Ausgeglichene Heizung und Kühlung, etwas unterdimensionierte Erdwärmesonde',
    energyWellBalancedGood:
      'Ausgeglichene Heizung und Kühlung, gut dimensionierte Erdwärmesonde',
    highestSourceTemperature: 'Höchste gelieferte Quellentemperatur (°C)',
    waterSourceDepth: 'Tiefe der Wärmeentnahme im Meer/Wasser',
    CO2EmissionFactor: 'CO₂-Emissionsfaktor (g/kWh)',

    // District heating / Electric boiler / Other source fields
    maxCapacity: 'Max Kapazität (kW)',
    energyPrice: 'Energiepreis (pro kWh)',
    temperatureFromSource: 'Temperatur aus der Quelle (°C)',
    // Combustion boiler fields
    boilerType: 'Kesseltyp',
    biomass: 'Biomasse',
    fuelSource: 'Brennstoffquelle',
    otherFuelSource: 'Sonstiges',
    fuelType: 'Brennstofftyp',
    flueGasCondensation: 'Abgaskondensation',
    fuelConfig: 'Brennstoffkonfiguration',
    fuelEnergyContent: 'Energiegehalt (kWh/L)',
    efficiencyLowLoad: 'Leistung bei 30% Last (kW)',
    effectFullLoad: 'Leistung bei Volllast (kW)',
    isCondensing: 'Brennwertkessel',
    operatingSchedule: 'Betriebszeitplan',
    startDate: 'Start (Tag/Monat)',
    endDate: 'Ende (Tag/Monat)',
    startOfDay: 'Startstunde',
    endOfDay: 'Endstunde',
    seasonalMeanTemp: 'Saisonale Durchschnittstemperatur (°C)',

    // Solar thermal fields
    solarType: 'Solartyp',
    vacuumTube: 'Vakuumröhre',
    flatPlate: 'Flachkollektor',
    tilt: 'Neigung (°)',
    area: 'Gesamtfläche (m²)',
    collectorArea: 'Kollektorfläche (m²)',
    pipeLength: 'Rohrlänge (m)',
    pipeUValue: 'Rohr-U-Wert (W/mK)',
    collectorSpecs: 'Kollektorspezifikationen',
    efficiencyNormal: 'Wirkungsgrad η₀',
    heatLossLinear: 'Wärmeverlust a₁ (W/m²K)',
    heatLossSecond: 'Wärmeverlust a₂ (W/m²K²)',
    opticalEfficiency: 'Optischer Wirkungsgrad',
    heatLossCoeff: 'Wärmeverlustkoeffizient',
    shadingWinter: 'Verschattungsfaktor Winter',
    shadingSummer: 'Verschattungsfaktor Sommer',
    adjustmentFactor: 'Korrekturfaktor',
    tankSpiralPlacementFactor: 'Platzierungsfaktor der Speicherwendel',
    temperatureColdWater: 'Kaltwassertemperatur (°C)',
    temperatureInCollectionTank: 'Temperatur im Speichertank (°C)',
    percentageOfCollectorLoopOutside:
      'Anteil des Kollektorkreises im Außenbereich (%)',
    snowCoverageMonths: 'Schneebedeckte Monate',
    selectMonths: 'Monate auswählen...',
    insulationFactorForCollectionLoop:
      'Isolationsfaktor für den Kollektorkreis',
    selectInsulationFactorForCollectionLoop: 'Isolationsfaktor auswählen...',

    // District heating tables O.1, O.2, O.3
    heatExchangerInsulation: 'Wärmetauscher-Isolierung',
    selectHeatExchangerInsulation: 'Isolierung wählen...',
    outletTemperatureRange: 'Auslasstemperaturbereich',
    selectOutletTempRange: 'Bereich wählen...',
    outletTempLow: '≤ 50 °C',
    outletTempMedium: '50–70 °C',
    outletTempHigh: '≥ 70 °C',
    bdhCoefficient: 'Wärmetauscherverlust',
    bdhValue: 'Verlustkoeffizient',
    supplyTemperatureRange: 'Vorlauftemperaturbereich',
    selectSupplyTempRange: 'Bereich wählen...',
    supplyTempHigh: '≥ 150 °C',
    supplyTempMedium: '105–150 °C',
    supplyTempLow: '≤ 105 °C',
    ddhCoefficient: 'Verteilungswärmeverlust',
    ddhValue: 'Verlustkoeffizient',
    coolingHeatExchangerInsulation: 'Kühlwärmetauscher-Isolierung',
    selectCoolingHxInsulation: 'Isolierung wählen...',
    coolingHeatExchangerUValue: 'Kühlwärmetauscher',
    coolingHxUValue: 'U-Wert (W/m²K)',

    // CHP tables Q.1, Q.2
    isCHP: 'Kraft-Wärme-Kopplung (KWK)',
    chpSettings: 'KWK-Einstellungen',
    chpFuelType: 'KWK Brennstoffart',
    selectChpFuelType: 'Brennstoffart wählen...',
    chpSolidFuel: 'Festbrennstoff',
    chpLiquidFuel: 'Flüssigbrennstoff',
    chpGas: 'Gas',
    chpPerformanceLevel: 'Leistungsstufe',
    selectChpPerformance: 'Leistung wählen...',
    chpThermalEfficiency: 'Thermischer Wirkungsgrad (%)',
    chpElectricalEfficiency: 'Elektrischer Wirkungsgrad (%)',
    chpTotalEfficiency: 'Gesamtwirkungsgrad (%)',
    chpBoilerType: 'KWK Kesseltyp',
    selectChpBoilerType: 'Kesseltyp wählen...',
    chpBiopellets: 'Biopellets',
    chpWoodChips: 'Holzhackschnitzel',
    gasOrOilBoiler: 'Gas- oder Ölkessel',
    chpC7: 'C\u2087',
    chpC8: 'C\u2088',
    chpN: 'n',

    // Solar thermal pipe insulation table H.2
    pipeInsulationType: 'Rohrisolierungstyp',
    selectPipeInsulation: 'Isolierung wählen...',
  },

  // Excess Energy Module
  excessEnergy: {
    eligibleForHarvesting: 'Berechtigt zur Energierückgewinnung',
    eligibleForHarvestingHelp:
      'Dieses Modul als berechtigt zur Überschussenergierückgewinnung markieren',

    // Duct dimensions
    ductDimensions: 'Kanalabmessungen',
    ductShape: 'Kanalform',
    diameter: 'Durchmesser (mm)',
    width: 'Breite (mm)',
    height: 'Höhe (mm)',
    airspeed: 'Luftgeschwindigkeit (m/s)',

    // Flow properties
    flowProperties: 'Strömungseigenschaften',
    temperature: 'Ablufttemperatur (C)',
    volumeFlow: 'Volumenstrom',
    volumeFlowAir: 'Volumenstrom (m³/h)',
    volumeFlowLiquid: 'Volumenstrom (L/h)',

    // Delete
    deleteModule: 'Überschussenergiemodul löschen',
    confirmDelete: 'Dieses Überschussenergiemodul löschen?',
    noModuleFound: 'Kein Überschussenergiemodul gefunden',
  },

  // Solar PV Module
  solarPv: {
    soilingFactors: 'Verschmutzungsfaktoren (\u03C6_soil)',
    panelProperties: 'Paneleigenschaften',
    lossesCoefficients: 'Verluste und Koeffizienten',
    panelAngle: 'Panelwinkel',
    tiltRange: 'Neigungsbereich: {range}°',
    angleOutOfRange: 'Winkel außerhalb des Bereichs',
    selectLocation: 'Standort auswählen...',
    usingStandardTable:
      'Verwendung der {standard} Tabelle für Neigungsbereich {range}°',
    selectCellType: 'Zellentyp auswählen...',
    nominalEfficiency: 'Nennwirkungsgrad (0-1)',
    panelAzimuth: 'Panel-Azimut (0-360°)',
    shadingFactor: 'Verschattungsfaktor (0-1)',
    mountingType: 'Montagetyp',
    selectMountingType: 'Montagetyp auswählen...',
    windExposure: 'Windexposition',
    selectWindExposure: 'Windexposition auswählen...',
    heatLossFactor: 'Wärmeverlustfaktor (W/m²K)',
    inverterEfficiency: 'Wechselrichterwirkungsgrad (0-1)',
    degradationLoss: 'Degradationsverlust (0-1)',
    inverterLoss: 'Wechselrichterverlust (0-1)',
    transmissionProduct: 'Transmissionsprodukt (0-1)',
    temperatureCoefficient: 'Temperaturkoeffizient (%/°C)',
    incidentAngleModifier: 'Einfallswinkelmodifikator (0-1)',
    deleteModule: 'Photovoltaikmodul löschen',
    confirmDelete: 'Dieses Photovoltaikmodul löschen?',
  },

  // Battery edit page
  battery: {
    annualSimOnly:
      'Batterien werden derzeit nur in Jahressimulationen berücksichtigt. In die Berechnung des Energielabels fließen sie noch nicht ein.',
    maxCapacity: 'Max. Kapazität (kWh)',
    maxChargePower: 'Max. Ladeleistung (kW)',
    maxDischargePower: 'Max. Entladeleistung (kW)',
    chargeEfficiency: 'Ladewirkungsgrad (0-1)',
    dischargeEfficiency: 'Entladewirkungsgrad (0-1)',
    minStateOfCharge: 'Minimaler Ladezustand (0-1)',
    maxStateOfCharge: 'Maximaler Ladezustand (0-1)',
    peakShavingThreshold: 'Schwelle für Lastspitzenkappung (kW)',
    preChargeStateOfCharge: 'Ladezustand für Vorladung (0-1)',
    maxCapacityRequired: 'Eine max. Kapazität größer als 0 ist erforderlich',
    maxChargePowerRequired:
      'Eine max. Ladeleistung größer als 0 ist erforderlich',
    maxDischargePowerRequired:
      'Eine max. Entladeleistung größer als 0 ist erforderlich',
    deleteBattery: 'Batterie löschen',
    confirmDelete: 'Diese Batterie löschen?',
  },

  // HVAC system type options
  hvacSystemTypes: {
    balanced: 'Ausgeglichen',
    exhaust: 'Abluft',
    supply: 'Zuluft',
  },

  // HVAC edit page
  hvac: {
    deleteUnit: 'HLK-Einheit löschen',
    confirmDelete: 'Diese HLK-Einheit löschen?',
    heatRecoveryShort: 'Wärmerückgewinnung',
    airVolumeShort: 'Luftvolumen',
    addDxSystem: 'DX-System hinzufügen',
    confirmDeleteDxSystem: 'Dieses DX-System löschen?',
    addHeatingBattery: 'Heizregister hinzufügen',
    confirmDeleteHeatingBattery: 'Dieses Heizregister löschen?',
    addCoolingBattery: 'Kühlregister hinzufügen',
    confirmDeleteCoolingBattery: 'Dieses Kühlregister löschen?',

    // Section headers
    namePlaceholder: 'Name des Lüftungsgeräts',
    dxSystemNamePlaceholder: 'Name des DX-Systems',
    batteryNamePlaceholder: 'Name des Registers',
    flowSfpSettings: 'Volumenstrom und SFP-Einstellungen',
    temperatureMeasurements: 'Temperaturmessungen',
    dxSystems: 'DX (Direktverdampfung)',
    heatingBatteries: 'Heizregister',
    coolingBatteries: 'Kühlregister',
    naturalVentilation: 'Natürliche Lüftung',

    // SFP fields
    sfpCalculationMethod: 'SFP-Berechnungsmethode',
    sfpAsFunction: 'Spezifische Ventilatorleistung',
    yearBands: {
      pre1985: 'Vor 1985',
      '1985to1995': '1985 bis 1995',
      '1995to2005': '1995 bis 2005',
      '2005to2013': '2005 bis 2013',
      '2013to2020': '2013 bis 2020',
      from2020: '2020 und neuer',
    },
    suggestions: {
      yearHelp:
        'Das Einbaujahr des Lüftungsgeräts. Es bestimmt den typischen Motortyp, SFP und die Wärmerückgewinnung der Periode.',
      hintLabel: 'Vorschlag',
      calculatedLabel: 'Berechnet',
      apply: 'Übernehmen',
      applyAll: '({count}) Vorschläge übernehmen',
      noSuggestions: 'Keine Vorschläge',
      applyAllHelp: 'Alle vorgeschlagenen Werte auf dieser Seite übernehmen.',
    },

    // Flow fields
    fanPower: 'Ventilatorleistung',
    coverage: 'Abdeckung',
    fanPowerIn: 'Ventilatorleistung Zuluft (kW)',
    fanPowerOut: 'Ventilatorleistung Abluft (kW)',
    supplyAirVolume: 'Supply Air Volume',
    airVolumeOperating: 'Operating (m³/h)',
    airVolumeCapacity: 'Capacity (m³/h)',
    airVolumeNonOperating: 'Non-Operating (m³/h)',
    extractionAirVolume: 'Extraction Air Volume',
    airVolumeExtractionOperating: 'Operating (m³/h)',
    airVolumeExtractionCapacity: 'Capacity (m³/h)',
    airVolumeExtractionNonOperating: 'Non-Operating (m³/h)',

    // Heat recovery
    heatRecoveryType: 'Wärmerückgewinnungstyp',
    efficiencyHR: 'Wirkungsgrad WRG (%)',
    frostProtection: 'Frostschutz',
    frostProtectionTemperature: 'Frostschutztemperatur (°C)',

    // Temperature
    measuredSupplyTemp: 'Gemessene Zulufttemp. (°C)',
    measuredExhaustTemp: 'Gemessene Ablufttemp. (°C)',

    // DX System
    dxSystem: 'DX-System',
    dxType: 'Typ',

    // Battery fields
    heatingBattery: 'Heizregister',
    coolingBattery: 'Kühlregister',
    batteryType: 'Typ',

    // Priority lists
    heatingPriorityList: 'Heizpriorität',
    coolingPriorityList: 'Kühlpriorität',
    priorityListHelp: 'Ziehen, um die Priorität für Berechnungen zu ändern',
    noPriorityItems: 'Keine Elemente konfiguriert',

    // zone linking
    linkedZones: 'Verknüpfte Zonen',
    noLinkedZones: 'Keine Zonen verknüpft',
    manageZones: 'Zonen verwalten',
    useZoneMap: 'Zonenkarte verwenden',
    linkZonesTitle: 'Thermische Zonen verknüpfen',
    noZonesAvailable: 'Keine thermischen Zonen verfügbar',
    zonesLinked: 'Zonen erfolgreich verknüpft',
    noZoneWarning:
      'Diese HLK-Einheit ist nicht mit einer thermischen Zone verknüpft.',
    noZoneListWarning: '{name} ist nicht mit einer thermischen Zone verknüpft.',
    sfp100Required: 'Ein SFP @ 100 % größer als 0 ist erforderlich',
    airVolumeOperatingRequired:
      'Ein Zuluftvolumen im Betrieb größer als 0 ist erforderlich',
    airVolumeCapacityRequired:
      'Eine Zuluftkapazität größer als 0 ist erforderlich',
    airVolumeExtractionOperatingRequired:
      'Ein Abluftvolumen im Betrieb größer als 0 ist erforderlich',
    dxEnergySourceRequired: 'Jedes DX-System benötigt eine Energiequelle',
    dxSystemEfficiencyRequired:
      'Jedes DX-System benötigt einen Systemwirkungsgrad größer als 0',
    heatingBatteryPowerRequired:
      'Jedes Heizregister benötigt eine Leistung größer als 0',
    heatingBatterySystemEfficiencyRequired:
      'Jedes Heizregister benötigt einen Systemwirkungsgrad größer als 0',
    heatingBatteryEnergySourceRequired:
      'Jedes Heizregister benötigt eine Energiequelle',
    coolingBatteryPowerRequired:
      'Jedes Kühlregister benötigt eine Leistung größer als 0',
    coolingBatterySystemEfficiencyRequired:
      'Jedes Kühlregister benötigt einen Systemwirkungsgrad größer als 0',
    coolingBatteryEnergySourceRequired:
      'Jedes Kühlregister benötigt eine Energiequelle',

    supplementaryFactor: 'Zusatzfaktor',

    motorType: 'Motortyp',
    motorTypes: {
      none: 'Keine',
      belt: 'Riemenantrieb',
      axial: 'Axialventilator',
      EC: 'EC-Motor',
      AC: 'AC-Motor',
      DC: 'DC-Motor',
      VSD: 'Frequenzumrichter (VSD)',
      other: 'Sonstige',
    },

    dxTypes: {
      cooling: 'Nur Kühlung',
      heating: 'Nur Heizung',
      both: 'Heizen und Kühlen',
    },

    flowTypes: {
      variable: 'Variabler Volumenstrom',
      constant: 'CAV, konstanter Volumenstrom',
      optimal: 'DCV, bedarfsgeführt',
    },

    batteryTypes: {
      water: 'Wasser',
      electric: 'Elektrisch',
      heatPump: 'Wärmepumpe',
      other: 'Sonstige',
    },

    heatRecoveryTypes: {
      rotaryWheel: 'Rotationswärmetauscher',
      crossFlow: 'Kreuzstrom-Plattenwärmetauscher',
      plateCounterflow: 'Gegenstrom-Plattenwärmetauscher',
      runAroundCoil: 'Kreislaufverbundsystem',
      heatPipe: 'Wärmerohr',
      none: 'Keine',
    },
  },

  // Exterior wall edit page
  exteriorWall: {
    namePlaceholder: 'Wandname',
    direction: 'Richtung',
    type: 'Wandtyp',
    shadingFactor: 'Verschattungsfaktor',
    deleteWall: 'Wand löschen',
    confirmDelete: 'Diese Wand löschen?',
    directionRequired: 'Bitte wählen Sie eine Wandrichtung',
    areaRequired: 'Eine Wandfläche größer als 0 ist erforderlich',
    uValueRequired: 'Ein U-Wert größer als 0 ist erforderlich',
    windowsExceedArea: 'Die Gesamtfensterfläche überschreitet die Wandfläche.',
    doorsExceedArea: 'Die Gesamttürfläche überschreitet die Wandfläche.',
    gatesExceedArea: 'Die Gesamttorfläche überschreitet die Wandfläche.',
    combinedExceedArea:
      'Die Gesamtfläche von Fenstern, Türen und Toren überschreitet die Wandfläche.',
    windowsExceedAreaList:
      '{name}: die Gesamtfensterfläche überschreitet die Wandfläche.',
    doorsExceedAreaList:
      '{name}: die Gesamttürfläche überschreitet die Wandfläche.',
    gatesExceedAreaList:
      '{name}: die Gesamttorfläche überschreitet die Wandfläche.',
    combinedExceedAreaList:
      '{name}: die Gesamtfläche von Fenstern, Türen und Toren überschreitet die Wandfläche.',
    options: {
      custom: 'Benutzerdefiniert',
      standard: 'Standard',
      timberFrame36_150: 'Holzrahmen 36mm, 150mm Dämmung',
      timberFrame36_200: 'Holzrahmen 36mm, 200mm Dämmung',
      timberFrame36_250: 'Holzrahmen 36mm, 250mm Dämmung',
      timberFrame48_150: 'Holzrahmen 48mm, 150mm Dämmung',
      timberFrame48_200: 'Holzrahmen 48mm, 200mm Dämmung',
      timberFrame48_250: 'Holzrahmen 48mm, 250mm Dämmung',
      epsBlock310: 'EPS-Block 310mm (140mm Betonkern)',
      epsBlock370: 'EPS-Block 370mm (140mm Betonkern)',
      epsBlock430: 'EPS-Block 430mm (140mm Betonkern)',
      iProfile200: 'I-Profil Stahlrahmen, 200mm Dämmung',
      iProfile300: 'I-Profil Stahlrahmen, 300mm Dämmung',
      iProfile400: 'I-Profil Stahlrahmen, 400mm Dämmung',
      lwaBlock250: 'Leichtbetonblock (Isoblokk) 250mm',
      lwaBlock300: 'Leichtbetonblock (Isoblokk) 300mm',
      lwaBlock350: 'Leichtbetonblock (Isoblokk) 350mm',
      slottedSteel200: 'Geschlitzter Stahl, 200mm Dämmung',
      slottedSteel250: 'Geschlitzter Stahl, 250mm Dämmung',
      slottedSteel300: 'Geschlitzter Stahl, 300mm Dämmung',
      unslottedSteel200: 'Ungeschlitzter Stahl, 200mm Dämmung',
      unslottedSteel250: 'Ungeschlitzter Stahl, 250mm Dämmung',
      unslottedSteel300: 'Ungeschlitzter Stahl, 300mm Dämmung',
    },
  },

  // Building types (NS 3031 categories)
  buildingTypes: {
    label: {
      smallHouse: 'Kleinhaus',
      apartmentBlock: 'Mehrfamilienhaus',
      kindergarten: 'Kindergarten',
      officeBuilding: 'Büro',
      schoolBuilding: 'Schule',
      universityCollege: 'Universität/Hochschule',
      hospital: 'Krankenhaus',
      nursingHome: 'Pflegeheim',
      hotelBuilding: 'Hotel',
      sportsBuilding: 'Sportanlage',
      commercialBuilding: 'Gewerbe',
      culturalBuilding: 'Kultur',
      lightIndustry: 'Leichtindustrie/Lager',
    },
    description: {
      smallHouse:
        'Einfamilienhaus, Doppelhaus, Reihenhaus, Kettenhaus oder andere kleine Wohngebäude.',
      apartmentBlock: 'Wohnblock mit zwei oder mehr Stockwerken.',
      kindergarten: 'Gebäude für Kindergarten oder frühkindliche Bildung.',
      officeBuilding:
        'Einfache Büros, klimatisierte Büros oder Ausstellungs-/Kongressgebäude.',
      schoolBuilding:
        'Unterrichtsräume, einschließlich Schulen mit Schwimmbad oder Sporthalle.',
      universityCollege:
        'Universitäts- oder Hochschulgebäude, Laborgebäude oder Forschungseinrichtungen.',
      hospital:
        'Krankenhäuser, Krankenhaushotels oder medizinische Laborgebäude.',
      nursingHome: 'Pflegeheimgebäude für Langzeitpflege.',
      hotelBuilding:
        'Hotels, Restaurantgebäude oder andere Beherbergungsbetriebe.',
      sportsBuilding:
        'Sporthallen, Schwimmbäder und andere Sportanlagen mit Duschbereichen.',
      commercialBuilding:
        'Geschäfte, Läden mit Kühl-/Gefrierräumen oder Tankstellen.',
      culturalBuilding: 'Kinos, Museen, Bibliotheken und religiöse Gebäude.',
      lightIndustry:
        'Industriegebäude, Lagerhallen, landwirtschaftliche Gebäude oder andere Werkstätten.',
    },
  },

  buildingSubcategories: {
    1: 'Einfamilienhaus',
    2: 'Einfamilienhaus mit Mieteinheit',
    3: 'Doppelhaushälfte (horizontal)',
    4: 'Doppelhaushälfte (vertikal)',
    5: 'Vierfamilienhaus',
    6: 'Kettenhaus',
    7: 'Reihenhaus',
    8: 'Ferienhaus',
    9: 'Sonstiges Kleinhaus',
    10: 'Wohnung',
    11: 'Sonstige Wohngebäude',
    12: 'Kindergartengebäude',
    13: 'Einfache Büros',
    14: 'Büros mit Lüftung und Kühlung',
    15: 'Messe-/Kongressgebäude',
    16: 'Sonstiges Bürogebäude',
    17: 'Unterrichtsräume',
    18: 'Schule mit Schwimmanlage',
    19: 'Schule mit Sporthalle',
    20: 'Schulgebäude',
    21: 'Laborgebäude',
    22: 'Sonstiges Forschungsgebäude',
    23: 'Krankenhaus',
    24: 'Krankenhaushotel',
    25: 'Krankenhauslabor',
    26: 'Pflegeheim',
    27: 'Hotelgebäude',
    28: 'Übernachtungsgebäude',
    29: 'Restaurantgebäude',
    30: 'Sonstiges Hotelgebäude',
    31: 'Sporthalle',
    32: 'Sporthalle mit Duschanlage',
    33: 'Sporthalle mit Schwimmanlage',
    34: 'Geschäft',
    35: 'Geschäft mit Kühlraum',
    36: 'Tankstelle',
    37: 'Kulturgebäude',
    38: 'Kino',
    39: 'Museum/Bibliothek',
    40: 'Gebäude für religiöse Aktivitäten',
    41: 'Industriegebäude',
    42: 'Energieversorgungsgebäude',
    43: 'Lagergebäude',
    44: 'Fischerei-/Landwirtschaftsgebäude',
    45: 'Sonstige Industrie',
  },

  thermalZones: {
    schedule: {
      heatingSchedule: 'Heizungsplan',
      coolingSchedule: 'Kühlungsplan',
      addHeatingSchedule: 'Heizplan hinzufügen',
      addCoolingSchedule: 'Kühlplan hinzufügen',
    },
    yearPeriods: {
      TEK50: 'Vor 1969',
      TEK70: '1970 - 1979',
      TEK80: '1980 - 1986',
      TEK87: '1987 - 1996',
      TEK97: '1997 - 2006',
      TEK07: '2007 - 2009',
      TEK10: '2010 - 2016',
      TEK17: '2017 und später',
    },
    hasFloorToGround: 'Zone hat Boden gegen Erdreich',
    hasRoof: 'Zone hat Dach',
    isBasement: 'Zone ist ein Keller',
    floor: {
      type: 'Typ Boden gegen Erdreich',
      area: 'Boden gegen Erdreich (m²)',
      options: {
        custom: 'Benutzerdefiniert',
        standard: 'Standard',
        tiles: 'Fliesen auf Beton',
        parquetChipBoard: 'Parkett auf Spanplatte',
        carpetConcrete: 'Teppich auf Beton',
      },
    },
    roof: {
      type: 'Dachtyp',
      optionsTitle: 'Dachkonstruktion',
      angle: 'Dachneigung',
      hasWindows: 'Dach hat Fenster',
      areaRequired: 'Eine Dachfläche größer als 0 ist erforderlich',
      windowArea: 'Fensterfläche (m²)',
      glassType: 'Glastyp',
      pitchTypes: {
        flat: 'Flachdach',
        lowSlope: 'Geringe Neigung',
        gentlePitch: 'Leichte Neigung',
        standardPitch: 'Standardneigung',
        steepPitch: 'Steile Neigung',
        verySteepPitch: 'Sehr steile Neigung',
      },
      options: {
        custom: 'Benutzerdefiniert',
        standard: 'Standard',
        compactConcrete200: 'Flachdach, Beton, 200mm Dämmung',
        compactConcrete300: 'Flachdach, Beton, 300mm Dämmung',
        compactConcrete400: 'Flachdach, Beton, 400mm Dämmung',
        compactSteel200: 'Flachdach, Stahl, 200mm Dämmung',
        compactSteel300: 'Flachdach, Stahl, 300mm Dämmung',
        compactSteel400: 'Flachdach, Stahl, 400mm Dämmung',
        pitched48mm200: 'Schrägdach, 48mm Sparren, 200mm Dämmung',
        pitched48mm300: 'Schrägdach, 48mm Sparren, 300mm Dämmung',
        pitched48mm400: 'Schrägdach, 48mm Sparren, 400mm Dämmung',
        pitchedIBeam200: 'Schrägdach, I-Träger, 200mm Dämmung',
        pitchedIBeam300: 'Schrägdach, I-Träger, 300mm Dämmung',
        pitchedIBeam450: 'Schrägdach, I-Träger, 450mm Dämmung',
        coldAttic200: 'Kaltdach, 200mm Dämmung',
        coldAttic300: 'Kaltdach, 300mm Dämmung',
        coldAttic450: 'Kaltdach, 450mm Dämmung',
      },
    },
    basement: {
      dimensions: 'Abmessungen',
      area: 'Bodenfläche gegen Erdreich (m²)',
      wallPerimeter: 'Erdberührter Wandumfang (m)',
      fillHeight: 'Tiefe unter Gelände (m)',
      wallThickness: 'Wandstärke (m)',
      wallConstruction: 'Kellerwand',
      wallConstructionType: 'Wandtyp',
      wallUValue: 'U-Wert Wand (W/m²K)',
      floorConstruction: 'Kellerboden',
      floorConstructionType: 'Bodentyp',
      floorUValue: 'U-Wert Boden (W/m²K)',
      intro:
        'Denken Sie daran, den Boden gegen Erdreich der darüberliegenden Zone um die Kellerfläche zu verringern.',
      floorConstructionOptions: {
        none: 'Keine',
        standard: 'Standard',
        concrete100: 'Beton auf Grund mit 100mm Dämmung',
        concrete150: 'Beton auf Grund mit 150mm Dämmung',
        concrete200: 'Beton auf Grund mit 200mm Dämmung',
        concrete250: 'Beton auf Grund mit 250mm Dämmung',
        concrete300: 'Beton auf Grund mit 300mm Dämmung',
        concrete350: 'Beton auf Grund mit 350mm Dämmung',
        concrete400: 'Beton auf Grund mit 400mm Dämmung',
        wood200: 'Holzbalkendecke mit 200mm Dämmung',
        wood250: 'Holzbalkendecke mit 250mm Dämmung',
        wood300: 'Holzbalkendecke mit 300mm Dämmung',
      },
    },
    groundConditions: {
      type: 'Bodentyp',
      thermalConductivity: 'Wärmeleitfähigkeit λ (W/(m·K))',
      heatCapacity: 'Wärmekapazität Cv (Wh/(m³·K))',
      penetrationDepth: 'Periodische Eindringtiefe δ (m)',
      options: {
        clay: 'Ton/Schluff',
        sand: 'Sand/Kies',
        rock: 'Fels',
      },
    },
    thermalMass: {
      buildingHeatCapacity: 'Zonen-Wärmekapazität',
      heatCapacityCategory: 'Wärmekapazitätskategorie',
      normalizedHeatCapacity: 'Normalisierte Wärmekapazität (Wh/m²K)',
      interiorWalls: 'Innenwände',
      cladding: 'Verkleidung',
      heatCapacity: 'Wärmekapazität (Wh/m²K)',
      furniture: 'Möbel',
      furnitureGrade: 'Möbelgrad',
      massFactor: 'Massefaktor (Wh/m²K)',
      heatCapacityCategoryRequired:
        'Bitte wählen Sie eine Wärmekapazitätskategorie',
      claddingRequired: 'Bitte wählen Sie einen Verkleidungstyp',
      furnitureGradeRequired: 'Bitte wählen Sie einen Möbelgrad',
      labelFirstOption: 'Sehr leichte Zone',
      labelSecondOption: 'Leichte Zone',
      labelThirdOption: 'Mittelschwere Zone',
      labelFourthOption: 'Schwere Zone',
      labelFifthOption: 'Sehr schwere Zone',
      shortDescriptionFirstOption:
        'Leichte Balkendecke, dünner Bodenbelag, leichte Wände',
      shortDescriptionSecondOption:
        'Akustikdecke, Teppich über Beton, leichte Wände',
      shortDescriptionThirdOption:
        'Wenig freiliegender Beton (20%), Parkett über Beton',
      shortDescriptionFourthOption: 'Hauptsächlich freiliegender Beton (70%)',
      shortDescriptionFifthOption:
        'Freiliegender Beton in Decke, Wänden und Boden',
      claddingOptions: {
        custom: 'Benutzerdefiniert',
        standard: 'Standard',
        concrete100: '100mm (oder mehr) Beton',
        concrete80: '80mm Beton',
        aeratedConcrete: 'Porenbeton',
        gypsum13: 'Gips 13mm',
        lightBrick: 'Leichter Ziegel',
        lwa: 'Leichtzuschlag',
        solidWood40: 'Massivholz (Dicke über 40mm)',
        woodPanel15: 'Holzplatte 15mm',
        heavyBrick: 'Schwerer (kompakter) Ziegel',
      },
      furnitureOptions: {
        none: 'Keine',
        standard: 'Standard',
        light: 'Leicht',
        medium: 'Mittel',
        heavy: 'Schwer',
      },
    },
    airLeakage: {
      tekStandard: 'TEK-Standard',
      n50: 'Leckagewert n50 (h⁻¹)',
      tekOptions: {
        TEK50: 'Bauvorschrift 1950–1969',
        TEK70: 'Bauvorschrift 1970–1979',
        TEK80: 'Bauvorschrift 1980–1986',
        TEK87: 'TEK 87 (1987-1996)',
        TEK97: 'TEK 97 (1997-2006)',
        TEK07: 'TEK 07 (2007-2009)',
        TEK10: 'TEK 10 (2010-2016)',
        TEK17: 'TEK 17 (2017+)',
      },
    },
    windows: {
      deleteWindow: 'Fenster löschen',
      confirmDelete: 'Dieses Fenster löschen?',
      gValue: 'g-Wert',
      frameFraction: 'Rahmenanteil',
      shadingFactor: 'Verschattungsfaktor (0-1)',
      externalBlinds: 'Außenjalousien (gt)',
      externalBlindsGt: 'Außenjalousien gt',
      externalScreen: 'Außenmarkise (gt)',
      externalScreenGt: 'Außenmarkise gt',
      internalShading: 'Innenliegender Sonnenschutz (gt)',
      internalShadingGt: 'Innenliegender Sonnenschutz gt',
      windowTypes: {
        none: 'Keine',
        custom: 'Benutzerdefiniert',
        singleGlass: 'Einfachglas',
        twoLayerGlass: '2-Schicht-Glas',
        twoLayerEnergyGlass: '2-Schicht-Energieglas',
        twoLayerSolarReflective: '2-Schicht-Sonnenschutzglas',
        threeLayerEnergyGlass: '3-Schicht-Energieglas',
      },
    },
    doors: {
      deleteDoor: 'Tür löschen',
      confirmDelete: 'Diese Tür löschen?',
      type: 'Türtyp',
      doorTypes: {
        custom: 'Benutzerdefiniert',
        standard: 'Standard',
        insulated: 'Isoliert',
        normal: 'Normal',
        wellInsulated: 'Gut isoliert',
        uninsulated: 'Nicht isoliert',
      },
    },
    gates: {
      deleteGate: 'Tor löschen',
      confirmDelete: 'Dieses Tor löschen?',
      type: 'Tortyp',
      gateTypes: {
        custom: 'Benutzerdefiniert',
        standard: 'Standard',
        insulated: 'Isoliert',
        sectional: 'Sektionaltor',
        roller: 'Rolltor',
        wellInsulated: 'Gut isoliert',
      },
    },
    internalLoads: {
      internalLoadsNotice:
        'Diese Werte werden bei der Erstellung des Energielabels nicht verwendet. Nur die Präsenzkontrolle für die Beleuchtung wird berücksichtigt.',
      hotWater: 'Warmwasser',
      equipment: 'Technische Ausrüstung',
      occupancy: 'Personen',
      weekday: 'Wochentag (260 Tage)',
      weekend: 'Wochenende (105 Tage)',
      resetToStandards: 'Zurücksetzen auf',
      hourlyProfile: 'Stundenprofil',
      editHourlyValues: 'Stundenwerte bearbeiten',
      peak: 'Spitze',
      avg: 'Durchschn.',
      daily: 'Täglich',
      annual: 'Jährlich',
      appliances: 'Haushaltsgeräte',
      appliancesDescription:
        'Strombedarf senken durch Anschluss der Geräte an Warmwasser.',
      dishwasherLabel: 'Geschirrspüler (Warmwasser)',
      washingMachineLabel: 'Waschmaschine (Warmwasser)',
      tumbleDryerLabel: 'Wäschetrockner (Warmwasser)',
      applianceShareLabel: 'Thermischer Anteil [%]',
      heatGainShareLabel: 'Wärmeeintrag in Zone [1-100%]',
      lampTypes: 'Lampentypen',
      lampType: 'Lampentyp',
      selectLampType: 'Lampentyp auswählen',
      ballast: 'Vorschaltgerät',
      electronic: 'Elektronisch',
      electromechanical: 'Elektromechanisch',
      sharePercent: 'Anteil (%)',
      efficiencyFactorFL: 'Effizienzfaktor (FL)',
      lampTypeNames: {
        ledNew: 'LED ab 2016 und neuer',
        ledOld: 'LED von 2010–2015',
        fluorescentT5: 'Leuchtstoffröhre T5',
        fluorescentT8: 'Leuchtstoffröhre T8',
        metalHalide: 'Metallhalogenidlampe',
        highPressureSodium: 'Natriumhochdrucklampe',
        compactFluorescent: 'Kompaktleuchtstofflampe',
        halogen: 'Halogenlampe',
        incandescent: 'Glühlampe',
      },
      addLampType: 'Lampentyp hinzufügen',
      deleteLampType: 'Diesen Lampentyp löschen?',
    },
    heatingEmissionSystem: 'Wärmeabgabesystem',
    heatingEmissionSystems: {
      radiator_thermostat_80_60:
        'Heizkörper/Konvektor mit Thermostatventil oder lokaler Raumregler',
      radiator_thermostat_60_40:
        'Heizkörper/Konvektor mit Thermostatventil oder lokaler Raumregler',
      radiator_thermostat_40_35:
        'Heizkörper/Konvektor mit Thermostatventil oder lokaler Raumregler',
      radiator_sd_80_60: 'Heizkörper/Konvektor an GLT angeschlossen',
      radiator_sd_60_40: 'Heizkörper/Konvektor an GLT angeschlossen',
      radiator_sd_40_35: 'Heizkörper/Konvektor an GLT angeschlossen',
      fan_coil_heat_pump:
        'Ventilatorkonvektor / Wärmepumpe Inneneinheit / aktiver Kühlbalken / Heizung über Zuluft',
      floor_heating_thermostat:
        'Fußbodenheizung mit Thermostatventil oder lokaler Raumregler',
      floor_heating_sd: 'Fußbodenheizung an GLT angeschlossen',
      panel_heater_pre_2010: 'Paneelheizer – vor 2010',
      panel_heater_post_2010: 'Paneelheizer – nach 2010',
    },
    coolingEmissionSystem: 'Kälteabgabesystem',
    coolingEmissionSystems: {
      chilled_beam_thermostat:
        'Passiver Kühlbalken mit Thermostatventil oder lokaler Raumregler',
      chilled_beam_sd: 'Passiver Kühlbalken an GLT angeschlossen',
      fan_coil_cool_pump:
        'Aktiver Kühlbalken / Ventilatorkonvektor mit lokaler Raumregler',
      fan_coil_cool_pump_sd:
        'Aktiver Kühlbalken / Ventilatorkonvektor an GLT angeschlossen',
      floor_cooling_thermostat: 'Fußbodenkühlung mit lokaler Raumregler',
      floor_cooling_sd: 'Fußbodenkühlung an GLT angeschlossen',
      chilled_ceiling_thermostat: 'Kühldecke mit lokaler Raumregler',
      chilled_ceiling_sd: 'Kühldecke an GLT angeschlossen',
    },
    effectiveSetpoint: 'Effektiver Sollwert',
  },

  // Thermal Zone Links
  thermalZoneLinks: {
    linkZones: 'Zonen verknüpfen',
    resetLayout: 'Anordnung zurücksetzen',
    resetLayoutConfirm:
      'Kartenanordnung zurücksetzen? Alle Zonen kehren zur vorgeschlagenen Platzierung zurück.',
    confirmLink: 'Verknüpfung bestätigen',
    linkDialogTitle: 'Wärmezonen verknüpfen',
    linkingZones: 'Zonen verknüpfen',
    sourceZone: 'Quellzone',
    targetZones: 'Zielzonen',
    areaUnit: 'm²',
    uValueUnit: 'W/m²K',
    selectSourceFirst: 'Wählen Sie zuerst die Quellzone, dann die Zielzonen',
    minTwoZones: 'Wählen Sie mindestens 2 Zonen zum Verknüpfen',
    linkSuccess: 'Zonen erfolgreich verknüpft',
    externalZone: 'Externe Zone',
    zoneConnections: 'Zonenkopplung',
    addConnection: 'Kopplung hinzufügen',
    noConnections: 'Keine Zonenkopplungen',
    connectionDeleted: 'Kopplung entfernt',
    deleteConnectionError: 'Verbindung konnte nicht gelöscht werden',
    connectionAdded: 'Kopplung hinzugefügt',
    connectionUpdated: 'Kopplung aktualisiert',
    editConnection: 'Kopplung bearbeiten',
    deleteConnection: 'Kopplung löschen',
    confirmDeleteConnection: 'Zonenkopplung entfernen?',
    connectToExisting: 'Bestehende Zone',
    connectToExternal: 'Externe Zone',
    chooseConnectionType: 'Verbinden mit',
    zoneMap: 'Zonenkarte',
    zoneMapEmpty: 'Keine Zonenverbindungen',
    notLinked: 'Nicht verbunden',
    autoLinked: 'Automatisch verbunden',
    linkModeHintSource: 'Quellzone anklicken',
    linkModeHintTarget: 'Zielzone anklicken oder externe Zone wählen',
    deleteModeHint:
      'Klicken Sie auf die Zone, deren Verbindungen Sie löschen möchten',
    ventilation: 'Lüftung',
    zoneMapSubtitle: 'Verschieben Sie die Zonen, um die Anordnung anzupassen.',
    noVentilationUnits: 'Keine Lüftungsgeräte verfügbar',
    noHeatingCoolingModules: 'Keine Heizung oder Kühlung verfügbar',
    linkAny: 'Verbinden',
    linkModeHintSourceAny: 'Klicken Sie auf die Quelle',
    linkModeHintTargetAny:
      'Klicken Sie auf das Ziel oder wählen Sie eine externe Zone',
    deleteModeHintAny:
      'Klicken Sie auf die Zone oder Lüftungseinheit, deren Verbindungen Sie löschen möchten',
  },

  analytics: {
    energyToggle: 'Energie',
    analyticsToggle: 'Analyse',
    compareToggle: 'Vergleichen',
    runSimulation: 'Simulation starten',
    runCoverNeedSimulation: 'Mindestanforderungssimulation starten',
    coverNeedTooltip:
      'Führt die Simulation mit fiktiven Systemen auf Mindestanforderungsniveau aus, sodass der gesamte Energiebedarf gedeckt wird, wo Systeme fehlen oder nicht ausreichen',
    coverNeedAssumptionsTitle: 'Annahmen der Mindestanforderungssimulation',
    simulating: 'Simuliert...',
    exportToExcel: 'Nach Excel exportieren',
    sendToEnova: 'An Enova senden',
    resendToEnova: 'Erneut an Enova senden',
    downloadEnovaPdf: 'Enova-PDF herunterladen',
    sentToEnovaSuccess: 'An Enova gesendet',
    sendToEnovaError: 'Senden an Enova fehlgeschlagen',
    simulationStartedRefresh:
      'Die Berechnungen wurden gestartet, aktualisieren Sie die Seite oder kehren Sie nach 10 Sekunden zurück',
    simulationStartError: 'Die Simulation konnte nicht gestartet werden',
    runRequiresZoneSelection:
      'Wählen Sie mindestens eine Zone aus, bevor Sie die Simulation starten.',
    solarNotIncludedInZones:
      'Die Solarproduktion wird auf Gebäudeebene berechnet und ist in Zonenergebnissen und Vergleichen nicht enthalten.',
    resultsCalculatedAt: 'Berechnet am {datetime}',
    resultsCalculatedWithStandard: 'Berechnet am {datetime} nach {standard}',
    enovaMissingTiltakDescription:
      'Füllen Sie die Beschreibung unter Maßnahmen im Energieausweis aus.',
    enovaNoIncludedActions:
      "Aktivieren Sie mindestens eine Maßnahme oder deaktivieren Sie 'Maßnahmen einbeziehen' und geben Sie eine Beschreibung an.",
    enovaMissingActionDescriptions: 'Beschreibungen ausfüllen für: {actions}',
    enovaMissingCredentials:
      'Füllen Sie {fields} in Ihrem Benutzerprofil aus, bevor Sie an Enova senden.',
    enovaNoMatrikkelSelected:
      'Wählen Sie mindestens eine Nutzungseinheit im Matrikkeldata-Abschnitt aus, bevor Sie an Enova senden.',
    enovaZonesNotSimulated:
      'Führen Sie die Energieausweis-Simulation für die ausgewählten Zonen aus, bevor Sie an Enova senden.',
    enovaNonResidentialMultipleUnits:
      'Für Nicht-Wohneinheiten kann nur eine Einheit ausgewählt werden.',
    confirmSendToEnovaMessage:
      'Sind Sie sicher, dass Sie an Enova senden möchten?',
    enovaSendWithMessagesWarning:
      'Die Simulation hat {count} Meldungen. Prüfen Sie diese, bevor Sie an Enova senden.',
    simulationProgress: 'Gebäudeenergiesimulation wird ausgeführt...',
    simulationMessages: 'Simulationsmeldungen',
    energyCalcWithStandard: 'Energieberechnungen nach {standard}-Standard.',
    energyCalc: 'Energieberechnungen',
    noResults:
      'Keine Simulationsergebnisse verfügbar. Starten Sie eine Simulation, um Energiedaten zu sehen.',
    analyticsPlaceholder: 'Analysediagramme werden hier angezeigt.',
    monthlyEnergyBudget: 'Monatliches Energiebudget (Bedarf)',
    deliveredEnergyTitle: 'Gelieferte Energiequellen',
    deliveredEnergyDesc:
      'Die gesamte gelieferte Energie umfasst alle dem Gebäude zugeführten Energiequellen.',
    energyComparisonTitle: 'Energievergleich (Netto / Verlust / Brutto)',
    energyComparisonDesc:
      'Vergleicht den Nettoenergiebedarf, Verteilungsverluste und die Bruttoenergie für jede Kategorie. Brutto = Netto + Verlust.',
    showTemperature: 'Temperaturlinie anzeigen',
    energySourcesChartLabel: 'Energiequellen',
    totalDeliveredEnergy: 'Gesamte gelieferte Energie',
    visible: 'Sichtbar',
    noData: 'Keine Daten',
    nettEnergy: 'Nettoenergie',
    grossEnergy: 'Bruttoenergie',
    distributionLossLabel: 'Verteilungs- und Speicherverlust',
    noMonthlyData:
      'Monatliche Daten sind für diese Simulation nicht verfügbar.',
    monthlyChartHelp:
      'Jeder gestapelte Balken stellt den monatlichen Nettoenergiebedarf nach Kategorie dar.',
    netEnergyDemand: 'Netto-Energiebedarf',
    distributionLosses: 'Verteilungs- und Speicherverluste',
    grossEnergyDemand: 'Brutto-Energiebedarf',
    energySourcesTitle: 'Energiequellen (Zugef\u00FChrte Energie)',
    deliveredExportedEnergyTitle: 'Gelieferte und exportierte Energie',
    climaCorrectedEnergyTitle:
      'Klimakorrigierte gelieferte und exportierte Energie',
    netEnergyTitle: 'Nettoenergie (Netto-Energiebedarf)',
    distributionLossTitle:
      'Verteilungsverluste (Verteilungs- und Speicherverluste)',
    grossEnergyTitle: 'Bruttoenergie (Brutto-Energiebedarf)',
    category: 'Kategorie',
    value: 'Wert',
    unit: 'Einheit',
    co2: 'CO₂ kg',
    energyType: 'Energieart',
    electricityCategory: '1. Elektrizität',
    fossilCategory: '2-3. Fossile Brennstoffe',
    renewableCategory: '4. Erneuerbare Heizung',
    districtCategory: '5. Fernenergie',
    otherCategory: '6-8. Andere Quellen',
    totalCategory: 'Gesamt',
    elSpecific: 'El. spezifische Posten',
    elHeating: 'El. für Raumheizung',
    elCooling: 'El. für Kühlsystem',
    elDHW: 'El. für Warmwasser',
    elProducedUsed: 'El. Eigenverbrauchsproduktion',
    elProducedExported: 'El. Produktion exportiert',
    oil: 'Öl',
    gas: 'Gas',
    solidFuel: 'Festbrennstoff',
    solidBiofuel: 'Fester Biobrennstoff',
    liquidBiofuel: 'Flüssiger Biobrennstoff',
    gaseousBiofuel: 'Gasförmiger Biobrennstoff',
    districtHeating: 'Fernwärme',
    districtCooling: 'Fernkälte',
    other: 'Sonstiges',
    sumDelivered: 'Gesamt',
    spaceHeating: 'Raumheizung',
    ventilationHeating: 'Lüftungsheizung',
    hotWater: 'Warmwasser',
    spaceCooling: 'Raumkühlung',
    ventilationCooling: 'Lüftungskühlung',
    fans: 'Ventilatoren',
    pumps: 'Pumpen',
    lighting: 'Beleuchtung',
    technicalEquipment: 'Technische Ausrüstung',
    total: 'Gesamt',
    // Heat loss
    heatLossTitle: 'Wärmeverlust',
    heatLossDesc:
      'Aufschlüsselung des Wärmeverlusts nach Bauteilen. Werte in W/m²K.',
    hlWalls: 'Wände',
    hlRoof: 'Dach',
    hlFloor: 'Boden gegen Erdreich',
    hlWindows: 'Fenster',
    hlDoors: 'Türen',
    hlThermalBridge: 'Wärmebrücken',
    hlInfiltration: 'Infiltration',
    hlVentilation: 'Lüftung',
    hlTotal: 'Gesamt',
    // Wärmeverlustbudget (Tabelle 3 NS 3031:2025)
    hlBudgetTitle: 'Wärmeverlustbudget',
    hlBudgetCategory: 'Wärmeverlustposten',
    hlBudgetValue: 'Wärmeverlustkoeffizient',
    hlWindowsDoors: 'Fenster und Türen',
    hlTransmissionSum: 'Wärmeverlustkoeffizient, Transmission, Summe 1–5',
    hlClimateScreenSum: 'Wärmeverlustkoeffizient, Klimahülle, Summe 1–6',
    hlTotalSum: 'Wärmeverlustkoeffizient, gesamt, Summe 1–7',
    // Primärenergie
    peDeliveredEnergy: 'Gelieferte Energie (Strom)',
    peDeliveredFuel: 'Gelieferter Brennstoff',
    peDistrictHeating: 'Fernwärme',
    peDistrictCooling: 'Fernkälte',
    peOtherDelivered: 'Sonstige gelieferte Energie',
    peElExport: 'Stromproduktion für Export',
    energyLabelTitle: 'Energielabel',
    supplementaryEnergyTitle: 'Zusätzliche Energie',
    primaryEnergyFactorsTitle: 'Primärenergiefaktoren',
    carCharging: 'Fahrzeugladung',
    otherEnergyNeeded: 'Sonstiger Energiebedarf',
    energyNeedForOtherBuildings: 'Energiebedarf für andere Gebäude',
    peFossilOil: 'Fossiles Öl',
    peFossilGas: 'Fossiles Gas',
    peFossilSolid: 'Fossiler Festbrennstoff',
    peBioOil: 'Bioöl',
    peBioGas: 'Biogas',
    peBioSolid: 'Biofestbrennstoff',
    ventilationSpecsTitle: 'Lüftungs- und Ventilatorspezifikationen',
    specificFanPower: 'Spezifische Ventilatorleistung (SFP)',
    specificAirFlowIn: 'Spezifischer Zuluftstrom in der Betriebszeit',
    specificAirFlowOut: 'Spezifischer Zuluftstrom außerhalb der Betriebszeit',
    specificExhaustAirFlowIn: 'Spezifischer Abluftstrom in der Betriebszeit',
    specificExhaustAirFlowOut:
      'Spezifischer Abluftstrom außerhalb der Betriebszeit',
    hcsHeatingTitle: 'Heizsysteme',
    hcsCoolingTitle: 'Kühlsysteme',
    hcsType: 'Typ',
    hcsHeatingFactor: 'Wirkungsgrad Heizfaktor',
    hcsCoolingFactor: 'Wirkungsgrad Kühlfaktor',
    hcsEnergyCoverage: 'Energiedeckungsgrad',
    hcsInndata: 'Eingabedaten',
    hcsInstalledHeatingEffect:
      'Spezifische installierte Leistung für Raum- und Lüftungsheizung',
    hcsInstalledCoolingEffect:
      'Spezifische installierte Leistung für Raum- und Lüftungskühlung',
    hcsSetpointInOperation: 'Äquivalente Sollwerttemperatur im Betrieb',
    hcsSetpointOutOfOperation: 'Äquivalente Sollwerttemperatur außer Betrieb',
    wpeTitle: 'Klimakorrigierte gewichtete gelieferte Energie',
    wpeColSource: 'Energiequelle',
    wpeColDelivered: 'Klimakorrigierte gelieferte und exportierte Energie',
    wpeColFactor: 'Gewichtungsfaktor',
    wpeColWeighted: 'Klimakorrigierte gewichtete gelieferte Energie',
    wpeTotal: 'Gesamt, Summe 1-6',
    wpeElectricity: 'Gelieferter Strom',
    wpeSolidBio: 'Gelieferter fester Biobrennstoff',
    wpeLiquidBio: 'Gelieferter flüssiger Biobrennstoff',
    wpeGasBio: 'Gelieferter gasförmiger Biobrennstoff',
    wpeSolidFossil: 'Gelieferter fester fossiler Brennstoff',
    wpeLiquidFossil: 'Gelieferter flüssiger fossiler Brennstoff',
    wpeGasFossil: 'Gelieferter gasförmiger fossiler Brennstoff',
    wpeDistrictHeating: 'Gelieferte Fernwärme',
    wpeDistrictCooling: 'Gelieferte Fernkälte',
    wpeOther: 'Andere gelieferte Energieträger',
    wpeElExport: 'Stromproduktion für den Export (Abzug)',
    ekBasisHeader: 'Grundlage für Energiekennwert',
    ekValueHeader: 'Wert',
    ekSpecificWeighted:
      'Spezifische klimakorrigierte gewichtete gelieferte Energie',
    meTitle: 'Gemessener Energieverbrauch (kWh/Jahr)',
    meColSource: 'Energieträger',
    meColYearGroup: 'Jahr',
    meColAverage: 'Durchschnitt',
    meTotalDelivered: 'Gesamte gelieferte Energie',
    meTotalNetDelivered:
      'Gesamte netto gelieferte Energie (abzüglich etwaigem Export)',
    icTitle: 'Innenraumtemperatur',
    icSubtitle: 'Monatsmittel basierend auf stündlichen Werten',
    icZoneLabel: 'Zone',
    icSingleZoneLabel: 'Innenraumtemperatur',
    dhcLocalHeatingElectricity: 'Lokale Heizung — Strom',
    dhcLocalHeatingFossilOil: 'Lokale Heizung — fossiles Öl',
    dhcLocalHeatingFossilGas: 'Lokale Heizung — fossiles Gas',
    dhcLocalHeatingFossilSolid: 'Lokale Heizung — fossiler Festbrennstoff',
    dhcLocalHeatingBioOil: 'Lokale Heizung — Bioöl',
    dhcLocalHeatingBioGas: 'Lokale Heizung — Biogas',
    dhcLocalHeatingBioSolid: 'Lokale Heizung — Biofestbrennstoff',
    dhcLocalDistrictHeating: 'Lokale Fernwärme',
    dhcLocalHeatPump: 'Lokale Wärmepumpe',
    dhcLocalHeatingOther: 'Lokale Heizung — andere Quellen',
    dhcCentralHeatPump: 'Zentrale Wärmepumpe',
    dhcCentralHeatingElectricity: 'Zentrale Heizung — Strom',
    dhcCentralHeatingFossilOil: 'Zentrale Heizung — fossiles Öl',
    dhcCentralHeatingFossilGas: 'Zentrale Heizung — fossiles Gas',
    dhcCentralHeatingFossilSolid: 'Zentrale Heizung — fossiler Festbrennstoff',
    dhcCentralHeatingBioOil: 'Zentrale Heizung — Bioöl',
    dhcCentralHeatingBioGas: 'Zentrale Heizung — Biogas',
    dhcCentralHeatingBioSolid: 'Zentrale Heizung — Biofestbrennstoff',
    dhcCentralDistrictHeating: 'Zentrale Fernwärme',
    dhcCentralHeatingOther: 'Zentrale Heizung — andere Quellen',
    dhcCentralSolarThermal: 'Zentrale Solarthermie',
    dhcCentralCogeneration: 'Zentrale Kraft-Wärme-Kopplung',
    dhcLocalCooling: 'Lokale Kühlung',
    dhcCentralCoolingAirWater: 'Zentrale Kühlung — Luft/Wasser',
    dhcCentralCoolingLiquidWater: 'Zentrale Kühlung — Flüssigkeit/Wasser',
    dhcCentralFreeCooling: 'Zentrale freie Kühlung',
    dhcCentralDistrictCooling: 'Zentrale Fernkühlung',
    // Interne Lasten
    internalLoadsTitle: 'Interne Lasten',
    internalLoadEnergyTitle: 'Interne Lasten - Energiebedarf',
    internalLoadHeatTitle: 'Interne Lasten - Wärmegewinne',
    ilLighting: 'Beleuchtung',
    ilEquipment: 'Technische Ausrüstung',
    ilHotWater: 'Warmwasser',
    ilPeople: 'Personen',
    internalLoadsChartTitle: 'Interne Lasten (Energiebedarf vs Wärmegewinne)',
    internalLoadsChartDesc:
      'Vergleicht Energiebedarf und Wärmegewinne aus internen Lastquellen.',
    ilEnergyNeed: 'Energiebedarf',
    ilSpecificEnergyNeed: 'Spezifischer Energiebedarf',
    ilSpecificHeatGain: 'Spezifischer Wärmegewinn',
    ilHeatGain: 'Wärmegewinn',
    // Month names
    month: 'Monat',
    monthJan: 'Jan',
    monthFeb: 'Feb',
    monthMar: 'Mär',
    monthApr: 'Apr',
    monthMay: 'Mai',
    monthJun: 'Jun',
    monthJul: 'Jul',
    monthAug: 'Aug',
    monthSep: 'Sep',
    monthOct: 'Okt',
    monthNov: 'Nov',
    monthDec: 'Dez',
    // Information table (general + climate)
    bdTitle: 'Informationen',
    bdParameter: 'Allgemein',
    bdInputValue: 'Eingabewert',
    bdBuildingCategory: 'Gebäudekategorie',
    bdBuildingType: 'Gebäudetyp',
    bdYearOfConstruction: 'Baujahr',
    bdTekStandard: 'TEK-Standard',
    bdCalculationDate: 'Berechnungsdatum',
    bdClimateInformation: 'Klima',
    bdClimateStationSource: 'Klimastationsquelle',
    bdClimateStation: 'Klimastation',
    bdClimateCorrectionFactor: 'Klimakorrekturfaktor',
    bdYearlyAverageTemperature: 'Jahresdurchschnittstemperatur',
    efTitle: 'Energiefluss',
    efColCategory: 'Energieposten',
    efColNet: 'Nettoenergiebedarf',
    efColDist: 'Verteilungs- und Speicherverluste',
    efColGross: 'Bruttoenergiebedarf',
    efColSpf: 'SPF',
    efColDelivered: 'Gelieferte Energie',
    efTotal: 'Gesamt',
    // Gewichtungsfaktoren Energieträger (T.2 NS 3031:2025)
    wfTitle: 'Gewichtungsfaktoren Energieträger',
    wfType: 'Typ',
    wfWeightFactor: 'Gewichtungsfaktor',
    wfClimateFactor: 'Treibhausgasfaktor (CO²-Äquivalent)',
    wfEnergyPrice: 'Energiepreis',
    wfOtherWeighting: 'Andere Gewichtung',
    wfElectricity: 'Gelieferter Strom',
    wfBioSolid: 'Feste Biobrennstoffe',
    wfBioLiquid: 'Flüssige Biobrennstoffe',
    wfBioGas: 'Gasförmige Biobrennstoffe',
    wfFossilSolid: 'Feste fossile Brennstoffe',
    wfFossilLiquid: 'Flüssige fossile Brennstoffe',
    wfFossilGas: 'Gasförmige fossile Brennstoffe',
    wfDistrictHeating: 'Fernwärme',
    wfDistrictCooling: 'Fernkälte',
    wfOther: 'Sonstige',
    wfExportedElectricity: 'Exportierter Strom',
    // Verteilungssysteme
    dsTitle: 'Verteilungssysteme',
    dsCategory: 'Parameter',
    dsValue: 'Eingabewert',
    dsRoomHeating: 'Raumheizung',
    dsVentilationHeating: 'Lüftungsheizung',
    dsDhwCirculation: 'Warmwasserzirkulation',
    dsRoomCooling: 'Raumkühlung',
    dsVentilationCooling: 'Lüftungskühlung',
    dsPipeLength: 'Laufmeter Verteilungsrohr pro beheizter Fläche',
    dsPumpPower: 'Spezifische Pumpenleistung',
    // Strom (Tabelle T.2 NS 3031:2025)
    elTitle: 'Strom',
    elCategory: 'Parameter',
    elValue: 'Eingabewert',
    elSolarEfficiency: 'Jahreswirkungsgrad der Photovoltaikanlage',
    elSolarInstalled: 'Installierte Leistung der Photovoltaikanlage (Ppeak)',
    elSolarCoverage: 'Deckung des stromspezifischen Bedarfs durch Photovoltaik',
    elWindCoverage: 'Deckung des stromspezifischen Bedarfs durch Windkraft',
    elChpEfficiency:
      'Jahresdurchschnittlicher Wirkungsgrad der Stromerzeugung in Kraft-Wärme-Kopplung',
    elChpCoverage:
      'Deckungsgrad des stromspezifischen Bedarfs durch Kraft-Wärme-Kopplung',
  },

  energyLabelConfig: {
    airLeakageTitle: 'Luftleckage',
    airLeakageMeasured: 'Luftleckage gemessen',
    airLeakageMeasuredDate: 'Messdatum',
    airLeakageGradeAHint:
      'Klasse A erfordert eine gemessene Luftleckage mit Messdatum. Ohne diese ist die Einstufung auf B begrenzt.',
    actionsTitle: 'Maßnahmen',
    includeMeasures: 'Maßnahmen in Bewertung einbeziehen',
    includeActivatedActions: 'Aktivierte Maßnahmen einbeziehen',
    loadingActions: 'Maßnahmen werden geladen…',
    actionNameVentilation: 'Lüftungsmaßnahme',
    actionNameHeating: 'Heizungs- und Kühlungsmaßnahme',
    actionNameLighting: 'Beleuchtungsmaßnahme',
    actionNameSolar: 'Solarzellenmaßnahme',
    actionNameControl: 'Steuerung & Regelung Maßnahme',
    actionsDescription:
      'Wenn keine Maßnahmen enthalten sind, beschreiben Sie stattdessen den Grund (z. B. Neubau).',
    includedMeasuresInfo:
      'Die Liste der einbezogenen Maßnahmen enthält eine Bewertung der Kosten und Auswirkungen in Bezug auf Feuchtigkeit und Raumklima für jede einzelne Energiemaßnahme. Die Liste kann als Grundlage für die Planung eines Programms zur Instandhaltung und Modernisierung des Gebäudes verwendet werden.',
    description: 'Beschreibung',
    measuredValuesTitle: 'Messwerte',
    measuredValuesCheckbox: 'Messwerte',
    measuredValuesDescription:
      'Energieverbrauchsmessungen nach Quellenart für die letzten 3 Jahre.',
    energySourcePlaceholder: 'Energiequelle (kWh)',
    addMeasurement: 'Messung hinzufügen',
    confirmDeleteMeasurement: 'Diese Messzeile löschen?',
    deliveredElectricity: 'Gelieferter Strom (kWh)',
    exportedElectricity: 'Exportierter Strom (kWh)',
    fossilOil: 'Fossiles Öl (kWh)',
    fossilGas: 'Fossiles Gas (kWh)',
    fossilSolidFuel: 'Fossiler Festbrennstoff (kWh)',
    bioOil: 'Bioöl (kWh)',
    bioGas: 'Biogas (kWh)',
    bioSolidFuel: 'Bio-Festbrennstoff (kWh)',
    districtHeating: 'Fernwärme (kWh)',
    districtCooling: 'Fernkühlung (kWh)',
    other: 'Sonstige (kWh)',
    // matrikkel data accordion
    matrikkelDataTitle: 'Katasterdaten',
    noUnitsFound: 'Keine Einheiten gefunden',
    street: 'Adresse',
    addressCode: 'Adresscode',
    postcode: 'Postleitzahl',
    city: 'Stadt',
    municipality: 'Gemeinde',
    municipalityNumber: 'Gemeindenummer',
    gnrBnr: 'Gnr/Bnr',
    leaseholdNumber: 'Erbpacht-Nummer',
    buildingNumber: 'Gebäudenummer',
    buildingType: 'Gebäudetyp',
    buildingStatus: 'Gebäudestatus',
    industryType: 'Branchengruppe',
    unitNumber: 'Einheitsnummer',
    unitId: 'Einheits-ID',
    unitType: 'Einheitstyp',
    sectionNumber: 'Sektionsnummer',
    sectionType: 'Sektionstyp',
  },

  zoneSelection: {
    title: 'Zonen zum Simulieren',
    selectAll: 'Alle auswählen',
    deselectAll: 'Alle abwählen',
    selected: '{count} von {total} ausgewählt',
  },

  buildingTool: {
    showAll: 'Alle anzeigen',
    hideAll: 'Alle ausblenden',
    updateZone: 'Zone aktualisieren',
    deleteZone: 'Zone löschen',
    title: 'Gebäudewerkzeug',
    description:
      'Zeichnen Sie ein Polygon auf der Karte, um den Gebäudegrundriss zu markieren, passen Sie die Parameter an und erstellen Sie eine Zone mit Wänden.',
    numberOfFloors: 'Anzahl der Stockwerke',
    floorHeight: 'Stockwerkshöhe (m)',
    startFloor: 'Startgeschoss',
    wallSegments: 'Wandsegmente',
    totalPerimeter: 'Gesamtumfang',
    creating: 'Wird erstellt...',
    createZoneAndWalls: 'Zone und Wände erstellen',
    createSuccess: 'Zone und {count} Wand/Wände erfolgreich erstellt',
    createError: 'Zone und Wände konnten nicht erstellt werden',
    joinBearings: 'Nach Himmelsrichtung zusammenführen',
    splitBearings: 'Alle Segmente anzeigen',
    joinButton: 'Verbinden',
    splitButton: 'Aufteilen',
    floorArea: 'Bodenfläche (m²)',
    roofArea: 'Dachfläche (m²)',
    autoSelect: 'Auto',
    autoSelectHint: 'Klicken Sie auf ein Gebäude, um den Grundriss auszuwählen',
    noBuildingFound: 'Kein Gebäude gefunden',
    createAnother: 'Weitere Zone erstellen',
    autoSelectTooltip: 'Auto-Auswahl',
    drawPolygonTooltip: 'Polygon zeichnen',
    drawStackedTooltip: 'Etage über Zone hinzufügen',
    drawStackedTooltipDisabled:
      'Etage über Zone hinzufügen (Zone erforderlich)',
    drawStackedHint:
      'Auf eine Zone klicken, um eine Kopie darüber zu erstellen',
    snapToggleOn: 'Einrasten ein',
    snapToggleOff: 'Einrasten aus',
    splitTooltip: 'Zone teilen',
    splitTooltipDisabled: 'Zone teilen (Zone erforderlich)',
    splitTargetHint: 'Auf eine Zone klicken, um sie zu teilen',
    view3dTooltip: '3D-Ansicht',
    splitPanelTitle: 'Zone teilen',
    splitPanelDescription:
      'Die Schieber ziehen, um den Schnitt zu positionieren. Die Zone wird in zwei Hälften geteilt.',
    splitPanelPickTargetHint:
      'Auf eine Zone in der Karte klicken, um sie auszuwählen.',
    splitPanelSplittingZone: 'Teilung: {name}',
    splitPanelCutPositionLabel: 'Schnittposition: {value}',
    splitPanelCutAngleLabel: 'Schnittwinkel: {value}°',
    splitPanelCutLengthLabel: 'Schnittlänge: {value}',
    splitPanelCutOffsetLabel: 'Schnittversatz: {value}',
    splitPanelConfirm: 'Teilung bestätigen',
    splitPanelCommitting: 'Teile…',
    errorUpdateZone: 'Fehler beim Aktualisieren der Zone',
    errorCreateStackedZone: 'Fehler beim Hinzufügen einer Etage über der Zone',
    errorSplitZone: 'Fehler beim Teilen der Zone',
    errorDeleteZone: 'Fehler beim Löschen der Zone',
  },

  underDevelopment: 'Diese Seite befindet sich in Entwicklung.',

  // excel export labels for the input data sheet
  excelExport: {
    headerSection: 'Bereich',
    headerName: 'Name',
    headerParameter: 'Parameter',
    headerValue: 'Wert',
    headerUnit: 'Einheit',
    inputDataSheetName: 'Eingabedaten',
    boolYes: 'Ja',
    boolNo: 'Nein',
    sectionThermalZones: 'Thermische Zonen',
    sectionExteriorWalls: 'Außenwände',
    sectionHvacUnits: 'Lüftungsanlagen',
    sectionHeatingCoolingModules: 'Heiz-/Kühlmodule',
    sectionCentralEnergyModules: 'Zentrale Energiemodule',
    sectionHeatPumps: 'Wärmepumpen',
    sectionDistrictHeating: 'Fernwärme',
    sectionCombustionBoilers: 'Verbrennungskessel',
    sectionElectricBoilers: 'Elektrokessel',
    sectionSolarThermal: 'Solarthermie',
    sectionOtherEnergySources: 'Andere Energiequellen',
    sectionSolarPv: 'Photovoltaik',
    sectionDomesticHotWater: 'Warmwasser',
    sectionPipeConfigurations: 'Rohrkonfigurationen',
    sectionProductionEquipment: 'Produktionsausrüstung',
    sectionExcessEnergy: 'Überschussenergie',
    // excel-specific short labels
    area: 'Fläche',
    uValue: 'U-Wert',
    yearInstalled: 'Baujahr',
    energySource: 'Energiequelle',
    systemEfficiency: 'Systemwirkungsgrad',
    usedForHeating: 'Für Heizung',
    usedForCooling: 'Für Kühlung',
    usedForDHW: 'Für Warmwasser',
    maxCapacity: 'Max. Kapazität',
    heatingCapacity: 'Heizkapazität',
    cop: 'COP',
    heatingEffect: 'Heizleistung',
    coolingEffect: 'Kühlleistung',
    co2eEmissionFactor: 'CO\u2082e-Emissionsfaktor',
    energyPrice: 'Energiepreis',
    power: 'Leistung',
    // entity prefixes
    prefixWall: 'Wand',
    prefixWindow: 'Fenster',
    prefixDoor: 'Tür',
    prefixGate: 'Tor',
    prefixPipe: 'Rohr',
    prefixHeatingBattery: 'Heizregister',
    prefixCoolingBattery: 'Kühlregister',
    prefixDxSystem: 'DX-System',
    prefixEnergySource: 'Energiequelle',
    prefixTank: 'Speicher',
    prefixCopEntry: 'COP-Eintrag',
    // thermal zones
    heatedFloorArea: 'Beheizte Fläche (BRA)',
    numberOfFloors: 'Anzahl Geschosse',
    floorHeight: 'Geschosshöhe',
    indoorTemperature: 'Starttemperatur',
    zoneClimate: 'Zonenklima',
    airLeakageGrade: 'Luftdichtheit - Grad',
    airLeakageN50: 'Luftdichtheit - n50',
    setpointHeating: 'Sollwert - Heizung',
    setpointCooling: 'Sollwert - Kühlung',
    thermalBridgeType: 'Wärmebrücke - Typ',
    thermalBridgePsiValue: 'Wärmebrücke - \u03C8-Wert',
    floorType: 'Boden gegen Erdreich - Typ',
    floorArea: 'Boden gegen Erdreich - Fläche',
    floorUValue: 'Boden gegen Erdreich - U-Wert',
    floorHeatLossCoeff: 'Boden gegen Erdreich - Wärmeverlustkoeffizient',
    roofType: 'Dach - Typ',
    roofArea: 'Dach - Fläche',
    roofUValue: 'Dach - U-Wert',
    roofAngle: 'Dach - Neigung',
    roofWindowArea: 'Dach - Fensterfläche',
    roofWindowUValue: 'Dach - Fenster U-Wert',
    roofWindowGValue: 'Dach - Fenster g-Wert',
    basementArea: 'Keller - Bodenfläche',
    basementWallPerimeter: 'Keller - Erdberührter Umfang',
    basementFillHeight: 'Keller - Tiefe unter Gelände',
    basementWallThickness: 'Keller - Wandstärke',
    basementWallUValue: 'Keller - Wand U-Wert',
    basementFloorUValue: 'Keller - Boden U-Wert',
    groundThermalConductivity: 'Boden - Wärmeleitfähigkeit',
    groundHeatCapacity: 'Boden - Wärmekapazität',
    groundPenetrationDepth: 'Boden - Eindringtiefe',
    thermalMassCategory: 'Thermische Masse - Kategorie',
    thermalMassHeatCapacity: 'Thermische Masse - Wärmekapazität',
    thermalMassNormalized: 'Thermische Masse - Normalisierte Wärmekapazität',
    // windows
    gValue: 'g-Wert',
    shadingFactor: 'Verschattungsfaktor',
    externalBlinds: 'Außenjalousien',
    externalBlindsGt: 'Außenjalousien Gt',
    externalScreen: 'Außenscreen',
    externalScreenGt: 'Außenscreen Gt',
    internalShading: 'Innenliegender Sonnenschutz',
    internalShadingGt: 'Innenliegender Sonnenschutz Gt',
    // hvac
    heatRecoveryType: 'Wärmerückgewinnungstyp',
    motorType: 'Motortyp',
    flowType: 'Strömungstyp',
    sfpSupply: 'SFP (Zuluft)',
    sfpExtract: 'SFP (Abluft)',
    sfpNonOperating: 'SFP außer Betrieb',
    coverageArea: 'Versorgungsfläche',
    coverageVolume: 'Versorgungsvolumen',
    fanPowerSupply: 'Ventilatorleistung (Zuluft)',
    fanPowerExtract: 'Ventilatorleistung (Abluft)',
    heatRecoveryEfficiency: 'Wärmerückgewinnungsgrad',
    frostProtection: 'Frostschutz',
    frostProtectionTemperature: 'Frostschutztemperatur',
    airVolumeOperatingSupply: 'Luftvolumen Betrieb (Zuluft)',
    airVolumeCapacitySupply: 'Luftvolumen Kapazität (Zuluft)',
    airVolumeNonOperatingSupply: 'Luftvolumen außer Betrieb (Zuluft)',
    airVolumeOperatingExtract: 'Luftvolumen Betrieb (Abluft)',
    airVolumeCapacityExtract: 'Luftvolumen Kapazität (Abluft)',
    airVolumeNonOperatingExtract: 'Luftvolumen außer Betrieb (Abluft)',
    supplyTemperature: 'Zulufttemperatur',
    onlyNaturalPassiveVentilation: 'Nur natürliche/passive Lüftung',
    batteryEer: 'EER',
    systemType: 'Systemtyp',
    coolingOnly: 'Nur Kühlung',
    ambientTemperature: 'Umgebungstemperatur',
    tankPurpose: 'Zweck',
    tankVolume: 'Volumen',
    tankInsulationGrade: 'Isolierungsgrad',
    tankHeatLossCoeff: 'Wärmeverlustkoeffizient',
    tankSetpointTemp: 'Solltemperatur',
    tankMaxTemp: 'Max. Temperatur',
    tankMinTemp: 'Min. Temperatur',
    heatPumpType: 'Wärmepumpentyp',
    nominalLoad: 'Nennlast',
    minimumLoad: 'Mindestlast',
    degradationCoefficient: 'Degradationskoeffizient',
    liquidSource: 'Flüssigkeitsquelle',
    sourceTemperature: 'Quellentemperatur',
    sourceYearlyAvgTemp: 'Quellen-Jahresmitteltemperatur',
    sourceTempAmplitude: 'Quellentemperaturamplitude',
    copSourceTemp: 'Quellentemp.',
    copMaxEffectLow: 'Max. Leistung (niedrige Temp.)',
    copMaxEffectHigh: 'Max. Leistung (hohe Temp.)',
    copFullLoadLow: 'COP Volllast (niedrige Temp.)',
    copFullLoadHigh: 'COP Volllast (hohe Temp.)',
    copNormalLoadLow: 'COP Normallast (niedrige Temp.)',
    copNormalLoadHigh: 'COP Normallast (hohe Temp.)',
    copLowLoadLow: 'COP Teillast (niedrige Temp.)',
    copLowLoadHigh: 'COP Teillast (hohe Temp.)',
    boilerType: 'Kesseltyp',
    efficiencyAtLowerLoad: 'Wirkungsgrad bei Teillast',
    effectAtFullLoad: 'Leistung bei Volllast',
    isCondensing: 'Brennwertkessel',
    seasonalMeanTemperature: 'Saisonale Mitteltemperatur',
    fuelSource: 'Brennstoffquelle',
    fuelEnergyContent: 'Brennstoff-Energiegehalt',
    fuelCo2EmissionFactor: 'Brennstoff CO\u2082-Emissionsfaktor',
    operatingStart: 'Betriebsbeginn',
    operatingEnd: 'Betriebsende',
    phi: 'Phi',
    insulationGrade: 'Isolierungsgrad',
    tilt: 'Neigung',
    collectorArea: 'Kollektorfläche',
    pipeLength: 'Rohrlänge',
    pipeUValue: 'Rohr U-Wert',
    efficiencyAtNormalConditions: 'Wirkungsgrad bei Normalbedingungen',
    heatLossLinearCoefficient: 'Wärmeverlust Linearkoeffizient',
    heatLossCoefficient: 'Wärmeverlustkoeffizient',
    fuelType: 'Brennstofftyp',
    panelArea: 'Modulfläche',
    nominalEfficiency: 'Nennwirkungsgrad',
    panelAngle: 'Modulneigung',
    panelAzimuth: 'Modul-Azimut',
    inverterEfficiency: 'Wechselrichterwirkungsgrad',
    degradationLoss: 'Degradationsverlust',
    inverterLoss: 'Wechselrichterverlust',
    transmissionProduct: 'Transmissionsprodukt (0-1)',
    temperatureCoefficient: 'Temperaturkoeffizient (%/°C)',
    incidentAngleModifier: 'Einfallswinkelmodifikator (0-1)',
    heatLossFactor: 'Wärmeverlustfaktor',
    pvMountingType: 'Montagetyp',
    windExposure: 'Windexposition',
    pvCellType: 'Zelltyp',
    heaterType: 'Warmwasserbereitertyp',
    useNormedData: 'Normdaten verwenden',
    placementType: 'Aufstellungsart',
    volume: 'Volumen',
    setpointTemperature: 'Solltemperatur',
    heatingElementPower: 'Heizstableistung',
    specificHeatLoss: 'Spezifischer Wärmeverlust',
    maxPowerDemand: 'Max. Leistungsbedarf',
    usagePattern: 'Nutzungsmuster',
    heatContributionPercent: 'Wärmebeitrag Prozent',
    distributionSystemType: 'Verteilungssystemtyp',
    pipeSpecificLength: 'Spezifische Rohrlänge',
    tapCyclesPerDay: 'Zapfzyklen pro Tag',
    pipesInHeatedRoom: 'Rohre im beheizten Raum',
    specificPumpPower: 'Spezifische Pumpenleistung',
    pipeLinearUValue: 'Rohr linearer U-Wert',
    avgTempOutsideHeatedRoom: 'Durchschn. Temp. außerhalb beheiztem Raum',
    greyWaterRecovery: 'Grauwasserrückgewinnung',
    greyWaterEfficiency: 'Grauwasserwirkungsgrad',
    greyWaterShare: 'Grauwasseranteil',
    greyWaterConnectionLossFactor: 'Grauwasser Anschlussverlustfaktor',
    greyWaterPatternLossFactor: 'Grauwasser Musterverlustfaktor',
    waterSystemQuality: 'Wassersystemqualität',
    pipeInsulationType: 'Rohrisolierungstyp',
    spp: 'SPP',
    constantFlow: 'Konstante Strömung',
    lengthOfPipe: 'Rohrlänge',
    percentageInHeatedSpace: 'Anteil im beheizten Raum',
    avgTempOutsideHeatedSpace: 'Durchschn. Temp. außerhalb beheiztem Raum',
    temperatureReturn: 'Rücklauftemperatur',
    temperatureSupply: 'Vorlauftemperatur',
    eligibleForHarvesting: 'Für Energierückgewinnung geeignet',
    medium: 'Medium',
    temperature: 'Temperatur',
    amount: 'Menge',
    ductShape: 'Kanalform',
    diameter: 'Durchmesser',
    width: 'Breite',
    height: 'Höhe',
    airSpeed: 'Luftgeschwindigkeit',
  },

  actions: {
    ventilation: {
      pageTitle: 'Belüftung',
      ventilationUnits: 'Lüftungsanlagen',
      noHvacUnits:
        'Keine HLK-Anlagen gefunden. Fügen Sie zuerst HLK-Anlagen im Bereich HLK-Systeme hinzu.',
      usingUnits:
        'Verwendet {count} aktivierte Lüftungsanlage(n) aus der Gebäudeinspektion.',
      enableUnitsHint:
        'Aktivieren Sie die Lüftungsanlagen unten, um sie in die Maßnahme einzubeziehen.',
    },
    lighting: {
      pageTitle: 'Beleuchtung',
      thermalZones: 'Thermische Zonen',
      noZones:
        'Keine thermischen Zonen gefunden. Fügen Sie zuerst thermische Zonen im Bereich Thermische Zonen hinzu.',
      usingZones:
        'Verwendet {count} aktivierte thermische Zone(n) für die Beleuchtungsmaßnahme.',
      enableZonesHint:
        'Aktivieren Sie die thermischen Zonen unten, um sie in die Beleuchtungsmaßnahme einzubeziehen.',
      unit: 'W/m\u00B2',
      presenceControl: 'Präsenzkontrolle (Beleuchtung)',
      presenceControlLabel: 'Präsenzkontrolle:',
      presenceYes: 'Ja (Faktor: {value})',
      presenceNo: 'Nein',
    },
    heating: {
      pageTitle: 'Heizung & Kühlung',
      thermalZones: 'Thermische Zonen',
      usingZones:
        '{count} aktivierte thermische Zone(n) für die Heizungsmaßnahme.',
      enableZonesHint:
        'Aktivieren Sie die thermischen Zonen unten, um sie in die Heizungsmaßnahme einzubeziehen.',
      addNewSystem: 'Neues System hinzufügen',
      addSystemDialogTitle: 'Neues System hinzufügen',
      template: 'Vorlage',
      systemName: 'Systemname',
      priorityHelp: '1 = höchste Priorität',
      unnamed: 'Unbenannt',
      chipNew: 'NEU',
      chipRemoved: 'ENTFERNT',
      chipModified: 'GEÄNDERT',
      remove: 'Entfernen',
      delete: 'Löschen',
      confirmDelete: 'Sind Sie sicher, dass Sie dieses System löschen möchten?',
      undo: 'Rückgängig',
      noExistingSystems: 'Keine bestehenden Heiz-/Kühlsysteme in dieser Zone.',
      enableZoneHint:
        'Aktivieren Sie diese Zone, um Heiz-/Kühlsysteme zu konfigurieren.',
      existingSystems: '{count} bestehendes/e System(e)',
      templateAirWaterHP: 'Luft/Wasser-Wärmepumpe',
      templateAirAirHP: 'Luft/Luft-Wärmepumpe',
      templateAirToAirHP: 'Luft/Luft-Wärmepumpe',
      templateGroundSourceHP: 'Erdwärmepumpe',
      templateElectricBoiler: 'Elektrokessel',
      templateDistrictHeating: 'Fernwärme',
      templateDistrictCooling: 'Fernkälte',
    },
    solar: {
      pageTitle: 'Photovoltaik',
      solarPvModules: 'PV-Module',
      noModules:
        'Keine PV-Module gefunden. Fügen Sie PV-Module im Photovoltaik-Bereich hinzu.',
      usingModules:
        '{count} aktivierte PV-Modul(e) aus der Gebäudeinspektion werden verwendet.',
      enableModulesHint:
        'Aktivieren Sie PV-Module unten, um sie in die Maßnahme aufzunehmen.',
      addNewModule: 'Neues Modul hinzufügen',
      chipNew: 'Neu',
      noExistingModules: 'Keine vorhandenen PV-Module.',
    },
    control: {
      pageTitle: 'Steuerung & Regelung',
      energyReductionPercent: 'Energiereduktion [%]',
      energyReductionHint:
        'Prozentuale Reduzierung der gesamten gelieferten Energie aus der Referenzsimulation.',
    },
    overview: {
      overviewTitle: 'Maßnahmenübersicht',
      combinedResults: 'Kombinierte Simulationsergebnisse',
      notSimulated: 'Noch nicht simuliert',
      noActiveActions:
        'Keine aktiven Maßnahmen. Aktivieren Sie Maßnahmen auf den einzelnen Maßnahmenseiten.',
      activeActions: 'Aktive Maßnahmen',
      runCombinedSimulation: 'Gebäudesimulation starten',
      noUnitsSelected: 'Keine Einheiten ausgewählt',
      noZonesSelected: 'Keine thermischen Zonen ausgewählt',
      noModulesSelected: 'Keine Module ausgewählt',
      totalInvestment: 'Gesamtinvestition',
      priorityUpdateFailed: 'Priorität konnte nicht aktualisiert werden',
    },
  },

  scenarioSync: {
    outOfSync:
      'Die Inspektion hat sich seit der letzten Synchronisierung dieses Szenarios geändert.',
    legacyOutOfSync:
      'Die Inspektion hat sich seit der Erstellung dieses Szenarios geändert. Das Szenario ist älter als die Synchronisierungsunterstützung. Erstellen Sie ein neues Szenario, um die neuesten Änderungen zu übernehmen.',
    reviewChanges: 'Änderungen prüfen',
    notSet: 'Nicht gesetzt',
    items: 'Einträge',
    dialogTitle: 'Szenario aus der Inspektion aktualisieren',
    dialogIntro:
      'Änderungen aus der Inspektion werden automatisch übernommen und Ihre eigenen Änderungen im Szenario bleiben erhalten. Wenn beide Seiten dasselbe Feld geändert haben, wählen Sie den gewünschten Wert.',
    conflictsHeading: 'Konflikte erfordern Ihre Entscheidung',
    noConflicts: '0 Konflikte',
    added: 'Neu',
    removed: 'Entfernt',
    removedInScenario:
      'In diesem Szenario gelöscht, die Löschung bleibt bestehen',
    removeConflict:
      'In der Inspektion gelöscht, aber in diesem Szenario geändert',
    keepEntity: 'Behalten',
    removeEntity: 'Löschen',
    keepScenario: 'Szenariowert behalten',
    takeParent: 'Inspektionswert verwenden',
    keptOverrides:
      'Felder behalten Ihre Szenarioänderungen (die Aktualisierung überschreibt sie nicht)',
    noChanges: 'Keine Unterschiede zu synchronisieren.',
    markSynced: 'Als synchronisiert markieren',
    applySync: 'Szenario aktualisieren',
    syncSuccess: 'Szenario aus der Inspektion aktualisiert',
    syncError: 'Szenario konnte nicht synchronisiert werden',
    resimulateHint:
      'Führen Sie die Simulation danach erneut aus, um die Ergebnisse zu aktualisieren.',
    collections: {
      inspection: 'Inspektion',
      thermalZones: 'Zonen',
      exteriorWalls: 'Außenwände',
      windowAreas: 'Fenster',
      doorAreas: 'Türen',
      gateAreas: 'Tore',
      operationalLoads: 'Interne Lasten',
      thermalZoneLinks: 'Zonenverbindungen',
      hvacUnits: 'Lüftungsanlagen',
      heatingCoolingModules: 'Heizung und Kühlung',
      centralEnergyModules: 'Zentrale Energie',
      combustionBoilers: 'Verbrennungskessel',
      districtHeatings: 'Fernwärme',
      electricBoilers: 'Elektrokessel',
      otherSources: 'Andere Energiequellen',
      solarTermals: 'Solarthermie',
      heatPumps: 'Wärmepumpen',
      productionEquipments: 'Produktionsanlagen',
      solarPvModules: 'Photovoltaik',
      excessEnergyModules: 'Überschussenergie',
      domesticHotWaters: 'Warmwasser',
      actionModules: 'Maßnahmen',
      pipeLinks: 'Rohrverbindungen',
      batteries: 'Batterien',
    },
  },

  scenario: {
    intro:
      'Erstellen Sie eine oder mehrere bearbeitbare Kopien dieser Inspektion. Ändern Sie in einer Kopie, was Sie möchten, und führen Sie dann eine Simulation aus, um sie mit dem Original zu vergleichen.',
    introExisting:
      'Eine Szenariokopie dieser Inspektion existiert bereits. Öffnen Sie sie, um weiter zu bearbeiten, oder beginnen Sie neu vom aktuellen Stand des Originals.',
    bannerNotice:
      'Szenario. Änderungen hier wirken sich nicht auf die ursprüngliche Inspektion aus.',
    createScenario: 'Szenario erstellen',
    addScenario: 'Szenario hinzufügen',
    scenarioName: 'Szenarioname',
    scenarioNamePlaceholder: 'z. B. Neues Lüftungssystem',
    unnamedScenario: 'Unbenanntes Szenario',
    creating: 'Wird erstellt…',
    createNewScenario: 'Neues Szenario erstellen',
    renameScenario: 'Name und Priorität der Maßnahme bearbeiten',
    deleteScenario: 'Szenario löschen',
    confirmDeleteScenario: 'Dieses Szenario entfernen?',
    working: 'Wird bearbeitet…',
    backToOriginal: 'Zurück zum Original',
    confirmReplace:
      'Vorhandenes Szenario durch eine neue Kopie des Originals ersetzen? Das aktuelle Szenario wird verworfen.',
    createFailed: 'Szenario konnte nicht erstellt werden',
    replaceFailed: 'Szenario konnte nicht ersetzt werden',
    renameFailed: 'Szenario konnte nicht umbenannt werden',
    deleteFailed: 'Szenario konnte nicht gelöscht werden',
    existingCreated: 'Erstellt am {date}',
    existingCreatedBy: 'Erstellt am {date} von {name}',
    generalNotes: 'Allgemeine Notizen',
    generalNotesPlaceholder:
      'Beschreiben Sie die Maßnahme so detailliert wie möglich: was konkret geändert wurde und warum.',
    notesRequired: 'Allgemeine Notizen sind erforderlich',
    investmentCost: 'Investitionskosten [NOK]',
    runToCompare: 'Szenario-Simulation ausführen, um zu vergleichen',
    savingsUnavailable:
      'Einsparungen konnten noch nicht berechnet werden. Preisdaten fehlen oder sind unvollständig.',
    compareLeftLabel: 'Original',
    compareRightLabel: 'Szenario',
    compareAgainst: 'Vergleichen mit',
    noComparison: 'Kein Vergleich',
    actionTypeLabel: 'Aktionstyp',
    selectActionType: 'Aktionstyp wählen',
    actionTypes: {
      buildingShell: 'Gebäudehülle',
    },
  },

  report: {
    dragDropHint: 'Kapitel und Felder in der Seitenleiste neu anordnen.',
    generateReport: 'Bericht generieren',
    reportLanguage: 'Berichtssprache',
    addChapter: 'Kapitel hinzufügen',
    exportToWord: 'Nach Word exportieren',
    exportingToWord: 'Wird nach Word exportiert...',
    exportingProgress: 'Export nach Word — {current} von {total}: {label}',
    sources: 'Quellen',
    noChapters:
      'Noch keine Kapitel. Fügen Sie ein Kapitel hinzu, um zu beginnen.',
    editTitle: 'Titel bearbeiten',
    removeChapter: 'Kapitel entfernen',
    noFields:
      'Noch keine Textfelder. Fügen Sie ein Feld hinzu, um zu beginnen.',
    fieldTitlePlaceholder: 'Titel des neuen Feldes...',
    addField: 'Feld hinzufügen',
    confirmRemoveChapter: 'Kapitel „{title}" entfernen?',
    generateWithAI: 'Mit KI generieren',
    hideAuditLog: 'Prüfprotokoll ausblenden',
    showAuditLog: 'Prüfprotokoll anzeigen',
    removeField: 'Feld entfernen',
    promptLabel: 'Prompt (wird für KI-Generierung verwendet)',
    promptPlaceholder: 'Anweisungen für die KI-Generierung schreiben...',
    generateText: 'Text generieren',
    textPlaceholder: 'Inhalt hier schreiben oder KI-Generierung verwenden',
    confirmRemoveField: 'Feld „{title}" entfernen?',
    addChapterTitle: 'Neues Kapitel hinzufügen',
    chapterTitleLabel: 'Kapiteltitel',
    chapterTitlePlaceholder: 'Z.B. Raumklima und Komfort',
    fetchError: 'Bericht konnte nicht abgerufen werden',
    saveError: 'Bericht konnte nicht gespeichert werden',
    generateError: 'Text konnte nicht generiert werden',
    generatingStatus:
      'Der Bericht wird von KI erstellt. Dies kann mehrere Minuten dauern — die Seite wird automatisch aktualisiert, wenn er fertig ist.',
    generateSuccess: 'Bericht erfolgreich erstellt',
    generateTimeout:
      'Zeitüberschreitung bei der Berichterstellung. Der Dienst verarbeitet möglicherweise noch — versuchen Sie, die Seite später zu aktualisieren.',
    noContent:
      'Noch kein Inhalt. Erstellen Sie den Bericht oder fügen Sie Text hinzu, um eine Vorschau zu sehen.',
    generationPromptLog: 'Generiert mit Prompt:',
  },
};

export default BUILDING_INSPECTION;
